// ============================================================================
// main.js — belépési pont. Ez az EGYETLEN modul, ami mind az állapotot,
// mind a nézetet, mind a hálózati modult ismeri; a többi modul egymást
// közvetlenül nem hívja.
// ============================================================================

import { log } from "./log.js";
import { prepareImage, kepValtozat, eredetiKellEz, uploadImage, uploadImageWithThumb, releaseImage, MAX_KEPEK } from "./imageUpload.js";
import { startUpdateWatcher, applyUpdate, beepitettVerzio, beepitettKiadas } from "./updater.js";
import { renderEnvBanner } from "./envBanner.js";
import { clearCachesOnVersionChange } from "./devCache.js";
import { ENV, IS_PROD } from "./env.js";
import {
  isSupported as notifSupported,
  shouldOfferNotifications,
  markOfferDismissed,
  enableNotifications,
  disableNotifications,
  pushAllapot,
  refreshToken as refreshPushToken,
  unregisterToken as unregisterPushToken,
  handleIncomingMessage,
  clearUnread,
  incrementUnread,
  kapUnreadCount,
} from "./notifications.js";
import { darabolasiKorlat, MAX_FORUM_TEXT_CODEPOINTS, splitMessage, labelPart } from "./messageSplit.js";
import { uritsdAKepeket } from "./kepBetolto.js";
import { hozzaferesAktiv, tagsagTiltja } from "./hozzaferes.js";
import { state, subscribe, setUiLang, confirmUiLang, setScreen, setUser, setAccess, setError, setLoginLoading, setChat, setOverlay, EGYMAS_MELLETT_KULCS } from "./state.js";

// ---------------------------------------------------------------------------
// Push-értesítésből induló betöltés: ha az app ZÁRVA volt, a service worker
// a "?room=<id>" query-paraméterrel nyitott új ablakot (lásd
// public/service-worker.js notificationclick - openWindow ág). Itt olvassuk
// ki EGYSZER, indításkor, majd azonnal eltávolítjuk az URL-ből (a
// history.replaceState nem tölt újra), hogy egy F5 már ne nyissa mindig
// ugyanazt a szobát, és a cím ne szivárogjon tovább (megosztás, előzmények).
//
// FONTOS: ez csak azt az esetet fedi, amikor az app nem futott (a service
// worker openWindow-t hívott). Ha egy MEGLÉVŐ ablak volt nyitva, a worker
// nem ide, hanem egy postMessage({type:"OPEN_ROOM"}) üzenetet küld - azt
// lentebb, a "serviceWorker" üzenetfigyelő kezeli.
let pendingRoomIdFromNotification = (() => {
  try {
    const params = new URLSearchParams(window.location.search);
    const roomId = params.get("room");
    if (roomId) {
      params.delete("room");
      const rest = params.toString();
      window.history.replaceState(null, "", window.location.pathname + (rest ? `?${rest}` : "") + window.location.hash);
    }
    return roomId;
  } catch (e) {
    return null;
  }
})();
import {
  frissitsdATokent,
  statuszosTemak,
  keresesiLap,
  watchAuthState,
  signInWithGoogle,
  signInWithGooglePopup,
  ujraHitelesites,
  consumeRedirectResult,
  signOut,
  getMyAccess,
  getMyProfile,
  saveProfile,
  suggestNameVariants,
  suggestRoomNames,
  sendMessage,
  adminAction,
  watchMyRooms,
  watchMyNotes,
  hideDeletedMarker,
  getHomeConfig,
  saveHomeConfig,
  presence,
  reportLandingIssue,
  landingUzenetek,
  memberAdmin,
  getMyMembershipCard,
  getMyNameHistory,
  applicationMine,
  applicationSave,
  applicationSubmit,
  applicationWithdraw,
  applicationAdmin,
  pollVote,
  watchMyAnnouncements,
  ackAnnouncement,
  announcementAdmin,
  sendNote,
  dismissNote,
  watchMessages,
  registerPushToken,
  getSendStatus,
  loadOlderMessages,
  UZENET_LAP,
  editMessage,
  retryTranslation,
  atiratJavitas,
  atiratModernizalas,
  forditasJavaslat,
  forditasJavaslatok,
  glossaryAction,
  watchTopics,
  forumAction,
  topicAction,
  convertTopicToRoom,
  deleteMessage,
  moveTopic,
  deleteTopic,
  adminTemak,
  javaslatosUzenetek,
  szobaTemai,
  offline,
  offlineAktival,
  offlineLeallit,
} from "./firebaseClient.js";
import { offlineSavInditasa } from "./offlineSav.js";
import { eloAblakFrissitese, regebbiLapHozzaadasa } from "./uzenetAblak.js";
import { olvasatlanSzobak, olvasottnakJelol, olvasottak } from "./olvasatlan.js";
import { nyissKeresot, zarjBeKeresot, felejtKeresest } from "./keresesView.js";
import { megjelenitendoCetlik } from "./noteData.js";
import { megjelenitendoKozlemenyek } from "./kozlemenyData.js";
import { nyissKozlemenyOlvasot, zarjBeKozlemenyOlvasot, kozlemenyOlvasoNyitva } from "./kozlemenyView.js";
import { nyissKezdolapot, zarjBeKezdolapot, kezdolapNyitva, mutassKezdolapSavot } from "./kezdolapView.js";
import { aktivMentese, aktivBetoltese, kezdolapKell, kezdolapSzobak, KEZDOLAP_ELOZMENY_KULCS } from "./kezdolap.js";
import {
  nyissCetliOlvasot, nyissCetliIrot, zarjBeCetliOlvasot, zarjBeCetliIrot, cetliOlvasoNyitva, cetliIroNyitva,
} from "./cetliView.js";
import { lapGyorsitotar } from "./kereso.js";
import { mentFuggo, frissitKesz, torolFuggo, torolFuggoSzobaban, olvasFuggo, helyreallitasTerv, vanFuggo } from "./pendingSend.js";
import { renderChatScreen, renderRoomSwitcher, feladoNev } from "./chatView.js";
import { getRoomDisplayName } from "./roomName.js";
import { renderAdminPanel, renderProfilePanel, onkentesSzobaSzerep } from "./adminView.js";
import { pdfE, elokeszitPdf } from "./pdfCsatolas.js";
import { visszaVedelem } from "./visszaVedelem.js";
import { utvonalBol, utvonalKeszit, hivatkozasKeszit } from "./utvonal.js";
import { renderMunkalista } from "./munkalistaView.js";
import { renderElbiralandok } from "./elbiralandokView.js";
import { KODOK, UJRAPROBA_HATAR, hibaKod, diagnosztikaSzoveg } from "./diagnostika.js";
import { vagolapraMasol } from "./vagolap.js";
import { alapSzuro } from "./munkalista.js";
import { renderHelpSheet, nyissSugot, zarjBeSugot, sugoNyitva } from "./helpView.js";
import { piszkozatMentese, piszkozatBetoltese, mindenTorlese, helyMentese, helyBetoltese, piszkozatokSzama, mindenFelhasznaloTorlese } from "./helyMentes.js";
import { felszabaditando, RETRY_MAX_VARAKOZAS_MS } from "./retryVarakozas.js";
import { pushAtvetel } from "./pushJelzo.js";
import { ELOZMENY_ID, temaLekeres, temaIrhato, legnagyobbSorszam, temaCim, cimekKuldesre, szuroCimkeValtas } from "./forumData.js";
import { renderGlossaryPanel, uresPiszkozat, piszkozatBejegyzesbol, bejegyzesPiszkozatbol } from "./szojegyzekView.js";
import { alapAtiratNyelv } from "./atiratView.js";
import { alapSorrend, testverCsoport } from "./roomTree.js";
import { hianyzoNevek, feladatLista, javaslatokKeszitese, mentesiTervek } from "./nevPotlas.js";
import { hatalyosMod, eszkozModIr, torlesAllapot, ESZKOZ_TORLES_ESEMENY } from "./eszkozMod.js";
import { hitelesitesValtozott, tarolotKer, elvesztesOlvas, tartosTarOlvas } from "./belepesEmlekezet.js";
import { renderLangSwitcher } from "./view.js";
import { renderJelentkezes } from "./jelentkezesView.js";
import { jt } from "./jelentkezesSzovegek.js";
import { reauthMentes, reauthKivesz, reauthTorol, reauthIndit, ALLAPOT_KULCSOK } from "./reauthFolytatas.js";
import { t, SUPPORTED_UI_LANGS, UI_LANG_NATIVE_NAMES, CHAT_LANGUAGES, ensureUiLang, onNyelvBetoltve } from "./i18n.js";
import {
  markRedirectStarted,
  clearRedirectMarker,
  redirectSilentlyFailed,
  shouldUsePopup,
  isAndroid,
  bejelentkezesiUt,
  rememberPopupNeeded,
  forgetPopupNeeded,
} from "./authFallback.js";
import {
  getInstallMode,
  triggerInstall,
  markDismissed,
  onInstallAvailabilityChange,
  isStandalone,
  isWebKit,
} from "./install.js";
import {
  applyDocumentLanguage,
  renderLangScreen,
  renderWelcomeScreen,
  renderBoundaryError,
  renderLoginScreen,
  renderAccessCheckingScreen,
  renderAccessPendingScreen,
  renderFatalError,
  renderInstallBanner,
} from "./view.js";

// ----------------------------------------------------------------------
// Hibakód és másolható hibakereső adatok (2026-10-19, a titkár #46 kérése; diagnostika.js)
// ----------------------------------------------------------------------
/** A nézeteknek átadott hibakereső állapot: a kód és a kézi újrapróbálások határa (null, ha nincs mit mutatni). */
function diagNezet() {
  return state.authDiag ? { kod: state.authDiag, hatarElerve: (state.accessProbak || 0) >= UJRAPROBA_HATAR } : null;
}

function diagAdat() {
  return {
    kod: state.authDiag,
    host: window.location.hostname,
    env: ENV.name === "prod" ? "normál (prod)" : "fejlesztési (dev)",
    kiadas: beepitettKiadas(),
    verzio: beepitettVerzio(),
    ut: useSignInPopup() ? "popup" : "redirect",
    telepitett: isStandalone(),
    ua: navigator.userAgent,
    online: navigator.onLine,
    nyelv: state.uiLang,
    ido: new Date(),
  };
}

/** A hibakereső adatok a vágólapra (jelszó, token, e-mail, azonosító, útvonal nélkül). A siker / hiba a nézetben jelenik meg. */
async function masoldAHibakeresoAdatokat() {
  await vagolapraMasol(diagnosztikaSzoveg(diagAdat()));
}

// ----------------------------------------------------------------------
// Render-elosztó: minden állapotváltozás után ez dönti el, melyik
// képernyő jelenjen meg.
// ----------------------------------------------------------------------
function renderTeljes() {
  const handlers = {
    // A kezdőképernyőn / a belépő képernyőn választott nyelv a CSEVEGÉS nyelve is lesz (lásd startChat).
    onSelectLang: (lang) => { state.uiLangValasztva = true; setUiLang(lang); },
    onContinue: handleContinueFromLang,
    onEnter: () => setScreen("login"),
    onBack: () => setScreen("lang"),
    onChangeLang: (lang) => { state.uiLangValasztva = true; setUiLang(lang); },
    onSignIn: handleSignIn,
    // Saját / közös eszköz (eszkozMod.js): a gyorsítótár-mód indításkor dől el, ezért a váltás újratölti a lapot.
    onDeviceMode: (mod) => {
      // Közös eszközre váltáskor a nem elküldött szövegek (piszkozat, félbemaradt küldés) törlődnek - előbb szólunk (titkár #65).
      if (mod === "kozos" && hatalyosMod() !== "kozos") {
        const n = piszkozatokSzama(tarolo()) + (vanFuggo() ? 1 : 0);
        if (n > 0) {
          if (!window.confirm(t(state.uiLang, "login.deviceDraftsConfirm", { n }))) { render(); return; } // a választó visszaáll a mostani módra
          mindenFelhasznaloTorlese(tarolo());
          torolFuggo();
        }
      }
      if (eszkozModIr(mod)) window.location.reload();
    },
    onDeviceRetry: () => window.location.reload(), // a törlés újrapróbálása: a jelzés megmarad, az indítás újra megpróbálja
    onSignOut: handleSignOut,
    onApply: () => jelentkezesMegnyitasa(),
    onRecheck: () => { state.accessProbak = (state.accessProbak || 0) + 1; checkAccess(state.user); },
    onCopyDiag: masoldAHibakeresoAdatokat,
    onRetry: () => window.location.reload(),
    onInstall: handleInstall,
    onDismissInstall: () => {
      markDismissed();
      render();
    },
  };

  const installMode = getInstallMode();
  applyDocumentLanguage(state.uiLang);

  // A screen az EGYETLEN igazságforrás arról, melyik képernyő látszik -
  // nincs többé külön, a switch-et megkerülő elágazás a nyelvválasztóra.
  // (Korábban két, egymástól függetlenül változó feltétel - uiLangChosen
  // és screen - döntött erről, és amikor ezek szétcsúsztak, a kód egy
  // nem kezelt állapotba futott, hibaképernyőt eredményezve.)
  switch (state.screen) {
    case "lang":
      renderLangScreen(state.uiLang, handlers);
      return;
    case "welcome":
      renderWelcomeScreen(state.uiLang, handlers);
      return;
    case "login":
      renderLoginScreen(
        state.uiLang,
        { errorKey: state.error?.key, loading: state.loginLoading, installMode, diag: diagNezet(), deviceMode: hatalyosMod(), deviceStatus: torlesAllapot(hatalyosMod()) },
        handlers
      );
      return;
    case "apply":
      // Önkéntes jelentkezés (v191): a nem tag is eléri; a nyelvválasztó a fejlécben (hu / en / ja szöveg, más nyelven angol).
      renderJelentkezes(document.getElementById("app"), {
        uiLang: state.uiLang, user: state.user, locale: state.uiLang, ...jelentkezes,
        nyelvvalaszto: renderLangSwitcher(state.uiLang, (lang) => { state.uiLangValasztva = true; setUiLang(lang); }),
      }, jelentkezesKezelok);
      return;
    case "access-checking":
      renderAccessCheckingScreen(state.uiLang, handlers, { lassu: state.accessLassu === true, diag: diagNezet() });
      return;
    case "access-pending":
      renderAccessPendingScreen(
        state.uiLang,
        { email: state.user?.email, uid: state.user?.uid, errorKey: state.error?.key, installMode, diag: diagNezet(), tagsagTiltja: state.access?.active === true && tagsagTiltja(state.access) },
        handlers
      );
      return;
    case "active":
      // Érintőképernyőn a böngésző "vissza" mozdulata ne dobjon ki az alkalmazásból (iPhone Safari, lásd visszaVedelem.js):
      // témából a témalistába lép vissza, egyébként a helyén marad. Csak egyszer indul el, bejelentkezés után.
      utvonalFigyeloIndit();
      if (!visszaVedelemLeallito) {
        visszaVedelemLeallito = visszaVedelem(window, {
          aktiv: () => state.screen === "active",
          // A "vissza" mozdulat előbb a nyitott súgót / átfedő panelt zárja be, csak utána lép témából a témalistára.
          vissza: () => {
            if (sugoNyitva()) { zarjBeSugot(); return; }
            if (state.overlay) { setOverlay(null); return; }
            if (state.currentRoomId && state.currentTopicId) openRoom(state.currentRoomId);
          },
        });
      }
      renderChatScreen(
        document.getElementById("app"),
        {
          uiLang: state.uiLang,
          contentLang: state.contentLang || state.uiLang,
          rooms: state.rooms,
          roomsLoaded: state.roomsLoaded === true,
          roomsMegerositetlen: state.roomsMegerositetlen === true || state.roomsHiba === true,
          currentRoomId: state.currentRoomId,
          messages: state.messages,
          messagesMegerositetlen: state.messagesMegerositetlen === true || state.messagesHiba === true,
          myUid: state.user?.uid,
          isAdmin: state.access?.role === "admin",
          // Témafelelős (2026-09-30): az admin panel rá is megnyílik, de
          // szűkített tartalommal (lásd adminView.js) - a rooms-figyelés
          // (startRoomsWatch, lentebb) VÁLTOZATLANUL csak a tényleges
          // tagságát mutatja, nem kap admin-szintű, összes-szobát-látó
          // Firestore-hozzáférést.
          isTopicLead: state.access?.role === "topic_lead",
          draft: state.draft,
          sending: state.sending,
          errorKey: state.chatErrorKey,
          errorText: state.chatErrorText,
          offerNotifications: state.offerNotifications,
          pendingImage: state.pendingImage,
          pendingFile: state.pendingFile || null,
          uploadProgress: state.uploadProgress,
          replyTo: state.replyTo,
          hasOlder: state.hasOlder,
          loadingOlder: state.loadingOlder,
          unreadRoomIds: state.unreadRoomIds || [],
          // Honnan folytatta: az első, a szoba megnyitásakor MÉG olvasatlan
          // üzenet - lásd openRoom() és olvasatlan.js. Csak addig él, amíg
          // a felhasználó el nem hagyja a szobát (nem tűnik el olvasás közben).
          firstUnreadMessageId: state.firstUnreadMessageId || null,
          // Üzenet szerkesztése (2026-10-02).
          editingMessageId: state.editingMessageId,
          editingText: state.editingText,
          editingBusy: state.editingBusy,
          editingErrorKey: state.editingErrorKey,
          editingErrorText: state.editingErrorText,
          showOriginalIds: state.showOriginalIds,
          egymasMellett: state.egymasMellett === true,
          retryBusyIds: state.retryBusyIds,
          szavazok: state.szavazok || {},
          fixEditor: state.fixEditor || null,
          fixList: state.fixList || null,
          atnevDraft: state.atnevDraft === undefined ? null : state.atnevDraft,
          atiratNyelv: state.atiratNyelv || null,
          atiratSzerk: state.atiratSzerk || null,
          modernAllapot: state.modernAllapot || null,
          noteCount: (state.notes || []).length,
          announcementCount: (state.announcements || []).length,
          // A belépési cél (hirdetmény) témájának fejléce (v157): a beállítás, az ajánlott tájékoztatók, és hogy magától nyílt-e meg
          homeLanding: state.homeLanding || null,
          homePinned: state.homePinned || [],
          bejaratAuto: state.bejaratAuto === true,
          bejaratZarva: state.bejaratZarva === true,
          bejaratBezarva: state.bejaratBezarva === true,
          // Fórum (2026-10-09) - lásd forumView.js és forumData.js.
          ...forumModell(),
          // A telepítési/iOS-értesítési sáv a bejelentkezés UTÁN, magában a
          // csevegésben is látszik - iPhone-on épp itt derül ki, hogy a
          // hangjelzéshez és az értesítésekhez telepíteni kell az appot.
          installBanner: renderInstallBanner(state.uiLang, installMode, handlers),
        },
        chatHandlers
      );
      renderOverlay();
      return;
    default:
      renderFatalError(state.uiLang, handlers);
  }
}

/**
 * A megjelenítés HIBAHATÁRA (2026-10-13): a képernyő rajzolása közben dobott kivétel nem hagyhat üres (fehér) oldalt -
 * hibaüzenet és újratöltés gomb látszik; nem éles környezetben a hiba szövege is.
 */
function hibaReszlet(err) {
  if (IS_PROD) return "";
  const szoveg = err && err.stack ? String(err.stack).split("\n").slice(0, 4).join("\n") : String((err && err.message) || err);
  return szoveg;
}
// Az átfedő lap (admin panel, profil stb.) görgetési helye és fókusza az ÚJRARAJZOLÁSON át (2026-10-20, v122; Tamás: "ha valahova kattintok és
// módosítok, a fókusz maradjon ott, ne ugorjon a megjelenítés tetejére"). A lap minden rendernél újraépül, ezért a görgetés alaphelyzetbe állt.
// Csak azonos lapnál (azonos "kulcs": melyik overlay, melyik admin-oldal) állítjuk vissza; oldalváltáskor a tetején kezdődik.
const LAP_FOKUSZALHATO = "input, select, textarea, button, summary, a[href]";
// A belső listák (pl. a szobatagok .panel-list listája, 260 px magas: ott kattint az admin) saját görgetése is megmarad.
function lapPillanatkep() {
  try {
    const lap = document.querySelector(".sheet");
    if (!lap || !state.overlay) return null;
    const fokusz = lap.contains(document.activeElement) ? [...lap.querySelectorAll(LAP_FOKUSZALHATO)].indexOf(document.activeElement) : -1;
    const gorgethetok = [lap, ...lap.querySelectorAll(".panel-list, .name-fill-list")];
    return {
      kulcs: `${state.overlay}|${panelState.adminMenu || ""}`,
      top: lap.scrollTop,
      belso: gorgethetok.map((e) => e.scrollTop),
      fokusz,
      db: lap.querySelectorAll(LAP_FOKUSZALHATO).length,
    };
  } catch (e) { return null; }
}
function lapVisszaallit(pillanatkep) {
  try {
    if (!pillanatkep || !state.overlay || pillanatkep.kulcs !== `${state.overlay}|${panelState.adminMenu || ""}`) return;
    const lap = document.querySelector(".sheet");
    if (!lap) return;
    lap.scrollTop = pillanatkep.top;
    // a belső listák görgetése (ugyanolyan szerkezetnél, sorrendben)
    const belsok = [...lap.querySelectorAll(".panel-list, .name-fill-list")];
    if (belsok.length === pillanatkep.belso.length - 1) belsok.forEach((e, i) => { e.scrollTop = pillanatkep.belso[i + 1]; });
    const elemek = [...lap.querySelectorAll(LAP_FOKUSZALHATO)];
    // A fókuszt csak akkor adjuk vissza, ha a lap szerkezete nem változott (különben rossz elemre kerülne); szövegmezőt nem vesz át (felugró billentyűzet).
    if (pillanatkep.fokusz >= 0 && elemek.length === pillanatkep.db) {
      const cel = elemek[pillanatkep.fokusz];
      if (cel && !cel.disabled && !(cel.tagName === "TEXTAREA" || (cel.tagName === "INPUT" && ["text", "search", "email", "url", "tel", "password", "number"].includes(cel.type)))) cel.focus({ preventScroll: true });
    }
  } catch (e) { /* a megjelenítés nem függ ettől */ }
}

function render() {
  const lapAllapot = lapPillanatkep();
  try {
    renderTeljes();
    lapVisszaallit(lapAllapot);
  } catch (err) {
    log.error("[render] a megjelenítés hibája:", err);
    try {
      renderBoundaryError(state.uiLang, { reszlet: hibaReszlet(err), onReload: () => window.location.reload() });
    } catch (err2) {
      const app = document.getElementById("app");
      if (app) app.textContent = "Error: " + ((err && err.message) || err);
    }
  }
}

// Fehér képernyő őr: egy elkapatlan hiba vagy elutasított ígéret után, ha az #app üres maradt, megjelenik a hibaüzenet.
function feherKepernyoOr(ok) {
  log.error("[hiba] elkapatlan:", ok);
  setTimeout(() => {
    const app = document.getElementById("app");
    if (app && app.children.length === 0) renderBoundaryError(state.uiLang, { reszlet: hibaReszlet(ok), onReload: () => window.location.reload() });
  }, 1500);
}
window.addEventListener("error", (e) => feherKepernyoOr(e && (e.error || e.message)));
window.addEventListener("unhandledrejection", (e) => feherKepernyoOr(e && e.reason));

/** A fórum mezői a chat-képernyő modelljébe. */
function forumModell() {
  const szoba = (state.rooms || []).find((r) => r && r.roomId === state.currentRoomId);
  const forum = Boolean(szoba && szoba.forum === true);
  if (!forum) return { forum: false };
  const aktTema = state.currentTopicId ? (state.topics || []).find((x) => x.topicId === state.currentTopicId) || null : null;
  const isAdmin = state.access?.role === "admin";
  const uid = state.user?.uid;
  return {
    forum: true,
    currentTopicId: state.currentTopicId || null,
    topics: state.topics,
    topicsMegerositetlen: state.topicsMegerositetlen === true || state.topicsHiba === true,
    aktTema,
    temaIrhato: state.currentTopicId ? temaIrhato(aktTema || { kind: state.currentTopicId === ELOZMENY_ID ? "history" : "discussion" }, { isAdmin }) : true,
    watching: Boolean(aktTema && uid && aktTema.watchers.includes(uid)),
    // Kezelés (2026-10-09): nyitó vagy admin / témafelelős; kitűzés és lezárás csak az utóbbié.
    staff: state.access?.role === "admin" || state.access?.role === "topic_lead",
    admin: state.access?.role === "admin",
    // Címek nyelvenként (admin): a nyelvek listája a nyelvek.json-ból (új nyelvvel automatikusan bővül).
    nyelvNevek: CHAT_LANGUAGES,
    titlesDraft: state.titlesDraft === undefined ? null : state.titlesDraft,
    titlesBusy: state.titlesBusy === true,
    titlesError: state.titlesError || null,
    titlesStatus: state.titlesStatus || null,
    // Státusz és címkék (2026-10-16, v77): a szoba katalógusa, a lista szűrője, a címkeválasztó és a katalógus-szerkesztő vázlata.
    tagCatalog: szoba.tagCatalog || [],
    // Hozzászólás-címkék (2026-10-16): ki jelölhet mást, a témán belüli szűrő és a nyitott választó vázlata.
    tagKezelo: Boolean(aktTema && uid && (aktTema.createdBy === uid || state.access?.role === "admin" || state.access?.role === "topic_lead")),
    postSzuro: state.postSzuro || [],
    postTagging: state.postTagging || null,
    postLinking: state.postLinking || null,
    postReviewing: state.postReviewing || null,
    temaMenu: state.temaMenu === true,
    sourceDraft: state.sourceDraft === undefined ? null : state.sourceDraft,
    wfPanel: state.wfPanel === undefined ? null : state.wfPanel,
    sourceBusy: state.sourceBusy === true,
    sourceError: state.sourceError || null,
    forumSzuro: state.forumSzuro || { workflow: "", tags: [] },
    tagsDraft: state.tagsDraft === undefined ? null : state.tagsDraft,
    tagsBusy: state.tagsBusy === true,
    tagsError: state.tagsError || null,
    katalogusDraft: state.katalogusDraft === undefined ? null : state.katalogusDraft,
    katalogusBusy: state.katalogusBusy === true,
    katalogusError: state.katalogusError || null,
    katalogusStatus: state.katalogusStatus || null,
    temaKezelhet: Boolean(aktTema && aktTema.kind !== "history" && uid && (aktTema.createdBy === uid || state.access?.role === "admin" || state.access?.role === "topic_lead")),
    roomMuted: Boolean(uid && Array.isArray(szoba.mutedBy) && szoba.mutedBy.includes(uid)),
    forumRead: state.forumRead || {},
    emailFrequency: state.emailFrequency || "off",
    ujTema: state.ujTema || null,
    ujTemaBusy: state.ujTemaBusy === true,
    ujTemaHiba: state.ujTemaHiba || null,
  };
}

// Újratöltés-álló szöveg és hely (2026-10-18, lásd helyMentes.js): a szöveg szobánként ÉS témánként a böngésző tárolójában él.
function tarolo() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
}
let piszkozatIdozito = null;
// v189: kijelentkezés közben a (kiürülő) memóriabeli szöveg NEM írhatja felül a már elmentett piszkozatot (a kijelentkezés a mezőt kiüríti, és a
// késleltetett mentés ilyenkor üres szöveggel törölte volna a tárolt piszkozatot).
let kilepesFolyamatban = false;
function piszkozatMentesenMost() {
  clearTimeout(piszkozatIdozito);
  piszkozatIdozito = null;
  if (kilepesFolyamatban) return;
  if (!state.user || !state.currentRoomId || state.screen !== "active") return;
  piszkozatMentese(tarolo(), state.user.uid, state.currentRoomId, state.currentTopicId, state.draft);
}
function piszkozatMentesenKesleltetve() {
  clearTimeout(piszkozatIdozito);
  piszkozatIdozito = setTimeout(piszkozatMentesenMost, 400);
}
// Az újratöltés / a lap elhagyása előtt azonnal mentünk (a késleltetett mentés ilyenkor nem érne rá lefutni).
window.addEventListener("pagehide", piszkozatMentesenMost);
document.addEventListener("visibilitychange", () => { if (document.hidden) piszkozatMentesenMost(); });
// A programból történő változás (küldés után ürül, szoba / téma váltás) is mentődik; a gépelést az onDraftChange jelzi.
// Megosztható hivatkozás (2026-10-18): a megnyitáskor a cím #/r/<szoba>/t/<téma>/m/<hozzászólás> alakú része - EGYSZER érvényesül (az első
// szobalista után), és csak olyan szobára, amelynek a tag tagja. Az értesítésből célzott szoba elsőbbséget élvez, a mentett hely a hivatkozás után jön.
// A bejelentkezés (Google-átirányítás) a címből a #-részt elhagyja: a belépés előtt megjegyzett útvonalra (szoba / téma) belépés után visszatérünk (titkár #65).
const BELEPES_UTAN_KULCS = "l0_belepesUtan";
function mentettBelepesUtan() {
  try {
    const h = window.sessionStorage.getItem(BELEPES_UTAN_KULCS);
    window.sessionStorage.removeItem(BELEPES_UTAN_KULCS);
    return h && /^#\/r\//.test(h) ? h : "";
  } catch (e) {
    return "";
  }
}
let bejovoUtvonal = utvonalBol(window.location.hash || mentettBelepesUtan());
let utvonalVisszaAllitas = false; // igaz, amíg a "vissza / előre" által kért hely nyílik meg (nem teszünk új előzménybejegyzést)
let visszaallitottTema = null; // az újratöltés után visszaállított téma (ha időközben megszűnt, a témalistára esünk vissza)
let visszaVedelemLeallito = null;
// A kért újrafordítások (azonosító -> { kezdet, lattFolyamatban }): a gomb a lezárulásig "folyamatban" marad.
const retryKerelmek = new Map();
function retryFeloldas(uzenetek) {
  if (retryKerelmek.size === 0) return;
  const ki = felszabaditando(retryKerelmek, uzenetek, Date.now());
  if (ki.length === 0) return;
  const kesz = new Set(state.retryBusyIds);
  for (const id of ki) { kesz.delete(id); retryKerelmek.delete(id); }
  setChat({ retryBusyIds: kesz });
}
subscribe(render);
subscribe(() => { if (state.screen === "active" && state.user) piszkozatMentesenKesleltetve(); });

// ----------------------------------------------------------------------
// ÖNKÉNTES JELENTKEZÉS (v191, a titkár leírása szerint; szerver: functions/src/applications.js; nézet: jelentkezesView.js)
// Közvetlenül megosztható cím: #/jelentkezes. A nem tag is eléri (elég a Google-belépés); a jelentkezés nem ad tagsági hozzáférést.
// A beírás nem rajzol újra (fókusz); a válaszok menet közben mentődnek (szerver) és ezen az eszközön is (megszakadt kapcsolat után folytatható).
// ----------------------------------------------------------------------
const JELENTKEZES_KULCS = "l0_jelentkezesUtan";
// A rövid cím: lineage0.com/apply (angol; Tamás: csak ez kell); a hosting az index.html-re írja át (firebase.json rewrites). A régi #/jelentkezes is működik.
const JELENTKEZES_ROVID_CIM = /^\/apply\/?$/;
function jelentkezesUtvonalKell() {
  try {
    return JELENTKEZES_ROVID_CIM.test(window.location.pathname) || /^#\/jelentkezes/.test(window.location.hash) || window.sessionStorage.getItem(JELENTKEZES_KULCS) === "1";
  } catch (e) {
    return /^#\/jelentkezes/.test(window.location.hash);
  }
}
let jelentkezesUtvonal = jelentkezesUtvonalKell();
if (jelentkezesUtvonal) state.screen = "apply"; // a közvetlen hivatkozás ne villantsa fel a nyelvválasztót
const jelentkezesKezdo = () => ({ betolt: false, hiba: false, app: null, vazlat: { answers: {}, roles: [], consent: {} }, lepes: "urlap", hiany: [], busy: false, kuldesHiba: false, valasz: "" });
let jelentkezes = jelentkezesKezdo();
const jelentkezesVaros = { answers: {}, roles: false, consent: {} }; // a szerverre még nem mentett változások
let jelentkezesIdozito = null;
let jelentkezesMentesFolyamatban = false;
const jelentkezesTarKulcs = (uid) => `l0_jelentkezesVazlat_${uid}`;

function jelentkezesHelyiMentes() {
  if (!state.user) return;
  try { window.localStorage.setItem(jelentkezesTarKulcs(state.user.uid), JSON.stringify({ ...jelentkezes.vazlat, at: Date.now() })); } catch (e) { /* nem kritikus */ }
}
function jelentkezesHelyiOlvas() {
  if (!state.user) return null;
  try {
    const v = JSON.parse(window.localStorage.getItem(jelentkezesTarKulcs(state.user.uid)) || "null");
    return v && typeof v === "object" ? v : null;
  } catch (e) {
    return null;
  }
}
function jelentkezesHelyiTorol() {
  if (!state.user) return;
  try { window.localStorage.removeItem(jelentkezesTarKulcs(state.user.uid)); } catch (e) { /* nem kritikus */ }
}
function jelentkezesMentesJelzes(kulcs) {
  const e = document.getElementById("apply-save-status");
  if (e) e.textContent = kulcs ? jt(state.uiLang, kulcs) : "";
}

/** A szerverre még nem mentett változások mentése; sikertelenségnél újrapróbál (a változások megmaradnak). */
async function jelentkezesMentese(teljes = false) {
  clearTimeout(jelentkezesIdozito);
  jelentkezesIdozito = null;
  if (!state.user) return false;
  if (jelentkezesMentesFolyamatban) {
    if (!teljes) return false;
    // a "Tovább" / "Beküldés" előtt megvárjuk a folyamatban lévő mentést (legfeljebb 15 mp-ig)
    for (let i = 0; i < 150 && jelentkezesMentesFolyamatban; i++) await new Promise((resolve) => setTimeout(resolve, 100));
    if (jelentkezesMentesFolyamatban) { jelentkezesMentesJelzes("saveFailed"); return false; }
  }
  if (teljes) {
    // A teljes vázlat felküldése: így az sem marad ki, ami sosem került a "várakozó" listára (pl. a Google-fiókból előtöltött név),
    // vagy aminek egy korábbi mentése sikertelen volt.
    const v = jelentkezes.vazlat;
    Object.assign(jelentkezesVaros.answers, v.answers || {});
    jelentkezesVaros.roles = true;
    for (const k of ["volunteer", "privacy"]) if (v.consent && typeof v.consent[k] === "boolean") jelentkezesVaros.consent[k] = v.consent[k];
  }
  const kuld = { answers: { ...jelentkezesVaros.answers }, roles: jelentkezesVaros.roles ? [...jelentkezes.vazlat.roles] : undefined, consent: { ...jelentkezesVaros.consent } };
  const vanValtozas = Object.keys(kuld.answers).length > 0 || kuld.roles !== undefined || Object.keys(kuld.consent).length > 0;
  if (!vanValtozas) return true;
  jelentkezesMentesFolyamatban = true;
  jelentkezesMentesJelzes("saving");
  try {
    await applicationSave({ answers: kuld.answers, ...(kuld.roles !== undefined ? { roles: kuld.roles } : {}), ...(Object.keys(kuld.consent).length ? { consent: kuld.consent } : {}) });
    // csak azt töröljük a "várakozó" listából, ami közben nem változott
    for (const [k, v] of Object.entries(kuld.answers)) if (jelentkezesVaros.answers[k] === v) delete jelentkezesVaros.answers[k];
    for (const [k, v] of Object.entries(kuld.consent)) if (jelentkezesVaros.consent[k] === v) delete jelentkezesVaros.consent[k];
    if (kuld.roles !== undefined && JSON.stringify(kuld.roles) === JSON.stringify(jelentkezes.vazlat.roles)) jelentkezesVaros.roles = false;
    jelentkezesMentesJelzes(Object.keys(jelentkezesVaros.answers).length || jelentkezesVaros.roles || Object.keys(jelentkezesVaros.consent).length ? "saving" : "saved");
    jelentkezesMentesFolyamatban = false;
    if (Object.keys(jelentkezesVaros.answers).length || jelentkezesVaros.roles || Object.keys(jelentkezesVaros.consent).length) jelentkezesMentesKesleltetve(400);
    return true;
  } catch (err) {
    log.error("[jelentkezés] a mentés nem sikerült:", err);
    jelentkezesMentesFolyamatban = false;
    jelentkezesMentesJelzes("saveFailed");
    // Zárolt (már beküldött) jelentkezés: az állapotot újra betöltjük; egyébként újrapróbál
    if (err && err.code === "functions/failed-precondition") { jelentkezesBetoltese(); return false; }
    // A szerver érvénytelennek tartja a válaszokat (pl. túl hosszú mező): az újrapróbálás ugyanazt kapná, ezért a hibát mutatjuk, nem hallgatunk
    if (err && err.code === "functions/invalid-argument") {
      const e = document.getElementById("apply-save-status");
      if (e) e.textContent = jt(state.uiLang, "saveInvalid") + " " + (err.message || "");
      return false;
    }
    jelentkezesMentesKesleltetve(6000);
    return false;
  }
}
function jelentkezesMentesKesleltetve(ms = 900) {
  clearTimeout(jelentkezesIdozito);
  jelentkezesIdozito = setTimeout(jelentkezesMentese, ms);
}

/** A kötelező mezők hiánya (a szerver ellenőrzésének tükre; a szerver dönt). */
function jelentkezesHiany() {
  const v = jelentkezes.vazlat;
  const a = v.answers || {};
  const hiany = [];
  for (const f of ["displayName", "language", "motivation", "experience", "hoursPerWeek", "reikiRelation"]) if (!(a[f] || "").trim()) hiany.push(f);
  if (!(a.country || "").trim() && !(a.timezone || "").trim()) hiany.push("country");
  const sz = v.roles || [];
  if (sz.length === 0) hiany.push("roles");
  if (sz.includes("tester") && !(a.device || "").trim()) hiany.push("device");
  if (sz.includes("admin") && !(a.adminExperience || "").trim() && !(a.adminTasks || "").trim()) hiany.push("adminExperience");
  if (!(v.consent && v.consent.volunteer === true)) hiany.push("consent.volunteer");
  if (!(v.consent && v.consent.privacy === true)) hiany.push("consent.privacy");
  return hiany;
}

async function jelentkezesBetoltese() {
  jelentkezes = { ...jelentkezesKezdo(), betolt: true };
  render();
  try {
    const s = await applicationMine();
    const helyi = jelentkezesHelyiOlvas();
    const vazlat = { answers: {}, roles: [], consent: {} };
    if (s && s.exists) {
      vazlat.answers = { ...(s.answers || {}) };
      vazlat.roles = Array.isArray(s.roles) ? [...s.roles] : [];
      vazlat.consent = { ...(s.consent || {}) };
    }
    // Megszakadt kapcsolat után: ha az eszközön frissebb vázlat van, az folytatódik (és a szerverre is felkerül)
    if ((!s || !s.exists || s.status === "draft") && helyi && typeof helyi.at === "number" && helyi.at > ((s && s.updatedAt) || 0)) {
      vazlat.answers = { ...vazlat.answers, ...(helyi.answers || {}) };
      if (Array.isArray(helyi.roles) && helyi.roles.length) vazlat.roles = [...helyi.roles];
      vazlat.consent = { ...vazlat.consent, ...(helyi.consent || {}) };
      Object.assign(jelentkezesVaros.answers, helyi.answers || {});
      if (Array.isArray(helyi.roles) && helyi.roles.length) jelentkezesVaros.roles = true;
      Object.assign(jelentkezesVaros.consent, helyi.consent || {});
    }
    if (!vazlat.answers.displayName && state.user && state.user.displayName) {
      vazlat.answers.displayName = state.user.displayName;
      jelentkezesVaros.answers.displayName = state.user.displayName; // az előtöltött nevet is el kell menteni (különben a szerveren hiányozna)
    }
    jelentkezes = { ...jelentkezesKezdo(), app: s && s.exists ? s : null, vazlat };
    render();
    if (Object.keys(jelentkezesVaros.answers).length || jelentkezesVaros.roles || Object.keys(jelentkezesVaros.consent).length) jelentkezesMentesKesleltetve(300);
  } catch (err) {
    log.error("[jelentkezés] a betöltés nem sikerült:", err);
    jelentkezes = { ...jelentkezesKezdo(), hiba: true };
    render();
  }
}

/** A jelentkezési oldal megnyitása az alkalmazásból (pl. a tagságra váró képernyőről). */
function jelentkezesMegnyitasa() {
  jelentkezesUtvonal = true;
  try { window.history.replaceState(window.history.state, "", "/apply"); } catch (e) { /* nem kritikus */ }
  setScreen("apply");
  if (state.user) jelentkezesBetoltese();
}

const jelentkezesKezelok = {
  onSignIn: () => handleSignIn(),
  onSignOut: () => handleSignOut(),
  onBackToApp: () => {
    jelentkezesUtvonal = false;
    try { window.sessionStorage.removeItem(JELENTKEZES_KULCS); } catch (e) { /* nem kritikus */ }
    // vissza az alkalmazás gyökerére (a rövid cím - /apply - útvonalát is elhagyjuk, különben az újratöltés ide térne vissza)
    try { window.history.replaceState(window.history.state, "", "/"); } catch (e) { /* nem kritikus */ }
    if (state.user) checkAccess(state.user); else setScreen("lang");
  },
  onRetryLoad: () => jelentkezesBetoltese(),
  onChange: (kulcs, ertek) => {
    jelentkezes.vazlat.answers[kulcs] = ertek;
    jelentkezesVaros.answers[kulcs] = ertek;
    jelentkezesHelyiMentes();
    jelentkezesMentesJelzes("saving");
    jelentkezesMentesKesleltetve();
  },
  onRoles: (szerep, be) => {
    const mostani = new Set(jelentkezes.vazlat.roles || []);
    if (be) mostani.add(szerep); else mostani.delete(szerep);
    jelentkezes.vazlat.roles = [...mostani];
    jelentkezesVaros.roles = true;
    jelentkezesHelyiMentes();
    jelentkezesMentesJelzes("saving");
    jelentkezesMentesKesleltetve();
  },
  onConsent: (kulcs, be) => {
    jelentkezes.vazlat.consent = { ...(jelentkezes.vazlat.consent || {}), [kulcs]: be };
    jelentkezesVaros.consent[kulcs] = be;
    jelentkezesHelyiMentes();
    jelentkezesMentesJelzes("saving");
    jelentkezesMentesKesleltetve();
  },
  onNext: async () => {
    // Ha a mentés nem sikerül, nem lépünk tovább: az átnézőlapon látszó adat és a szerveren lévő eltérne.
    if (!(await jelentkezesMentese(true))) return;
    jelentkezes = { ...jelentkezes, lepes: "attekintes", hiany: jelentkezesHiany(), kuldesHiba: false };
    render();
  },
  onBack: () => { jelentkezes = { ...jelentkezes, lepes: "urlap" }; render(); },
  onSubmit: async () => {
    if (jelentkezes.busy) return;
    jelentkezes = { ...jelentkezes, busy: true, kuldesHiba: false };
    render();
    try {
      // a beküldés előtt a legutóbbi válaszoknak a szerveren kell lenniük
      if (!(await jelentkezesMentese(true))) throw new Error("save-failed");
      const s = await applicationSubmit();
      jelentkezesHelyiTorol();
      jelentkezes = { ...jelentkezes, busy: false, app: s, lepes: "urlap" };
    } catch (err) {
      log.error("[jelentkezés] a beküldés nem sikerült:", err);
      const hianyok = err && err.details && Array.isArray(err.details.missing) ? err.details.missing : null;
      jelentkezes = { ...jelentkezes, busy: false, kuldesHiba: !hianyok, hiany: hianyok || jelentkezesHiany() };
    }
    render();
  },
  onReplyChange: (szoveg) => { jelentkezes.valasz = szoveg; },
  onReply: async () => {
    const szoveg = (jelentkezes.valasz || "").trim();
    if (!szoveg || jelentkezes.busy) return;
    jelentkezes = { ...jelentkezes, busy: true };
    render();
    try {
      const s = await applicationSave({ reply: szoveg });
      jelentkezes = { ...jelentkezes, busy: false, app: s, valasz: "" };
    } catch (err) {
      log.error("[jelentkezés] a válasz nem ment el:", err);
      jelentkezes = { ...jelentkezes, busy: false };
    }
    render();
  },
  onWithdraw: async (torles) => {
    if (jelentkezes.busy) return;
    jelentkezes = { ...jelentkezes, busy: true };
    render();
    try {
      const s = await applicationWithdraw(torles === true);
      if (torles === true) jelentkezesHelyiTorol();
      jelentkezes = { ...jelentkezes, busy: false, app: s };
    } catch (err) {
      log.error("[jelentkezés] a visszavonás nem sikerült:", err);
      jelentkezes = { ...jelentkezes, busy: false };
    }
    render();
  },
};

// ----------------------------------------------------------------------
// Bejelentkezés
// ----------------------------------------------------------------------
/**
 * Melyik bejelentkezési utat használjuk?
 *
 * FONTOS, VALÓS HIBÁBÓL TANULVA: iPhone-on Safariban a bejelentkezés nem
 * jött létre. Az ok a WebKit tárolás-szétválasztása (ITP): a
 * signInWithRedirect a visszatéréskor nem találja meg azt az átmeneti
 * állapotot, amit indulás előtt elmentett, és a folyamat CSENDBEN elbukik -
 * a felhasználó visszakerül a belépő képernyőre, hibaüzenet nélkül.
 *
 * A Firebase saját ajánlása szerint ilyen böngészőkben a felugró ablakos út
 * (signInWithPopup) a megbízható: az közvetlenül, a megnyitó lappal beszél,
 * nem függ attól a tárolási csatornától, amit a böngésző elvághat.
 *
 * A felugró ablak viszont TELEPÍTETT (kezdőképernyős) módban nem járható -
 * ott a rendszer nem nyit új ablakot -, ezért ott marad az átirányítás.
 * Ugyanez igaz minden nem-WebKit böngészőre (Chrome, Edge, Firefox
 * asztalon és Androidon), ahol az átirányítás eddig is jól működött.
 */
function useSignInPopup() {
  // A döntés tiszta függvény (authFallback.js bejelentkezesiUt): Androidon felugró ablak, mert az átirányítás
  // visszatérése ott más lapon / ablakban is megnyílhat, és az elmentett állapot hiányában elbukik ("missing initial
  // state"); telepített iPhone-os módban átirányítás; egyébként a korábbi szabályok.
  return bejelentkezesiUt({
    standalone: isStandalone(),
    android: isAndroid(),
    webkit: isWebKit(),
    popupKell: shouldUsePopup(),
  }) === "popup";
}

// A beragadt bejelentkezés kiszabadítása (2026-10-13): ha 30 mp után sincs bejelentkezett felhasználó (pl. a felugró Google-ablak
// üresen maradt, vagy az eredmény nem tért vissza), a gomb újra használható, és érthető üzenet jelenik meg - nem marad
// örökké "Átirányítás Google-hoz...".
let loginFeloldoIdozito = null;
function loginFeloldoInditasa() {
  clearTimeout(loginFeloldoIdozito);
  loginFeloldoIdozito = setTimeout(() => {
    if (state.loginLoading && !state.user && state.screen === "login") {
      setLoginLoading(false);
      state.authDiag = hibaKod(KODOK.LOGIN_STUCK);
      setError("login.errorStuck");
    }
  }, 30000);
}

async function handleSignIn() {
  state.authDiag = null; // új próba: a korábbi kód elavult
  try { if (/^#\/r\//.test(window.location.hash)) window.sessionStorage.setItem(BELEPES_UTAN_KULCS, window.location.hash); } catch (e) { /* nem kritikus */ }
  // A jelentkezési oldalról indított belépés (a Google-átirányítás a címből a #-részt elhagyja): belépés után a jelentkezési oldalra térünk vissza (v191).
  try { if (jelentkezesUtvonal) window.sessionStorage.setItem(JELENTKEZES_KULCS, "1"); } catch (e) { /* nem kritikus */ }
  setError(null);
  setLoginLoading(true); // enélkül a "Átirányítás Google-hoz..." visszajelzés sosem jelent meg
  loginFeloldoInditasa();

  if (useSignInPopup()) {
    try {
      await signInWithGooglePopup();
      // Siker esetén az onAuthStateChanged viszi tovább a folyamatot.
      clearRedirectMarker();
      return;
    } catch (err) {
      const kod = String(err?.code || "");
      log.error("[auth] felugró bejelentkezés hiba:", kod || err);

      // A felhasználó maga zárta be az ablakot vagy szakította meg: ez nem
      // hiba, csak meggondolta magát - ne dobjunk rá hibaüzenetet.
      if (kod === "auth/popup-closed-by-user" || kod === "auth/cancelled-popup-request") {
        setLoginLoading(false);
        return;
      }

      // Ha a böngésző letiltotta a felugró ablakot, marad az átirányítás.
      // Minden más hibánál is megpróbáljuk - rosszabb nem lehet tőle.
      log.debug("[auth] visszaesés átirányításos bejelentkezésre");
      // A felugró ablak nem járható ezen az eszközön - ne erőltessük
      // legközelebb sem.
      forgetPopupNeeded();
    }
  }

  try {
    // Jelet teszünk le: ha visszatéréskor nincs bejelentkezett
    // felhasználó, ebből tudjuk, hogy az átirányítás némán elbukott.
    markRedirectStarted();
    await signInWithGoogle();
    // A redirect elviszi az oldalt Google-hoz - ide innentől nem tér
    // vissza a vezérlés, amíg a böngésző vissza nem navigál.
  } catch (err) {
    log.error("[auth] signInWithGoogle hiba:", err);
    setLoginLoading(false);
    state.authDiag = hibaKod(KODOK.LOGIN_FAILED, err && err.code);
    setError("login.errorFailed");
  }
}

// A nyelvválasztó "Tovább" gombja. Ha a felhasználó közben már
// bejelentkezett (pl. korábbi munkamenetből megmaradt a bejelentkezés),
// rögtön a jogosultság-ellenőrzésre lépünk, nem a belépő képernyőre.
function handleContinueFromLang() {
  confirmUiLang();
  if (state.user) {
    // A képernyő még "lang": a checkAccess ezen az ágon szándékosan nem dolgozik (nem rántja el a nyelvválasztót), ezért előbb
    // továbblépünk. Enélkül a már bejelentkezett tag a "Tovább" után a nyelvválasztón ragadt volna (a folyamat-szimulátor találta, v139).
    setScreen("access-checking");
    checkAccess(state.user);
  }
}

async function handleInstall() {
  await triggerInstall();
  render(); // a sáv eltűnik, ha a telepítés megtörtént vagy elutasították
}

/**
 * Kijelentkezés. v189 (a titkár #18 / #20 fő kérése, M4ph14 #17): a lejárt bejelentkezés után a tag kijelentkezik és újra belép - a megírt szöveg
 * eddig ilyenkor ELVESZETT (a kijelentkezés minden mentett piszkozatot törölt). Most a kijelentkezés ELŐTT a mostani szöveg elmentődik, és SAJÁT
 * eszközön a tag piszkozatai megmaradnak (felhasználónként külön kulccsal, 24 óráig élnek): ugyanazzal a fiókkal belépve a szöveg visszatér.
 * KÖZÖS eszközön minden törlődik (mint eddig).
 */
async function handleSignOut() {
  piszkozatMentesenMost();
  kilepesFolyamatban = true;
  try {
    await handleSignOutBelso();
  } finally {
    kilepesFolyamatban = false;
  }
}

async function handleSignOutBelso() {
  // A nyitott keresőablak az előző felhasználó üzeneteit mutatná (2026-10-04).
  zarjBeKeresot();
  felejtKeresest(); // a megőrzött találatok és a "Vissza" sáv sem maradhat meg
  zarjBeSugot();
  // Kijelentkezés: a szerver rögzíti a kijelentkezés idejét (a kezdőlap 1 órás döntésének kiindulópontja); időkorláttal, hiba nem akadályoz.
  if (state.user) await idokorlattal(presence("logout", eszkozAzonosito()), 3000);
  // Közös eszköz: az előző tag mentett szövegei és helye ne maradjanak meg (helyMentes.js).
  // SAJÁT eszközön a tag piszkozatai és a legutóbbi helye (szoba- és témaazonosító) megmaradnak (v189): a kezdőlap "Visszatérés az előzőleg
  // megtekintett helyre" gombjának a hely kell, a lejárt bejelentkezés utáni újra belépésnek a megírt szöveg. A kulcsok felhasználónként külön
  // állnak, ezért egy másik fiók nem látja őket.
  if (state.user && hatalyosMod() !== "sajat") mindenTorlese(tarolo(), state.user.uid);
  await offlineLeallit().catch(() => {}); // a felhasználó MINDEN offline adata és a kezelő is leáll (közös eszközön a következő belépő ne lássa)
  bejovoUtvonal = null;
  try { window.sessionStorage.removeItem(BELEPES_UTAN_KULCS); } catch (e) { /* nem kritikus */ }
  try { if (window.location.hash) window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search); } catch (e) { /* nem kritikus */ }
  clearTimeout(piszkozatIdozito);
  piszkozatIdozito = null;
  // A token eltávolítása: enélkül a következő felhasználó ugyanazon az
  // eszközön a korábbi tag értesítéseit is megkapná.
  // A betöltött képek az ELŐZŐ felhasználóhoz tartoztak - a blob-címeket
  // elengedjük, hogy a következő belépő ne férhessen hozzájuk, és a
  // memória se maradjon lefoglalva.
  uritsdAKepeket();
  await unregisterPushToken(registerPushToken).catch(() => {});
  // A félbemaradt küldés feljegyzése a kijelentkezett felhasználó szövegét
  // tartalmazza - egy közös eszközön a következő tag nem láthatja.
  torolFuggo();
  helyreallitasLefutott = false;
  // A szobánként félretett piszkozatok és képek sem maradhatnak meg a
  // következő felhasználónak.
  for (const a of szobaAllapotok.values()) if (a.pendingImage) releaseImage(a.pendingImage);
  szobaAllapotok.clear();
  state.pendingSendId = null;
  state.ujraprobalhato = false;
  // A szobát is elengedjük: enélkül egy újabb belépésnél (ugyanaz vagy más
  // felhasználó, ugyanabban a munkamenetben) a szobalista "a jelenlegi
  // szoba még megvan" ágra futott, nem nyitotta meg újra, és az
  // üzenetfigyelő kikapcsolva maradt - üres vagy elavult lista.
  setChat({
    draft: "", pendingImage: null, replyTo: null, currentRoomId: null, messages: [],
    hasOlder: false, loadingOlder: false, unreadRoomIds: [], firstUnreadMessageId: null,
    showOriginalIds: new Set(), retryBusyIds: new Set(), notes: [], szavazok: {}, announcements: [], fixEditor: null, fixList: null, atiratNyelv: null, atiratSzerk: null,
    // Fórum (2026-10-09): kijelentkezéskor a fórum-állapot is törlődik.
    currentTopicId: null, topics: null, forumRead: {}, forumAllapotBetoltve: false, emailFrequency: "off", ujTema: null, ujTemaBusy: false, ujTemaHiba: null, titlesDraft: null, atnevDraft: null, titlesBusy: false, titlesError: null, titlesStatus: null, forumSzuro: { workflow: "", tags: [] }, postSzuro: [], postTagging: null, postLinking: null, postReviewing: null, temaMenu: false, sourceDraft: null, sourceBusy: false, sourceError: null, wfPanel: null, tagsDraft: null, tagsBusy: false, tagsError: null, katalogusDraft: null, katalogusBusy: false, katalogusError: null, katalogusStatus: null,
  });
  regebbiUzenetek = [];
  eloAblak = [];
  lapozasSzoba = null;
  if (roomsUnsub) { roomsUnsub(); roomsUnsub = null; }
  if (messagesUnsub) { messagesUnsub(); messagesUnsub = null; }
  // Fórum (2026-10-09): a témafigyelő és az olvasottság-időzítő is leáll; az állapot nem szivárog át.
  if (topicsUnsub) { topicsUnsub(); topicsUnsub = null; }
  clearTimeout(olvasottIdozito);
  aktLekeres = null;
  // A cetlik a kijelentkezett tagé: a figyelő leáll, a felugró ablakok bezárulnak, a "látott" lista
  // és a memóriában lévő szövegek törlődnek - a következő belépő semmit nem láthat belőlük (2026-10-07).
  aktivRogzites(); // a kijelentkezés pillanata is "utolsó aktivitás": a következő belépésnél ebből dől el, kell-e a kezdőlap
  if (aktivIdozito) { clearInterval(aktivIdozito); aktivIdozito = null; }
  kezdolapBelepeskor = false;
  zarjBeKezdolapot();
  try { window.sessionStorage.removeItem(KEZDOLAP_ELOZMENY_KULCS); } catch (e) { /* nem kritikus */ }
  if (annUnsub) { annUnsub(); annUnsub = null; }
  zarjBeKozlemenyOlvasot();
  latottKozlemenyek.clear();
  panelState.kozlemeny = null;
  panelState.kozlemenyek = null;
  if (notesUnsub) { notesUnsub(); notesUnsub = null; }
  zarjBeCetliOlvasot();
  zarjBeCetliIrot();
  latottCetlik.clear();
  await signOut();
  setUser(null);
  setAccess(null);
  jelentkezes = jelentkezesKezdo(); // a kijelentkezett jelentkező adata ne maradjon a memóriában (v191)
  setScreen(jelentkezesUtvonal ? "apply" : "lang"); // kijelentkezés után a kezdőképernyő (2026-10-13); a jelentkezési oldalról a jelentkezési bemutató
}


// ===========================================================================
// CSEVEGÉS
// ===========================================================================

let roomsUnsub = null;
let messagesUnsub = null;
// Fórum (2026-10-09): a szoba témáinak figyelője, az aktuális téma lekérdezése, az olvasottság-jelölés időzítője.
let topicsUnsub = null;
let aktLekeres = null;
let olvasottIdozito = null;

// A panelek saját, átmeneti állapota (nem tartozik a fő állapotgéphez).
// ----------------------------------------------------------------------------
// KÖZÖS SZÓJEGYZÉK (2026-10-08, tagi kérésre) - a panel állapota és kezelői.
// A szerver ellenőriz, verzióz és naplóz (functions/src/glossary.js); itt csak megjelenítés.
// ----------------------------------------------------------------------------
const SZOJEGYZEK_KEZDO = { data: null, betolt: false, hibaKulcs: null, hibaSzoveg: null, statusz: null, kereses: "", piszkozat: null, busy: false, tortenet: null };
let szojegyzekAllapot = { ...SZOJEGYZEK_KEZDO };

async function szojegyzekBetoltes({ megtartPiszkozat = false } = {}) {
  szojegyzekAllapot = { ...szojegyzekAllapot, betolt: true };
  render();
  try {
    const data = await glossaryAction("get");
    szojegyzekAllapot = { ...szojegyzekAllapot, data, betolt: false, piszkozat: megtartPiszkozat ? szojegyzekAllapot.piszkozat : null };
  } catch (err) {
    log.error("[szójegyzék] betöltés hiba:", err);
    szojegyzekAllapot = { ...szojegyzekAllapot, betolt: false, hibaKulcs: "glossary.loadFailed" };
  }
  render();
}

/** A szerver érthető (magyar) ellenőrzési üzenete, vagy null - ilyenkor az általános hibaszöveg jön. */
function szojegyzekHibaSzoveg(err) {
  const kod = err && err.code;
  if (kod === "functions/invalid-argument" || kod === "functions/failed-precondition" || kod === "functions/not-found" || kod === "functions/resource-exhausted" || kod === "functions/permission-denied") {
    return (err && err.message) || null;
  }
  return null;
}

const glossaryHandlers = {
  onClose: () => {
    szojegyzekAllapot = { ...SZOJEGYZEK_KEZDO };
    setOverlay(null);
  },
  // A keresés a nézetben, helyben szűr (nincs újrarajzolás - a beviteli mező fókusza megmarad); itt csak megjegyezzük.
  onSearch: (q) => { szojegyzekAllapot.kereses = q; },
  onNew: () => {
    szojegyzekAllapot = { ...szojegyzekAllapot, piszkozat: uresPiszkozat(), statusz: null, hibaKulcs: null, hibaSzoveg: null };
    render();
  },
  onEdit: (entry) => {
    szojegyzekAllapot = { ...szojegyzekAllapot, piszkozat: piszkozatBejegyzesbol(entry), statusz: null, hibaKulcs: null, hibaSzoveg: null };
    render();
  },
  // A mezők gépelés közben NEM rajzolnak újra (a fókusz és a kurzor a helyén marad).
  onDraftChange: (mezo, ertek) => { if (szojegyzekAllapot.piszkozat) szojegyzekAllapot.piszkozat[mezo] = ertek; },
  onDraftTranslation: (kod, ertek) => {
    if (szojegyzekAllapot.piszkozat) szojegyzekAllapot.piszkozat.translations = { ...szojegyzekAllapot.piszkozat.translations, [kod]: ertek };
  },
  onCancelDraft: () => {
    szojegyzekAllapot = { ...szojegyzekAllapot, piszkozat: null, hibaKulcs: null, hibaSzoveg: null };
    render();
  },
  onSave: async () => {
    const a = szojegyzekAllapot;
    if (!a.piszkozat || !a.data || a.busy) return;
    szojegyzekAllapot = { ...a, busy: true, hibaKulcs: null, hibaSzoveg: null, statusz: null };
    render();
    try {
      const res = await glossaryAction("upsert", { entry: bejegyzesPiszkozatbol(a.piszkozat), baseVersion: a.data.version });
      szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, piszkozat: null, tortenet: null, statusz: t(state.uiLang, "glossary.saved", { n: res.version }) };
      await szojegyzekBetoltes();
      return;
    } catch (err) {
      log.error("[szójegyzék] mentés hiba:", err);
      if (err && err.code === "functions/aborted") {
        // Közben más mentett: friss változat, a piszkozat MEGMARAD - átnézés után újra menthető.
        szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, hibaKulcs: "glossary.conflict" };
        await szojegyzekBetoltes({ megtartPiszkozat: true });
        return;
      }
      const szoveg = szojegyzekHibaSzoveg(err);
      szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, hibaSzoveg: szoveg, hibaKulcs: szoveg ? null : "glossary.failed" };
    }
    render();
  },
  onDelete: async (entry) => {
    const a = szojegyzekAllapot;
    if (!a.data || a.busy || !entry) return;
    if (!window.confirm(t(state.uiLang, "glossary.deleteConfirm", { label: entry.label }))) return;
    szojegyzekAllapot = { ...a, busy: true, hibaKulcs: null, hibaSzoveg: null, statusz: null };
    render();
    try {
      const res = await glossaryAction("delete", { id: entry.id, baseVersion: a.data.version });
      szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, tortenet: null, statusz: t(state.uiLang, "glossary.deleted", { n: res.version }) };
      await szojegyzekBetoltes();
      return;
    } catch (err) {
      log.error("[szójegyzék] törlés hiba:", err);
      if (err && err.code === "functions/aborted") {
        szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, hibaKulcs: "glossary.conflict" };
        await szojegyzekBetoltes();
        return;
      }
      const szoveg = szojegyzekHibaSzoveg(err);
      szojegyzekAllapot = { ...szojegyzekAllapot, busy: false, hibaSzoveg: szoveg, hibaKulcs: szoveg ? null : "glossary.failed" };
    }
    render();
  },
  onToggleHistory: async () => {
    if (Array.isArray(szojegyzekAllapot.tortenet)) {
      szojegyzekAllapot = { ...szojegyzekAllapot, tortenet: null };
      render();
      return;
    }
    try {
      const res = await glossaryAction("history", { limit: 30 });
      szojegyzekAllapot = { ...szojegyzekAllapot, tortenet: res.items || [] };
    } catch (err) {
      log.error("[szójegyzék] változásnapló hiba:", err);
      szojegyzekAllapot = { ...szojegyzekAllapot, hibaKulcs: "glossary.loadFailed" };
    }
    render();
  },
};

let panelState = {
  newUserEmail: "",
  newUserName: "",
  newRoomName: "",
  localizedNewRoomNames: {},
  // Beágyazott szobák (2026-09-28): az új/szerkesztett szoba szülője
  // (kategóriája) - null a főszobát jelenti.
  newRoomParentId: null,
  // Csak olvasható szoba (2026-10-08): az új szoba jelölője (csak adminnak látszik).
  newRoomReadOnly: false,
  selectedRoomId: null,
  editingRoomId: null,        // épp átnevezés alatt álló szoba
  editName: "",
  editLocalizedNames: {},
  editParentRoomId: null,
  users: null,
  // Az ÖSSZES szoba (2026-09-29), nem csak amiknek maga az admin a tagja -
  // enélkül az admin nem tudna kezelni (átnevezni, tagot fel-/levenni) olyan
  // szobát, amelynek maga nem tagja. Az adminAction "listRooms" tölti fel.
  allRooms: null,
  // A hívó egyike-e a két fix adminisztrátornak (a szerver mondja meg).
  callerIsRoot: false,
  // Gemini-költség összesítő (adminAction "usageSummary"):
  // null = töltődik, false = nem sikerült, objektum = megvan.
  usage: null,
  // Az admin panel épp megnyitott almenüje (null = főmenü).
  nevPotlas: null,
  adminMenu: null,
  // "Témák kezelése" (2026-10-19): a kiválasztott szoba, a témái (null = töltődik), és az épp szerkesztett téma { topicId, mode: "rename"|"move", value, target }.
  // "Közlemények" (2026-10-25): az űrlap { text, audience, uids[], roomId, days, valasz, hiba } és az elküldöttek listája (null = töltődik).
  kozlemeny: null,
  kozlemenyek: null,
  homeRoomIds: null, // "Kezdőlap" (2026-10-25): a kijelölt szobák (null = töltődik)
  homeStatus: null,
  homeLanding: null, // a belépési cél { roomId, topicId } vagy null (= a kezdőlap)
  homeLandingTopics: null,
  homeLandingIssueAt: null,
  homePinned: [], // az ajánlott tájékoztatók (hozzászólás-azonosítók, legfeljebb 3)
  homeLandingMessages: null, // a belépési cél témájának kiválasztható hozzászólásai
  homeLandingMessagesHiba: false, // a lekérés sikertelen volt (nem "0 hozzászólás")
  adminTopicsRoomId: null,
  adminTopics: null,
  adminTopicEdit: null,
  adminTopicsCursor: null, // az utolsó betöltött téma (a következő laphoz)
  adminTopicsMore: false, // lehet-e még téma a szobában
  busy: false,
  statusKey: null,
  errorKey: null,
  profileName: "",
  profileNameLatn: "",
  profileNameJa: "",
  profileNameZh: "",
  profileNameKo: "",
  profileNameCyr: "",
  profileNameEl: "",
  profileLang: null,
  suggesting: false,
};

/** Egyedi azonosító egy küldési szándékhoz (UUID v4). */
/** Firestore Timestamp -> ms, tartalék nélkül 0 (soha nem "olvasatlan"). */
function idopontMs(ts) {
  if (ts && typeof ts.toMillis === "function") return ts.toMillis();
  return typeof ts === "number" ? ts : 0;
}

function newClientMessageId() {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  // Tartalék régebbi böngészőkhöz.
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * A '#' rövidítés feldolgozása (SPECIFICATION.md 7.):
 *   "#szöveg"  -> fordítás nélkül
 *   "##szöveg" -> szó szerinti vezető '#'
 * Csak a legelső karakter számít.
 */
function applyHashShortcut(raw) {
  if (raw.startsWith("##")) return { text: raw.slice(1), noTranslate: false };
  if (raw.startsWith("#")) return { text: raw.slice(1), noTranslate: true };
  return { text: raw, noTranslate: false };
}

/** A csevegés indítása a sikeres jogosultság-ellenőrzés után. */
async function startChat() {
  try {
    const profile = await getMyProfile(state.user.uid);

    // A csevegési nyelvek a programba épített listából jönnek (nyelvek.json →
    // ui-strings.js), ugyanabból, amiből a szerver dolgozik - nincs külön
    // adatbázis-olvasás, és a kettő nem térhet el egymástól.
    const labels = { ...CHAT_LANGUAGES };
    const codes = Object.keys(labels);

    // A tartalomnyelv a profilból jön; ha ott nincs vagy már nem érvényes,
    // a felület nyelvét próbáljuk, végül az első elérhetőt.
    const profilNyelv = profile && profile.preferredLang;
    let contentLang = profilNyelv;
    // A kezdőképernyőn (vagy a belépő képernyőn) EZEN a látogatáson választott felületi nyelv egyben a CSEVEGÉS
    // (kommunikáció) nyelve is (2026-10-13, tagi kérés) - felülírja a korábban mentett csevegési nyelvet, és el is
    // mentődik. Ha nem választott, a profil nyelve él; az újaknál (nincs profilnyelv) a felület nyelve.
    if (state.uiLangValasztva && labels[state.uiLang]) contentLang = state.uiLang;
    state.uiLangValasztva = false;
    if (!contentLang || !labels[contentLang]) {
      contentLang = labels[state.uiLang] ? state.uiLang : codes[0] || null;
    }

    // A mentett csevegési nyelv a FELIRATOK nyelvét is beállítja - a
    // felhasználónak egy nyelve van, nem kettő.
    if (labels[contentLang] && contentLang !== state.uiLang) {
      setUiLang(contentLang);
    }

    setChat({
      contentLangs: labels,
      contentLang,
      profileName: (profile && profile.name) || state.user.displayName || "",
      profileNameLatn: (profile && profile.nameLatn) || "",
      profileNameJa: (profile && profile.nameJa) || "",
      profileNameZh: (profile && profile.nameZh) || "",
      profileNameKo: (profile && profile.nameKo) || "",
      profileNameCyr: (profile && profile.nameCyr) || "",
      profileNameEl: (profile && profile.nameEl) || "",
      // Ha nincs beállítva egyetlen csevegési nyelv sem, a küldés úgyis
      // elbukna a szerveren - jobb ezt előre, érthetően jelezni.
      chatErrorKey: codes.length === 0 ? "profile.noLanguages" : null,
    });

    // A csevegés nyelvének mentése (2026-10-13): új tagnál (nincs profilnyelv) vagy ha a kezdőképernyőn mást választott -
    // enélkül a szoba nyelvei (a tagok mentett nyelvéből) nem tartalmaznák az övét, és nem fordulna le neki semmi.
    // Nem blokkol és nem kritikus: hiba esetén a Profil panelen kézzel is beállítható. Név nélkül nem mentünk (a szerver kéri).
    const mentesiNev = (profile && profile.name) || state.user.displayName || "";
    if (labels[contentLang] && contentLang !== profilNyelv && mentesiNev) {
      saveProfile({ name: mentesiNev, preferredLang: contentLang, lastRoomId: (profile && profile.lastRoomId) || null })
        .catch((err) => log.error("[profil] a csevegési nyelv mentése nem sikerült:", err));
    }

    // Felajánljuk az értesítést, ha a böngésző támogatja és a
    // felhasználó még nem döntött róla.
    setChat({ offerNotifications: shouldOfferNotifications() });

    await kezdolapElokeszites();
    startRoomsWatch();
    startNotesWatch();
    startAnnouncementsWatch();
    // Belépés = átvétel (2026-10-13): az ikon jelvénye törlődik, és ha várt értesítés, a szerver is megtudja.
    pushAtveteleHaKell();

    // Ha már van engedély, frissítjük az eszköztokent: a token
    // megváltozhat, és egy elavultra küldött értesítés elveszne.
    if (notifSupported() && Notification.permission === "granted") {
      refreshPushToken(registerPushToken, { uid: state.user && state.user.uid }).catch(() => {});
    }
  } catch (err) {
    log.error("[chat] indítás hiba:", err);
    setChat({ chatErrorKey: "admin.loadFailed" });
  }
}

let helyreallitasLefutott = false;

/**
 * Az újratöltés (vagy az alkalmazás leállítása) miatt félbemaradt küldés
 * helyreállítása - lásd pendingSend.js. A szervertől megkérdezzük, mi
 * érkezett meg; ami nem, az visszakerül a beviteli mezőbe.
 *
 * SOHA nem küld automatikusan: a felhasználó látja a visszatett szöveget,
 * és ő dönt. Egy újratöltés után nem tudhatjuk, mit akar még.
 */
async function helyreallitFuggoKuldest(elerhetoSzobak) {
  const rec = olvasFuggo(state.user && state.user.uid);
  if (!rec) return;

  if (!elerhetoSzobak.some((r) => r.roomId === rec.roomId)) {
    torolFuggo();
    return;
  }

  let terv;
  try {
    terv = await helyreallitasTerv(rec, getSendStatus);
  } catch (err) {
    // Hálózati hiba: a feljegyzés marad, a következő indításkor újra.
    log.debug("[chat] a küldés állapota most nem kérdezhető le:", err);
    return;
  }

  if (terv.teendo !== "visszaallit") {
    // Minden megérkezett, vagy a szoba már nem elérhető.
    torolFuggo();
    return;
  }

  // Közben már küld valamit: nem avatkozunk bele. A feljegyzés marad.
  if (state.sending) return;

  // A feljegyzés szobája nyílik meg (a mostani szoba piszkozata félre-
  // kerül, nem vész el - szobánkénti állapot).
  if (state.currentRoomId !== rec.roomId) openRoom(rec.roomId);

  // Abban a szobában már van piszkozat vagy kép: nem írjuk felül.
  if ((state.draft || "").trim() || state.pendingImage || state.pendingFile) return;

  if (terv.pendingSendId) {
    // UGYANAZ az azonosító és UGYANAZOK a darab-azonosítók: ha a szerver
    // időközben mégis megkapta volna, az újraküldés nem hoz létre másodikat.
    darabIdCache.set(`${terv.pendingSendId}:${terv.darabIds.length}`, terv.darabIds);
    state.pendingSendId = terv.pendingSendId;
  } else {
    state.pendingSendId = null;
    torolFuggo();
  }
  setChat({ draft: terv.draft, chatErrorKey: "chat.sendRestored" });
}

// ---------------------------------------------------------------------------
// CETLI (2026-10-07, tagi kérésre): rövid, privát, eldobható üzenet. A címzett az
// alkalmazásban felugró cetlit kap; elolvassa, és eldobja (végleges törlés). Legfeljebb 5 él.
// Szerveroldal: functions/src/notes.js; felület: cetliView.js; adat: noteData.js.
// ---------------------------------------------------------------------------
let notesUnsub = null;
// Melyik cetlit mutattuk már fel ebben a munkamenetben: csak az ÚJ cetli nyitja ki magától a
// felugró ablakot; a már látott, de meg nem dobottat a fejléc ✉ gombja nyitja újra.
const latottCetlik = new Set();

function cetliOlvasoFrissitese(kijelolt) {
  if (!(state.notes || []).length) { zarjBeCetliOlvasot(); return; }
  nyissCetliOlvasot({
    uiLang: state.uiLang,
    tartalomNyelv: state.contentLang,
    cetlik: state.notes,
    kijelolt: kijelolt || undefined,
    onDobd: (noteId) => dismissNote({ noteId }),
  });
}

function startNotesWatch() {
  if (notesUnsub) notesUnsub();
  notesUnsub = watchMyNotes(
    state.user.uid,
    (nyers) => {
      const cetlik = megjelenitendoCetlik(nyers);
      const ujak = cetlik.filter((c) => !latottCetlik.has(c.noteId));
      for (const c of cetlik) latottCetlik.add(c.noteId);
      setChat({ notes: cetlik });
      if (cetliOlvasoNyitva()) {
        // Nyitott ablak: frissül (új cetli érkezett / egyet eldobtak); az új cetlire ugrik.
        cetliOlvasoFrissitese(ujak.length > 0 ? ujak[0].noteId : null);
      } else if (ujak.length > 0 && !cetliIroNyitva()) {
        // Zárt ablak + új cetli: magától kinyílik (de nem szakítjuk meg, ha éppen cetlit ír).
        cetliOlvasoFrissitese(ujak[0].noteId);
      }
    },
    (err) => log.error("[cetli] a figyelés hibája:", err)
  );
}

// ---------------------------------------------------------------------------
// KEZDŐLAP (2026-10-25, a titkár #86 / #92 javaslata): belépés után, ha a tag legalább 1 órája nem volt aktív (vagy első belépés), a
// tagok kezdőlapja nyílik (fontos közlemények, kijelölt tájékoztató szobák, "Tovább az egyes menükhöz" / "Visszatérés az előzőleg
// megtekintett helyre"); rövidebb szünet után a legutóbbi hely marad. Logika: kezdolap.js; felület: kezdolapView.js.
// ---------------------------------------------------------------------------
let kezdolapBelepeskor = false;
let aktivIdozito = null;
let aktivFigyeloBeallitva = false;

const ESZKOZ_ID_KULCS = "l0_eszkozId";
const PRESENCE_IDOKORLAT_MS = 4000;

/** Az eszköz véletlen azonosítója (eszközönként külön szerveridős nyilvántartáshoz); sosem dob. */
function eszkozAzonosito() {
  try {
    let id = window.localStorage.getItem(ESZKOZ_ID_KULCS);
    if (!id || !/^[A-Za-z0-9_-]{8,64}$/.test(id)) {
      id = (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2, 10)).replace(/[^A-Za-z0-9_-]/g, "");
      window.localStorage.setItem(ESZKOZ_ID_KULCS, id);
    }
    return id;
  } catch (e) {
    return "ismeretlen-eszkoz";
  }
}

/** Időkorláttal: a szerver nem érhető el -> null (a hívó az eszköz órájára esik vissza). */
function idokorlattal(ig, ms = PRESENCE_IDOKORLAT_MS) {
  return Promise.race([ig, new Promise((r) => setTimeout(() => r(null), ms))]).catch(() => null);
}

/** A kezdőlap beállításának (belépési cél, ajánlott tájékoztatók) betöltése: a fejléc a menüből lépve is ugyanaz. Sosem dob. */
function homeBeallitasBetoltese() {
  getHomeConfig().then((c) => setChat({ homeRoomIds: c.roomIds, homeLanding: c.landing, homePinned: c.pinned || [], homeLandingIssueAt: c.landingIssueAt || null })).catch(() => {});
}

function aktivRogzites() {
  if (!state.user) return;
  aktivMentese(tarolo(), state.user.uid); // tartalék: az eszköz órája (ha a szerver nem érhető el)
  presence("ping", eszkozAzonosito()).catch(() => {}); // szerveridős életjel (a döntést a szerver hozza: functions/src/presence.js)
}

/**
 * Belépés után, a szobafigyelő indulása ELŐTT: kell-e a kezdőlap; az aktivitás-időbélyeg indítása. A döntést a SZERVER hozza a szerveridővel
 * (eszközönként külön; a kijelentkezés ideje külön az életjeltől); ha nem érhető el (hálózat, időkorlát 4 mp), az eszköz órája dönt.
 */
async function kezdolapElokeszites() {
  const uid = state.user.uid;
  let mar = false;
  try { mar = window.sessionStorage.getItem(KEZDOLAP_ELOZMENY_KULCS) === uid; } catch (e) { /* nem kritikus */ }
  // Ugyanabban a munkamenetben az újratöltés nem értékeli ki újra (nem dob vissza a kezdőlapra).
  if (!mar) {
    const szerver = await idokorlattal(presence("check", eszkozAzonosito()));
    kezdolapBelepeskor = szerver && typeof szerver.showHome === "boolean" ? szerver.showHome : kezdolapKell(aktivBetoltese(tarolo(), uid));
    try { window.sessionStorage.setItem(KEZDOLAP_ELOZMENY_KULCS, uid); } catch (e) { /* nem kritikus */ }
  }
  aktivRogzites();
  homeBeallitasBetoltese();
  if (aktivIdozito) clearInterval(aktivIdozito);
  aktivIdozito = setInterval(() => { if (!document.hidden) aktivRogzites(); }, 60 * 1000);
  if (!aktivFigyeloBeallitva) {
    aktivFigyeloBeallitva = true;
    document.addEventListener("visibilitychange", aktivRogzites);
    window.addEventListener("pagehide", aktivRogzites);
  }
}

function kezdolapLezarasa() {
  zarjBeKezdolapot();
}

function kezdolapFrissitese() {
  nyissKezdolapot({
    uiLang: state.uiLang,
    tartalomNyelv: state.contentLang,
    nev: state.profileName || (state.user && state.user.displayName) || "",
    kozlemenyek: state.announcements || [],
    szobak: kezdolapSzobak(state.homeRoomIds, state.rooms),
    // v221: "Következő ügyem" - az olvasatlan szobák (a szobalista piros pontjaival azonos forrás), az aktuális szoba nélkül
    olvasatlan: (state.unreadRoomIds || []).map((id) => (state.rooms || []).find((r) => r.roomId === id)).filter((r) => r && r.roomId !== state.currentRoomId),
    figyelmeztetes: state.homeLandingHiba === true ? "home.landingMissing" : null,
    // Az adminnak: legalább egy tagnál a belépési cél nem volt megnyitható (a Kezdőlap beállítás újramentése törli).
    adminFigyelmeztetes: state.access && state.access.role === "admin" && state.homeLandingIssueAt ? "admin.homeLandingIssue" : null,
    vanElozoHely: Boolean(state.currentRoomId),
    onTudomas: (annId) => ackAnnouncement({ annId }),
    onSzoba: (roomId) => { kezdolapLezarasa(); openRoom(roomId); },
    onMenuk: () => { kezdolapLezarasa(); setOverlay("rooms"); },
    onVissza: kezdolapLezarasa,
    onBezar: kezdolapLezarasa,
  });
}

/**
 * A kezdőlap megnyitása: a beállítást (config/home) frissen olvassa. BELÉPÉSKOR (belepeskor = true) és beállított belépési cél esetén
 * (a titkár #94 kérése) a kezdőlap HELYETT a kijelölt, meglévő szoba / téma nyílik meg (azonosító szerint), felül a "Tovább az egyes
 * menükhöz" / "Visszatérés az előzőleg megtekintett helyre" sávval; ha a cél nem nyitható (törölték, nincs jogosultság), a kezdőlap nyílik,
 * a hiányról szóló figyelmeztetéssel. A fejléc 🏠 gombja mindig a kezdőlapot nyitja.
 */
async function kezdolapMegnyitasa(belepeskor = false) {
  let cfg = { roomIds: [], landing: null };
  try {
    cfg = await getHomeConfig();
    setChat({ homeRoomIds: cfg.roomIds, homeLanding: cfg.landing, homePinned: cfg.pinned || [] });
  } catch (e) { /* üres lista marad */ }
  if (!state.user) return;
  const cel = cfg.landing;
  setChat({ homeLandingIssueAt: cfg.landingIssueAt || null });
  if (belepeskor && cel && cel.roomId) {
    const szoba = (state.rooms || []).find((r) => r.roomId === cel.roomId && !r.archived && !r.deleting);
    if (szoba) {
      const elozo = state.currentRoomId ? { roomId: state.currentRoomId, topicId: state.currentTopicId || null } : null;
      const tema = szoba.forum === true && cel.topicId ? cel.topicId : null;
      visszaallitottTema = tema; // ha a téma időközben megszűnt, a témalistára esünk vissza (nem üres képernyő)
      openRoom(szoba.roomId, tema);
      state.bejaratAuto = true; // a fejléc kimondja: mivel eltelt az idő, magától nyílt meg (v157)
      state.bejaratZarva = false; // belépéskor magától nyílt meg: kinyitva (v158)
      state.bejaratBezarva = false; // és nincs bezárva (v171)
      const vanElozo = Boolean(elozo) && (elozo.roomId !== szoba.roomId || elozo.topicId !== tema);
      mutassKezdolapSavot({
        uiLang: state.uiLang,
        vanElozoHely: vanElozo,
        menuGomb: !tema, // témában a hirdetmény fejléce már hordozza a "Tovább az egyes menükhöz" gombot (v173)
        onMenuk: () => setOverlay("rooms"),
        onVissza: () => {
          const r = (state.rooms || []).find((x) => x.roomId === elozo.roomId);
          if (!r) { setOverlay("rooms"); return; }
          const t0 = r.forum === true ? elozo.topicId : null;
          visszaallitottTema = t0;
          openRoom(r.roomId, t0);
        },
      });
      return;
    }
    log.error("[kezdőlap] a beállított belépési cél (szoba) nem nyitható meg: törölt vagy nem elérhető; a kezdőlap nyílik.");
    setChat({ homeLandingHiba: true });
    reportLandingIssue(); // az admin értesül (config/home.landingIssueAt); sosem dob
  } else {
    setChat({ homeLandingHiba: false });
  }
  kezdolapFrissitese();
}

// ---------------------------------------------------------------------------
// KÖZLEMÉNY (2026-10-25, Tamás kérésére): az admin üzenete, ami bejelentkezéskor felugrik, és addig újra megjelenik, amíg a tag
// TUDOMÁSUL nem veszi. Szerveroldal: functions/src/announcements.js; felület: kozlemenyView.js; adat: kozlemenyData.js.
// A belépéskor a már meglévő (még nem tudomásul vett) közlemények is "újak" (a munkamenet még egyet sem mutatott).
// ---------------------------------------------------------------------------
let annUnsub = null;
const latottKozlemenyek = new Set();

function kozlemenyOlvasoFrissitese(kijelolt) {
  const lista = state.announcements || [];
  if (!lista.length) { zarjBeKozlemenyOlvasot(); return; }
  nyissKozlemenyOlvasot({
    uiLang: state.uiLang,
    tartalomNyelv: state.contentLang,
    kozlemenyek: lista,
    kijelolt: kijelolt || undefined,
    onTudomas: (annId) => ackAnnouncement({ annId }),
  });
}

function startAnnouncementsWatch() {
  if (annUnsub) annUnsub();
  annUnsub = watchMyAnnouncements(
    state.user.uid,
    (nyers) => {
      const lista = megjelenitendoKozlemenyek(nyers);
      const ujak = lista.filter((k) => !latottKozlemenyek.has(k.annId));
      for (const k of lista) latottKozlemenyek.add(k.annId);
      setChat({ announcements: lista });
      if (kezdolapNyitva()) kezdolapFrissitese();
      else if (kozlemenyOlvasoNyitva()) kozlemenyOlvasoFrissitese(ujak.length > 0 ? ujak[0].annId : null);
      // A kezdőlap (belépéskor, ha a tag legalább 1 órája nem volt aktív) maga mutatja a közleményeket: nem ugrik fel kétszer ugyanaz.
      else if (ujak.length > 0 && !kezdolapBelepeskor) kozlemenyOlvasoFrissitese(ujak[0].annId);
    },
    (err) => log.error("[közlemény] a figyelés hibája:", err)
  );
}

/** A cetli küldésének hibájából a tagnak mutatható, a szerver által megfogalmazott szöveg - vagy null (általános felirat). */
function ismertCetliHiba(err) {
  const kod = String((err && err.code) || "");
  const ismert = ["functions/permission-denied", "functions/not-found", "functions/resource-exhausted",
    "functions/failed-precondition", "functions/invalid-argument", "functions/already-exists"];
  const uzenet = (err && typeof err.message === "string" && err.message.trim()) || "";
  return ismert.includes(kod) && uzenet ? uzenet : null;
}

function startRoomsWatch() {
  if (roomsUnsub) roomsUnsub();
  // A "Még nincsenek szobák" üzenet csak az ELSŐ sikeres szobalista UTÁN jelenhet meg (v172, titkár #5): addig "Betöltés…" áll (egy belépéskor
  // egyszer felvillant az üres üzenet, mielőtt a szobák betöltődtek volna).
  setChat({ roomsLoaded: false });

  const isAdmin = state.access?.role === "admin";
  roomsUnsub = watchMyRooms(
    state.user.uid,
    isAdmin,
    (rooms, meta) => {
      // Archivált szoba senkinek nem látszik. A törlés alatt álló szoba a
      // tagoknak azonnal eltűnik (nem is lehet bele írni), az admin viszont
      // látja - ha a törlés megszakadt, neki kell újra megpróbálnia.
      const visible = rooms.filter((r) => !r.archived && (isAdmin || !r.deleting));
      // Szerver által még NEM igazolt ÜRES lista (akadozó hálózat, helyi gyorsítótár): nem "még nincsenek szobák", hanem jelzés + újrapróba (v181).
      if (visible.length === 0 && meta && meta.megerositetlen === true) {
        setChat({ roomsMegerositetlen: true, roomsHiba: false });
        return;
      }
      setChat({ rooms: visible, roomsLoaded: true, roomsMegerositetlen: false, roomsHiba: false });
      // v186: a szerveren tárolt szoba-szintű olvasottság egyszer betöltődik belépéskor (nem csak fórum-szoba megnyitásakor).
      if (!state.forumAllapotBetoltve && !forumAllapotFolyamatban) {
        forumAllapotFolyamatban = true;
        forumAllapotBetoltese().finally(() => { forumAllapotFolyamatban = false; });
      }
      szobaOlvasottnakJelolese();
      olvasatlanFrissitese();

      // Ha még nincs megnyitott szoba, vagy a jelenlegi eltűnt, válasszunk.
      const stillThere = visible.some((r) => r.roomId === state.currentRoomId);
      if (!stillThere) {
        // Push-értesítésből induló, zárt appos megnyitásnál a MEGCÉLZOTT
        // szoba nyílik meg, nem a lista első eleme - máskülönben az
        // értesítésre kattintva a felhasználó egy másik beszélgetést látna.
        // Csak EGYSZER érvényesül (a changottam nullra), és csak akkor, ha a
        // célzott szoba ténylegesen létezik és elérhető ennek a tagnak.
        const targetId = pendingRoomIdFromNotification;
        const targetValid = targetId && visible.some((r) => r.roomId === targetId);
        // Újratöltés után az utolsó hely (szoba + téma) áll vissza; az értesítésből célzott szoba elsőbbséget élvez.
        const utvonalSzoba = !targetValid && bejovoUtvonal ? visible.find((r) => r.roomId === bejovoUtvonal.roomId) : null;
        const utolso = !targetValid && !utvonalSzoba && state.user ? helyBetoltese(tarolo(), state.user.uid) : null;
        const utolsoSzoba = utolso ? visible.find((r) => r.roomId === utolso.roomId) : null;
        if (utvonalSzoba) {
          const cel = bejovoUtvonal;
          bejovoUtvonal = null;
          const tema = utvonalSzoba.forum === true && cel.topicId ? cel.topicId : null;
          visszaallitottTema = tema;
          openRoom(utvonalSzoba.roomId, tema);
          if (cel.messageId && (tema || utvonalSzoba.forum !== true)) ugorjHivatkozottUzenethez(utvonalSzoba.roomId, tema, cel.messageId);
        } else if (utolsoSzoba) {
          visszaallitottTema = utolsoSzoba.forum === true && utolso.topicId ? utolso.topicId : null;
          openRoom(utolsoSzoba.roomId, visszaallitottTema);
        } else {
          openRoom(targetValid ? targetId : visible.length > 0 ? visible[0].roomId : null);
        }
        if (targetId) pendingRoomIdFromNotification = null;
        bejovoUtvonal = null;
      }
      // Kezdőlap (2026-10-25): belépés után egyszer, miután a legutóbbi hely már a háttérben áll (a "Visszatérés" gomb oda visz).
      if (kezdolapBelepeskor) {
        kezdolapBelepeskor = false;
        kezdolapMegnyitasa(true);
      }

      // Újratöltés előtt félbemaradt küldés: csak egyszer, az első
      // szobalista után (akkor már tudjuk, mely szobák elérhetők).
      if (!helyreallitasLefutott) {
        helyreallitasLefutott = true;
        helyreallitFuggoKuldest(visible).catch((err) => log.error("[chat] küldés-helyreállítás hiba:", err));
      }
    },
    (err) => {
      log.error("[chat] szobalista hiba:", err);
      setChat({ chatErrorKey: "admin.loadFailed", roomsHiba: true });
    }
  );
}

/**
 * Megmondja a service workernek, melyik szobát nézi ÉPPEN ez a lap.
 *
 * Ez alapján dönti el a worker, hogy egy beérkező push-üzenetre kell-e
 * rendszerszintű értesítés: ha a felhasználó épp azt a beszélgetést
 * olvassa, a felugró értesítés és a hangjelzés csak zavaró lenne.
 *
 * Hiba esetén csendben kihagyjuk - ilyenkor a worker a biztonságos irányba
 * téved, és megjeleníti az értesítést.
 */
function reportCurrentRoomToSW() {
  try {
    const ctrl = navigator.serviceWorker && navigator.serviceWorker.controller;
    if (!ctrl) return;
    // Csak akkor "nézi", ha a lap tényleg látható - háttérbe tett lapnál
    // az értesítés kell.
    const roomId = !document.hidden && state.screen === "active" ? state.currentRoomId || "" : "";
    ctrl.postMessage({ type: "CURRENT_ROOM", roomId });
  } catch (e) {
    // nem kritikus
  }
}

// ---------------------------------------------------------------------------
// Szobánkénti küldési állapot
//
// FONTOS, AUDITBÓL (2026-09-26): a piszkozat, a küldési azonosító, a
// csatolt kép és az újrapróbálás jelzője korábban EGYETLEN, közös állapot
// volt. Következmények:
//   - egy elbukott küldés után szobát váltva a mezőben maradt szöveg a
//     MÁSIK szobába ment el a küldés gombra;
//   - az "újrapróbálható" jelző a visszatéréskor a MOSTANI szoba szövegét
//     küldte el;
//   - egy többrészes küldés közben szobát váltva a hátralévő darabok az ÚJ
//     szobába mentek (a ciklus minden darabnál újra olvasta a szobát).
// Most minden szoba a saját állapotát tartja; a küldés a KEZDETKOR rögzíti
// a szobáját, és az eredményét (ürítés, maradék, hiba) oda írja vissza -
// akkor is, ha a felhasználó közben máshol jár.
// ---------------------------------------------------------------------------
const szobaAllapotok = new Map();
const uresSzobaAllapot = () => ({
  draft: "", pendingSendId: null, pendingImage: null, ujraprobalhato: false, chatErrorKey: null,
});

/** Az éppen elhagyott szoba küldési állapotának félretétele. */
function szobaAllapotFelretetele(roomId) {
  if (!roomId) return;
  const a = {
    draft: state.draft || "",
    pendingSendId: state.pendingSendId || null,
    pendingImage: state.pendingImage || null,
    ujraprobalhato: Boolean(state.ujraprobalhato),
    // A hibaüzenet csak akkor a szobáé, ha félbemaradt küldés tartozik
    // hozzá (egyébként pl. általános kapcsolati hiba, ami nem szobához kötött).
    chatErrorKey: state.pendingSendId ? state.chatErrorKey || null : null,
  };
  if (!a.draft && !a.pendingSendId && !a.pendingImage) szobaAllapotok.delete(roomId);
  else szobaAllapotok.set(roomId, a);
}

/**
 * Egy küldés eredményének alkalmazása A KÜLDÉS SZOBÁJÁRA: ha a felhasználó
 * még ott van, a látható állapotra; ha közben máshová váltott, a szoba
 * félretett állapotára (visszatéréskor azt látja).
 */
function kuldesSzobajara(roomId, valtozas) {
  if (state.currentRoomId === roomId) {
    const { pendingSendId, ujraprobalhato, ...lathato } = valtozas;
    if ("pendingSendId" in valtozas) state.pendingSendId = pendingSendId;
    if ("ujraprobalhato" in valtozas) state.ujraprobalhato = ujraprobalhato;
    setChat(lathato);
    return;
  }
  const a = szobaAllapotok.get(roomId) || uresSzobaAllapot();
  for (const k of Object.keys(uresSzobaAllapot())) if (k in valtozas) a[k] = valtozas[k];
  if (!a.draft && !a.pendingSendId && !a.pendingImage && !a.chatErrorKey) szobaAllapotok.delete(roomId);
  else szobaAllapotok.set(roomId, a);
}

// ---------------------------------------------------------------------------
// Régebbi üzenetek lapozása (2026-09-26)
//
// Korábban szobánként CSAK a legutolsó 50 üzenet volt elérhető. Most az élő
// ablak (legutolsó 50) felett a lista tetején "Korábbi üzenetek" gomb tölt
// be egyszerre 50-et; a logika: uzenetAblak.js.
// ---------------------------------------------------------------------------
let regebbiUzenetek = [];
let eloAblak = [];
let lapozasSzoba = null;
// A "meddig olvasott korábban" időpont a JELENLEGI szoba megnyitásának
// pillanatából (lásd openRoom - olvasottIdopontNyitaskor). Azért kell ide,
// MODULSZINTRE is kimentve, mert a régebbi-lapozás (lentebb) egy MÁSIK
// függvényben fut, ahhoz nem ér el az openRoom() belső const-ja.
let olvasottHatarIdopontja = null;

async function regebbiBetoltese() {
  const roomId = state.currentRoomId;
  if (!roomId || state.loadingOlder || !state.hasOlder) return false;
  const legregebbi = (state.messages || [])[0];
  if (!legregebbi) return false;
  setChat({ loadingOlder: true });
  try {
    const { messages: lap, hasMore } = await loadOlderMessages(roomId, legregebbi, aktLekeres);
    if (lapozasSzoba !== roomId) return false; // közben szobát váltott
    const r = regebbiLapHozzaadasa(regebbiUzenetek, lap, eloAblak);
    regebbiUzenetek = r.regebbi;

    // VALÓS HIBÁBÓL TANULVA (2026-10-03, tagi jelzésre): a "meddig olvastad"
    // elválasztó korábban CSAK az első (legfrissebb 50-es) lapon kereste az
    // első olvasatlan üzenetet. Ha az olvasatlan hátralék ennél NAGYOBB
    // volt, a jelölő a lap TETEJÉRE (a "Korábbi üzenetek" gomb mellé)
    // került, és OTT IS MARADT - a felhasználó visszalapozott, és egy
    // csomó, VALÓJÁBAN szintén olvasatlan régebbi üzenetet látott az
    // elválasztó FÖLÖTT, ami azt a hamis benyomást keltette, hogy azokat
    // már olvasta.
    //
    // JAVÍTÁS: minden betöltött régebbi lapnál újra megnézzük, hol van a
    // valódi határ - DE csak akkor, ha a jelölő eddig a lap TETEJÉN állt
    // (vagyis korábban sem találtunk benne olvasott/olvasatlan HATÁRT,
    // csak azt tudtuk, hogy a betöltött rész ELEJE már olvasatlan). Ha a
    // jelölő a betöltött listán BELÜL volt, az már egy VALÓDI határ - az
    // előtte álló (régebbi) üzenetek biztosan olvasottak (az időbélyegek
    // monoton nőnek), tehát onnantól nincs mit újraszámolni.
    if (
      typeof olvasottHatarIdopontja === "number" &&
      state.firstUnreadMessageId &&
      legregebbi &&
      state.firstUnreadMessageId === legregebbi.messageId
    ) {
      const ujHatar = lap.find(
        (msg) => msg.senderId !== state.user?.uid && idopontMs(msg.createdAt) > olvasottHatarIdopontja
      );
      if (ujHatar) {
        // A most betöltött lap is (részben) olvasatlan - a jelölő visszébb
        // kerül, erre a lapra. Ha a felhasználó még tovább lapoz, és EZ a
        // lap is végig olvasatlannak bizonyul, a következő hívás ugyanígy
        // tovább tolja a jelölőt.
        setChat({ messages: r.megjelenitett, hasOlder: hasMore, loadingOlder: false, firstUnreadMessageId: ujHatar.messageId });
        return lap.length > 0;
      }
      // Ha NEM találtunk a lapon olvasatlant, a korábban megjelölt határ
      // marad érvényes - ez a lap (és minden, ami ennél is régebbi) már
      // olvasott, hiszen az időbélyegek monoton nőnek.
    }

    setChat({ messages: r.megjelenitett, hasOlder: hasMore, loadingOlder: false });
    return lap.length > 0;
  } catch (err) {
    log.error("[chat] régebbi üzenetek betöltése hiba:", err);
    if (lapozasSzoba === roomId) setChat({ loadingOlder: false, chatErrorKey: "chat.loadOlderFailed" });
    return false;
  }
}

// ---------------------------------------------------------------------------
// Szobánkénti olvasatlan-jelzés (2026-09-26) - a logika: olvasatlan.js.
// ---------------------------------------------------------------------------

/** A most látott szoba olvasottnak jelölése (csak ha tényleg látja). */
function szobaOlvasottnakJelolese() {
  if (!state.user || state.screen !== "active" || !state.currentRoomId) return;
  if (typeof document !== "undefined" && document.hidden) return;
  const szoba = (state.rooms || []).find((r) => r.roomId === state.currentRoomId);
  if (szoba && typeof szoba.lastMessageAt === "number") {
    olvasottnakJelol(state.user.uid, szoba.roomId, szoba.lastMessageAt);
    szobaOlvasottSzerverre(szoba.roomId, Math.floor(szoba.lastMessageAt)); // v186: minden eszközön ugyanaz
  }
}

/** A látott szoba olvasottnak jelölése, majd az olvasatlan-lista újraszámolása. */
function latottSzobaFrissitese() {
  szobaOlvasottnakJelolese();
  olvasatlanFrissitese();
}

function olvasatlanFrissitese() {
  if (!state.user) return;
  const lista = olvasatlanSzobak(state.user.uid, state.rooms || []);
  const regi = state.unreadRoomIds || [];
  if (lista.length !== regi.length || lista.some((id, i) => id !== regi[i])) {
    setChat({ unreadRoomIds: lista });
    if (kezdolapNyitva()) kezdolapFrissitese(); // v221: a nyitott kezdőlap "Következő ügyem" listája naprakész marad
  }
  // v219: a cím- és ikonjelvény-számláló nem haladhatja meg a valódi olvasatlan szobák számát (és nulla olvasatlannál az ikonjelvény is törlődik),
  // csak ha a lap látható: háttérben a worker jelvénye marad, amíg a tag vissza nem tér.
  if (typeof document !== "undefined" && !document.hidden) kapUnreadCount(lista.length);
}

// Melyik szobába megy ÉPP küldés (a feltöltési százalék csak ott látszik).
let aktivKuldesSzoba = null;

/**
 * A tag SAJÁT fórum-állapota (olvasottság, e-mail összefoglaló gyakorisága) a szerverről - egyszer töltjük be belépésenként.
 * A fórum-szoba megnyitása és a profil is ezt használja (2026-10-16: az e-mail beállítás a profilba is bekerült).
 */
function forumAllapotBetoltese() {
  return forumAction({ action: "get" })
    .then((r) => {
      setChat({ forumRead: r.read || {}, emailFrequency: r.emailFrequency || "off", forumAllapotBetoltve: true });
      szobaOlvasottsagEgyesitese(r.roomRead);
    })
    .catch((err) => log.error("[fórum] állapot betöltése:", err));
}

// ---------------------------------------------------------------------------
// A szoba-szintű olvasottság (a szobalista piros pontja) EGYSÉGES a tag eszközei között (v186, Tamás kérése): eddig csak a helyi tárban élt
// (eszközönként), a téma-szintű viszont a szerveren. Most a szerver is tárolja (forumAction markRoomRead / get.roomRead); a kliens a helyi
// jelölést és a szerverét egyesíti (mindig a későbbi nyer), és a saját jelölést ritkítva elküldi.
// ---------------------------------------------------------------------------
let forumAllapotFolyamatban = false;
const szobaOlvasottKuldve = new Map(); // roomId -> utoljára elküldött időpont
const szobaOlvasottIdozitok = new Map();
let szobaOlvasottUtolsoEgyesites = 0;

/** A szerveren tárolt szoba-olvasottság egyesítése a helyivel; ezután az olvasatlan-lista újraszámolódik. */
function szobaOlvasottsagEgyesitese(roomRead) {
  szobaOlvasottUtolsoEgyesites = Date.now();
  if (!state.user || !roomRead || typeof roomRead !== "object") return;
  for (const [roomId, at] of Object.entries(roomRead)) {
    if (Number.isInteger(at)) {
      olvasottnakJelol(state.user.uid, roomId, at);
      szobaOlvasottKuldve.set(roomId, Math.max(szobaOlvasottKuldve.get(roomId) || 0, at));
    }
  }
  olvasatlanFrissitese();
}

/** A szoba olvasottnak jelölése a szerveren is (ritkítva: szobánként legfeljebb 4 másodpercenként, csak ha előrelépett). */
function szobaOlvasottSzerverre(roomId, at) {
  if (!roomId || !Number.isInteger(at) || at <= (szobaOlvasottKuldve.get(roomId) || 0)) return;
  clearTimeout(szobaOlvasottIdozitok.get(roomId));
  szobaOlvasottIdozitok.set(roomId, setTimeout(() => {
    szobaOlvasottIdozitok.delete(roomId);
    if (at <= (szobaOlvasottKuldve.get(roomId) || 0)) return;
    szobaOlvasottKuldve.set(roomId, at);
    forumAction({ action: "markRoomRead", roomId, at }).catch((err) => log.error("[olvasatlan] a szoba olvasottsága nem mentődött:", err));
  }, 4000));
}

/** Előtérbe kerüléskor (legalább 5 percenként) a szerveren tárolt olvasottság újraolvasása: a másik eszközön olvasott szoba itt is olvasott lesz. */
function szobaOlvasottsagFrissitese() {
  if (!state.user || state.screen !== "active" || Date.now() - szobaOlvasottUtolsoEgyesites < 5 * 60 * 1000) return;
  szobaOlvasottUtolsoEgyesites = Date.now();
  forumAction({ action: "get" }).then((r) => szobaOlvasottsagEgyesitese(r.roomRead)).catch((err) => log.error("[olvasatlan] az olvasottság frissítése:", err));
}

const erintoEszkoz = () => Boolean(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);

/**
 * A cím hash-ének a mostani helyhez igazítása (2026-10-18). Számítógépen a szoba / téma váltása új előzménybejegyzés (működik a böngésző
 * vissza / előre gombja); érintőképernyőn csak felülírjuk a mostanit (ott a "vissza" mozdulatot a visszaVedelem.js kezeli). Csak azonosítók kerülnek bele.
 */
function utvonalFrissitese(roomId, topicId) {
  try {
    const cel = roomId ? utvonalKeszit({ roomId, topicId }) : "";
    if (window.location.hash === cel) return;
    const url = window.location.pathname + window.location.search + cel;
    if (!cel && !window.location.hash) return;
    if (utvonalVisszaAllitas || erintoEszkoz() || !window.location.hash) window.history.replaceState(window.history.state, "", url);
    else window.history.pushState(null, "", url);
  } catch (e) {
    // az előzmény módosítása korlátozott lehet: nincs hivatkozás-frissítés, de nincs hiba sem
  }
}

let utvonalFigyeloVan = false;
/** Számítógépen a böngésző vissza / előre gombja (a cím hash-e változik): a megfelelő helyre lépünk, ha a tag tagja a szobának. */
function utvonalFigyeloIndit() {
  if (utvonalFigyeloVan || erintoEszkoz()) return;
  utvonalFigyeloVan = true;
  window.addEventListener("hashchange", () => {
    if (state.screen !== "active") return;
    const cel = utvonalBol(window.location.hash);
    if (!cel) return;
    const szoba = (state.rooms || []).find((r) => r.roomId === cel.roomId);
    if (!szoba) return;
    const tema = szoba.forum === true ? cel.topicId : null;
    if (state.currentRoomId === cel.roomId && (state.currentTopicId || null) === (tema || null)) return;
    utvonalVisszaAllitas = true;
    try {
      openRoom(cel.roomId, tema);
    } finally {
      utvonalVisszaAllitas = false;
    }
  });
}

/** A hivatkozott hozzászólásra ugrás: megvárja, míg a szoba / téma üzenetei betöltődnek (legfeljebb ~10 mp), majd a meglévő idézet-ugrással odalapoz. */
async function ugorjHivatkozottUzenethez(roomId, topicId, messageId) {
  const sorKeres = () => document.querySelector(`.msg-row[data-message-id="${CSS.escape(messageId)}"]`);
  const betoltve = () => state.currentRoomId === roomId && (state.currentTopicId || null) === (topicId || null) && Array.isArray(state.messages) && state.messages.length > 0;
  for (let i = 0; i < 100 && !(betoltve() && sorKeres()); i++) {
    // Ha az üzenetek megjöttek, de a keresett nincs az élő ablakban, az onJumpToMessage visszalapoz érte.
    if (i >= 20 && betoltve()) break;
    await new Promise((r) => setTimeout(r, 100));
  }
  if (state.currentRoomId !== roomId) return;
  await chatHandlers.onJumpToMessage(messageId, { maxLap: 100 });
  // A betöltés utáni automatikus "az aljára" görgetés felülírhatja az ugrást: ha a hozzászólás kikerült a látványból, még egyszer odagörgetünk.
  await new Promise((r) => setTimeout(r, 900));
  const sor = sorKeres();
  if (sor && state.currentRoomId === roomId) {
    const t = sor.getBoundingClientRect();
    if (t.bottom < 0 || t.top > window.innerHeight) await chatHandlers.onJumpToMessage(messageId, { maxLap: 1 });
  }
}

// Az éppen figyelt üzenetlista pillanatképe szerver által igazolt-e (v181): üres, igazolatlan lista nem jelent "még nincs üzenet".
let uzenetekMegerositetlen = false;

/** "Próbáld újra" az igazolatlan / hibás lista mellett (v181): a figyelőket újraindítja. */
function listaUjraprobalasa() {
  if (!state.currentRoomId) {
    startRoomsWatch();
    return;
  }
  if (topicsUnsub) { topicsUnsub(); topicsUnsub = null; }
  setChat({ messagesHiba: false, topicsHiba: false, topics: null, topicsMegerositetlen: false });
  openRoom(state.currentRoomId, state.currentTopicId || null);
}

// v220 (#102): ha a témafigyelő hibával áll le (pl. a bejelentkezési állapot még nem rendeződött, átmeneti hálózati hiba), a lista eddig
// üresen maradt egészen a következő belépésig ("piros pont, de üres téma"). Most magától újrapróbálkozik: 2, 5, majd 12 mp múlva,
// legfeljebb háromszor, és csak ha a tag még ugyanabban a szobában van, és a lista továbbra is hibás.
const TEMA_UJRAPROBA_KESES_MS = [2000, 5000, 12000];
let temaUjraprobaDb = 0;
let temaUjraprobaSzoba = null;
let temaUjraprobaIdozito = null;
function temaFigyeloUjraproba(roomId, topicId) {
  if (temaUjraprobaSzoba !== roomId) { temaUjraprobaSzoba = roomId; temaUjraprobaDb = 0; }
  if (temaUjraprobaDb >= TEMA_UJRAPROBA_KESES_MS.length || temaUjraprobaIdozito) return;
  const keses = TEMA_UJRAPROBA_KESES_MS[temaUjraprobaDb++];
  temaUjraprobaIdozito = setTimeout(() => {
    temaUjraprobaIdozito = null;
    if (state.currentRoomId !== roomId || state.topicsHiba !== true) return;
    if (topicsUnsub) { topicsUnsub(); topicsUnsub = null; }
    openRoom(roomId, topicId);
  }, keses);
}

function openRoom(roomId, topicId = null) {
  // A most elhagyott szoba / téma szövege azonnal mentődik, mielőtt az állapot átváltana.
  piszkozatMentesenMost();
  // A belépési cél "magától nyílt meg" jelzése csak addig él, amíg ott marad a tag (v157).
  if (state.bejaratAuto === true) {
    const l = state.homeLanding;
    if (!(l && roomId === l.roomId && (topicId || null) === (l.topicId || null))) state.bejaratAuto = false;
  }
  if (messagesUnsub) {
    messagesUnsub();
    messagesUnsub = null;
  }
  // Fórum (2026-10-09): fórum-módú szobában téma nélkül a témalista látszik (nincs üzenetfigyelés);
  // egy témát megnyitva (topicId) a téma hozzászólásai jönnek a megszokott üzenetnézetben.
  const forumSzoba = (state.rooms || []).find((r) => r && r.roomId === roomId);
  const forumMod = Boolean(forumSzoba && forumSzoba.forum === true);
  if (topicsUnsub && state.currentRoomId !== roomId) {
    topicsUnsub();
    topicsUnsub = null;
  }
  const aktTema = forumMod && topicId ? (state.topics || []).find((x) => x.topicId === topicId) || null : null;
  aktLekeres = forumMod && topicId ? temaLekeres(aktTema || { topicId, kind: topicId === ELOZMENY_ID ? "history" : "discussion" }) : null;

  // A "meddig olvasott korábban" időpontot ITT, a szoba tényleges
  // megnyitása ELŐTT kell elmenteni - a lenti üzenetfigyelő első
  // eredménye ugyanis már ÚJRA olvasottá jelöli a szobát (lásd
  // szobaOlvasottnakJelolese hívásai). Ha ezt később olvasnánk ki, mindig
  // "mindent olvasott" állapotot látnánk, és sosem találnánk meg, hol
  // hagyta abba a felhasználó.
  //
  // undefined = a szobát még sosem látta ez az eszköz - ilyenkor NINCS
  // "ahol abbahagyta" pont (a szoba baseline szerint eleve olvasottnak
  // számít), tehát nem mutatunk elválasztót, mint eddig.
  const olvasottIdopontNyitaskor =
    roomId && state.user ? olvasottak(state.user.uid)[roomId] : undefined;
  olvasottHatarIdopontja = typeof olvasottIdopontNyitaskor === "number" ? olvasottIdopontNyitaskor : null;

  // Az új szoba / téma mentett szövege (újratöltés után, vagy témák közti váltáskor). Témánként külön: eddig egy szobában a
  // szöveg átkerült a következő témába is - és oda ment volna el. null = a tároló nem használható: marad a memóriabeli viselkedés.
  const mentettPiszkozat = roomId && state.user ? piszkozatBetoltese(tarolo(), state.user.uid, roomId, forumMod ? topicId : null) : null;
  // A régi szoba piszkozata, azonosítója és képe félre, az új szobáé elő.
  const regi = state.currentRoomId;
  let uj = null;
  if (regi !== roomId) {
    szobaAllapotFelretetele(regi);
    uj = (roomId && szobaAllapotok.get(roomId)) || uresSzobaAllapot();
    szobaAllapotok.delete(roomId);
    state.pendingSendId = uj.pendingSendId;
    state.ujraprobalhato = uj.ujraprobalhato;
  }

  // A válasz-hivatkozás és a szerkesztés alatt álló üzenet is a RÉGI szoba
  // üzenetére mutatna - szobaváltáskor mindkettőt elengedjük, különben a
  // mentés a szerveren bukna el (más roomId-vel hívná).
  setChat({
    currentRoomId: roomId,
    messages: roomId && !(forumMod && !topicId) ? null : [],
    chatErrorKey: uj ? uj.chatErrorKey : null,
    replyTo: null,
    // Fórum (2026-10-09): a megnyitott téma; szobaváltáskor a témalista újratöltődik.
    currentTopicId: forumMod ? topicId : null,
    ...(regi !== roomId ? { topics: null, topicsMegerositetlen: false, topicsHiba: false } : {}),
    messagesMegerositetlen: false,
    messagesHiba: false,
    ujTema: null,
    ujTemaHiba: null,
    titlesDraft: null,
    atnevDraft: null,
    titlesError: null,
    titlesStatus: null,
    // A szűrő és a megnyitott szerkesztők szobánként érvényesek: szobaváltáskor alaphelyzetbe állnak.
    // A témán belüli szűrő és a nyitott hozzászólás-jelölő témaváltáskor alaphelyzetbe áll.
    postSzuro: [],
    postTagging: null,
    postLinking: null,
    postReviewing: null,
    fixEditor: null,
    fixList: null,
    atiratNyelv: null,
    atiratSzerk: null,
    modernAllapot: null,
    temaMenu: false,
    sourceDraft: null,
    sourceError: null,
    wfPanel: null,
    ...(regi !== roomId ? { forumSzuro: { workflow: "", tags: [] }, tagsDraft: null, katalogusDraft: null, katalogusError: null, katalogusStatus: null } : {}),
    // PDF-melléklet (2026-10-10): szobaváltáskor a még el nem küldött PDF nem viszi át magát a másik szobába.
    pendingFile: null,
    editingMessageId: null,
    editingText: "",
    editingBusy: false,
    editingErrorKey: null,
    editingErrorText: null,
    ...(uj ? { draft: uj.draft, pendingImage: uj.pendingImage, uploadProgress: null } : {}),
    // A mentett szöveg: a szoba memóriabeli (pl. félbemaradt küldés maradéka) szövege elsőbbséget élvez, egyébként a mentett.
    ...(mentettPiszkozat !== null && !(uj && uj.draft) ? { draft: mentettPiszkozat } : {}),
    hasOlder: false,
    loadingOlder: false,
    firstUnreadMessageId: null, // az új szoba első lapja fogja megállapítani
  });
  if (roomId && state.user) helyMentese(tarolo(), state.user.uid, roomId, forumMod ? topicId : null);
  utvonalFrissitese(roomId, forumMod ? topicId : null);
  // A lapozás állapota szobánként indul elölről.
  regebbiUzenetek = [];
  eloAblak = [];
  lapozasSzoba = roomId;
  reportCurrentRoomToSW();
  if (!roomId) return;
  // v185 (Tamás: "a Reiki Állatoknak piros olvasatlan jelzése miért aktív? elolvastam és megnyitottam"): a szoba megnyitása is "látta" - fórum-szobában
  // a témalista módban nincs üzenetfigyelő, ezért a szoba eddig csak a következő szobalista-frissítéskor lett olvasott. A témák olvasatlan jelzése
  // (a témalistán a számok) külön, a szerveren tárolt olvasottságból jön, azt ez nem érinti.
  latottSzobaFrissitese();

  if (forumMod) {
    if (!topicsUnsub) {
      topicsUnsub = watchTopics(
        roomId,
        (topics, meta) => {
          if (state.currentRoomId !== roomId) return;
          // v181: a szerver által még nem igazolt (gyorsítótáras) lista jelzése; egy ilyen ÜRES lista nem jelent "még nincs téma".
          setChat({ topics, topicsMegerositetlen: Boolean(meta && meta.megerositetlen === true), topicsHiba: false });
          if (!(meta && meta.megerositetlen === true)) temaUjraprobaDb = 0; // szerver által igazolt lista: az újrapróbálkozások számlálója nullázódik
          if (visszaallitottTema && state.currentTopicId === visszaallitottTema) {
            if (topics.some((x) => x.topicId === visszaallitottTema) || visszaallitottTema === ELOZMENY_ID) visszaallitottTema = null;
            else if (topics.length > 0) {
              // Az újratöltéskor visszaállított téma közben megszűnt: nem üres képernyőre, hanem a témalistára érkezünk.
              visszaallitottTema = null;
              openRoom(roomId);
            }
          }
        },
        (err) => {
          log.error("[fórum] témafigyelő hiba:", err);
          if (state.currentRoomId === roomId) setChat({ topicsHiba: true });
          temaFigyeloUjraproba(roomId, state.currentTopicId || null);
        }
      );
    }
    if (!state.forumAllapotBetoltve) forumAllapotBetoltese();
    if (!topicId) return; // témalista: nincs üzenetfigyelés
  }

  let elsoBetoltes = true;
  messagesUnsub = watchMessages(
    roomId,
    (messages, meta) => {
      retryFeloldas(messages);
      uzenetekMegerositetlen = Boolean(meta && meta.megerositetlen === true);
      // Az ELSŐ betöltés a meglévő előzmény - arra nem jelzünk.
      if (!elsoBetoltes && messages.length > 0) {
        const utolso = messages[messages.length - 1];
        if (utolso.senderId !== state.user?.uid) {
          handleIncomingMessage({ roomId, currentRoomId: state.currentRoomId });
        }
      }

      // Az első betöltött lapon keressük meg az ELSŐ, akkor még olvasatlan
      // (nem tőlünk érkezett) üzenetet - ez lesz a "Meddig olvastad"
      // elválasztó helye a nézetben (uzenetAblak.js/chatView.js).
      //
      // NEM ÉRTESÜL RÓLA, ha a kihagyott üzenetek száma több, mint amennyi
      // ebbe az első (legfrissebb 50-es) lapba belefér: ilyenkor a lista
      // ELSŐ sora már maga is olvasatlan, tehát a jelölő oda kerül, a
      // "Korábbi üzenetek" gomb pedig - mivel hasOlder ilyenkor igaz -
      // eleve látszik, így a felhasználó onnan tud visszább lapozni.
      let ujElsoOlvasatlanId;
      if (elsoBetoltes && typeof olvasottIdopontNyitaskor === "number") {
        const jelolt = messages.find(
          (msg) => msg.senderId !== state.user?.uid && idopontMs(msg.createdAt) > olvasottIdopontNyitaskor
        );
        ujElsoOlvasatlanId = jelolt ? jelolt.messageId : null;
      }
      // Az élő ablak (legutolsó 50) és a már betöltött régebbiek egyesítése;
      // a figyelésből kicsúszó üzenet a képernyőn marad (uzenetAblak.js).
      const elsoLap = elsoBetoltes;
      elsoBetoltes = false;
      if (lapozasSzoba !== roomId) return; // elkésett válasz egy elhagyott szobából
      const r = eloAblakFrissitese(regebbiUzenetek, eloAblak, messages);
      regebbiUzenetek = r.regebbi;
      eloAblak = messages;
      setChat({
        messages: r.megjelenitett,
        messagesMegerositetlen: uzenetekMegerositetlen,
        messagesHiba: false,
        ...(elsoLap ? { hasOlder: messages.length >= UZENET_LAP, firstUnreadMessageId: ujElsoOlvasatlanId } : {}),
      });
      szobaOlvasottnakJelolese();
      olvasatlanFrissitese();
      if (forumMod && topicId) temaOlvasottnakJelolese(roomId, topicId, r.megjelenitett);
    },
    (err) => {
      log.error("[chat] üzenetfigyelő hiba:", err);
      setChat({
        messages: [],
        messagesHiba: true, // v181: a hiba nem "még nincs üzenet" (a nézet külön jelzést és újrapróbát mutat)
        chatErrorKey: err && err.code === "permission-denied" ? "chat.notMember" : "common.errorConnection",
      });
    },
    aktLekeres
  );

  // A legutóbbi szobát elmentjük a profilba (nem kritikus, ha nem sikerül).
  if (state.profileName && state.contentLang) {
    saveProfile({
      name: state.profileName,
      preferredLang: state.contentLang,
      lastRoomId: roomId,
    }).catch(() => {});
  }
}

async function handleSend() {
  const raw = (state.draft || "").trim();
  const kep = state.pendingImage;
  const fajl = state.pendingFile || null; // PDF-melléklet (2026-10-10)

  // Küldhető, ha van szöveg VAGY kép VAGY PDF. Egy csak képet (vagy PDF-et) tartalmazó üzenet
  // teljesen érvényes - a melléklet maga az üzenet.
  if ((!raw && !kep && !fajl) || !state.currentRoomId || state.sending) return;
  // Csak olvasható szoba (2026-10-08): a tag nem küldhet (a felület is tiltja; a szerver elutasítaná).
  const aktSzoba = (state.rooms || []).find((r) => r && r.roomId === state.currentRoomId);
  if (aktSzoba && aktSzoba.readOnly === true && state.access?.role !== "admin") return;

  // Átirat (2026-10-19): a szöveg a megjelölt nyelven áll (nem a saját csevegési nyelven), magától nem fordítódik; a "#" jel itt nem parancs, a szöveg része.
  const atiratNyelv = state.atiratNyelv && !kep && !fajl ? state.atiratNyelv : null;
  const { text, noTranslate } = atiratNyelv ? { text: raw, noTranslate: true } : applyHashShortcut(raw);

  if (!kep && !fajl && !text.trim()) {
    setChat({ chatErrorKey: "chat.sendFailed" });
    return;
  }
  if (!state.contentLang) {
    setChat({ chatErrorKey: "profile.noLanguages" });
    return;
  }

  // EGY küldési szándék = EGY azonosító, ami a sikerig MEGMARAD.
  //
  // FONTOS, VALÓS HIBÁBÓL TANULVA: korábban minden gombnyomás új
  // azonosítót kapott, így az idempotencia - a rendszer egyik alapvető
  // ígérete - nem működött: ha a válasz elveszett a hálózaton, de az
  // üzenet valójában elment, az újrapróbálkozás MÁSODIK üzenetet hozott
  // létre. Az azonosítót ezért a state tárolja, és csak sikeres küldés
  // után (vagy a szöveg/kép megváltozásakor) dobjuk el.
  if (!state.pendingSendId) state.pendingSendId = newClientMessageId();
  const clientMessageId = state.pendingSendId;

  // A küldés CÉLJA a kezdetkor rögzül: szoba, megválaszolt üzenet, nyelv.
  // Ha közben szobát vált, a küldés akkor is ide megy (lásd fentebb).
  const roomId = state.currentRoomId;
  const replyToId = state.replyTo ? state.replyTo.messageId : null;
  const sourceLang = atiratNyelv || state.contentLang;
  aktivKuldesSzoba = roomId;

  setChat({ sending: true, chatErrorKey: null });

  try {
    // --- A kép feltöltése ELŐBB, mert az üzenet már a végleges
    // hivatkozással kell mentődjön. Ha a feltöltés elbukik, üzenet sem
    // keletkezik - nem marad "lyukas", kép nélküli üzenet a listában.
    //
    // A már feltöltött képet ÚJRAHASZNÁLJUK: egy sikertelen küldés utáni
    // újrapróbálkozás nem tölti fel másodszor (fölösleges forgalom, és a
    // megváltozott útvonal miatt a szerver ütközésnek látná ugyanazt a
    // küldési azonosítót).
    let imageAdat = null;
    const tobbImageAdat = []; // a 2-4. kép (v211)
    if (kep) {
      // "@2" (2026-10-06, tagi kérésre): a kép TÖMÖRÍTÉS NÉLKÜL, az eredeti
      // fájlként töltődik fel, és a szerver is így adja a Gemininek. A kép
      // kiválasztásakor már elkészült a szokásos (kicsinyített) változat; ezt
      // itt, a küldés pillanatában - amikor a szöveg már ismert - cseréljük
      // az eredetire. Ha az eredeti nem küldhető (túl nagy), a küldés megáll
      // és a tag érthető hibát kap, NEM megy ki csendben egy rontott kép.
      // Ha ennél a formátumnál nincs eredeti-út (pl. GIF), a szokásos kép marad.
      // A változatot már a "@2" begépelésekor igazítjuk (kepSzinkron), itt a
      // küldés pillanatában még egyszer, a VÉGLEGES szöveggel - ez a védőháló.
      // Több képes bejegyzésnél (v211) nincs "@2": minden kép a szokásos, kicsinyített változatban megy.
      const tobbKep = Array.isArray(kep.extras) ? kep.extras : [];
      const valtott = tobbKep.length === 0 ? await kepValtozat(kep, eredetiKellEz(text)) : null;
      if (valtott) setChat({ pendingImage: kep });
      if (!kep.uploaded) {
        // v222: a szokásos (kicsinyített JPEG) képhez bélyegkép is készül; az eredeti-útnál (@2) nem.
        const feltoltve = kep.eredeti
          ? await uploadImage({
            blob: kep.blob,
            roomId,
            uid: state.user.uid,
            onProgress: reportUploadProgress,
            contentType: kep.contentType,
            kiterjesztes: kep.kiterjesztes,
          })
          : await uploadImageWithThumb({ blob: kep.blob, width: kep.width, height: kep.height, roomId, uid: state.user.uid, onProgress: reportUploadProgress });
        kep.uploaded = { path: feltoltve.path, url: feltoltve.url, ...(feltoltve.thumbPath ? { thumbPath: feltoltve.thumbPath, thumbUrl: feltoltve.thumbUrl } : {}) };
      }
      imageAdat = {
        path: kep.uploaded.path,
        url: kep.uploaded.url,
        width: kep.width,
        height: kep.height,
        ...(kep.uploaded.thumbPath ? { thumbPath: kep.uploaded.thumbPath, thumbUrl: kep.uploaded.thumbUrl } : {}),
      };
      // A további képek (v211) feltöltése ugyanígy: a már feltöltöttet újrahasználjuk egy sikertelen küldés utáni újrapróbálkozáskor.
      for (const tovabbi of tobbKep) {
        if (!tovabbi.uploaded) {
          const feltoltve = await uploadImageWithThumb({ blob: tovabbi.blob, width: tovabbi.width, height: tovabbi.height, roomId, uid: state.user.uid, onProgress: reportUploadProgress });
          tovabbi.uploaded = { path: feltoltve.path, url: feltoltve.url, ...(feltoltve.thumbPath ? { thumbPath: feltoltve.thumbPath, thumbUrl: feltoltve.thumbUrl } : {}) };
        }
        tobbImageAdat.push({
          path: tovabbi.uploaded.path, url: tovabbi.uploaded.url, width: tovabbi.width, height: tovabbi.height,
          ...(tovabbi.uploaded.thumbPath ? { thumbPath: tovabbi.uploaded.thumbPath, thumbUrl: tovabbi.uploaded.thumbUrl } : {}),
        });
      }
    }

    // PDF-melléklet feltöltése (2026-10-10): ugyanaz a logika, mint a képnél - a feltöltött fájlt újrahasználjuk
    // egy sikertelen küldés utáni újrapróbálkozásnál (nem tölt fel másodszor).
    let fajlAdat = null;
    if (fajl) {
      if (!fajl.uploaded) {
        const feltoltve = await uploadImage({
          blob: fajl.file,
          roomId,
          uid: state.user.uid,
          onProgress: reportUploadProgress,
          contentType: "application/pdf",
          kiterjesztes: "pdf",
        });
        fajl.uploaded = { path: feltoltve.path, url: feltoltve.url };
      }
      fajlAdat = { path: fajl.uploaded.path, url: fajl.uploaded.url, name: fajl.name, size: fajl.size };
    }

    // --- A szöveg feldarabolása, ha meghaladja a szerver korlátját.
    //
    // FONTOS, VALÓS HIBÁBÓL TANULVA: korábban a hosszú üzenetet a szerver
    // egyszerűen elutasította, a felhasználó pedig egy általános "nem
    // sikerült elküldeni" piros szöveget kapott - anélkül, hogy megtudta
    // volna, miért. Most a hosszú szöveg TÖBB RÉSZBEN megy el.
    //
    // A kép és a válasz-hivatkozás CSAK az ELSŐ darabra kerül: a kép egy
    // üzenethez tartozik, és a válasz is egyetlen helyre mutat.
    // Fórumbejegyzés (2026-10-09): témában 5000 karakterig EGY bejegyzés (a fordító egyben adja vissza).
    const darabok = text.trim() ? splitMessage(text, darabolasiKorlat(Boolean(state.currentTopicId))) : [""];

    // Feljegyzés újratöltés esetére (lásd pendingSend.js) - csak szövegnél.
    if (!kep && !fajl) {
      mentFuggo({
        uid: state.user.uid,
        roomId,
        draft: raw,
        darabok,
        darabIds: darabAzonositok(clientMessageId, darabok.length),
      });
    }

    // Minden darab SAJÁT küldési azonosítót kap - különben a szerver
    // ugyanannak az üzenetnek látná őket, és csak az első menne el.
    //
    // FONTOS, VALÓS HIBÁBÓL TANULVA: az azonosító UUID v4 formátumú
    // KELL legyen, a szerver ezt szigorúan ellenőrzi. A korábbi
    // "<uuid>-0" toldalékos megoldás emiatt minden darabot elutasított,
    // és a darabolás sosem sikerült. Ezért valódi UUID-ket generálunk,
    // és MEGŐRIZZÜK őket a küldési szándék mellett: egy újrapróbálkozás
    // így ugyanazokat használja, és a darabok nem duplázódnak.
    // Az ELSŐ darab TÉNYLEGES üzenet-azonosítóját (a szerver válaszából,
    // NEM a saját clientMessageId-t!) kell megadni a további darabok
    // "firstPartId" mezőjében - a szerver a tényleges üzenetdokumentumot
    // keresi ez alapján (lásd sendMessage.js), és az egy szerver-generált,
    // a clientMessageId-től ELTÉRŐ azonosító.
    let elsoDarabUzenetId = null;

    for (let i = 0; i < darabok.length; i++) {
      // Minden darab SAJÁT küldési azonosítót kap - különben a szerver
      // ugyanannak az üzenetnek látná őket, és csak az első menne el.
      //
      // FONTOS, VALÓS HIBÁBÓL TANULVA: az azonosító UUID v4 formátumú
      // KELL legyen, a szerver ezt szigorúan ellenőrzi. A korábbi
      // "<uuid>-0" toldalékos megoldás emiatt minden darabot elutasított,
      // és a darabolás sosem sikerült. Ezért valódi UUID-ket generálunk,
      // és MEGŐRIZZÜK őket a küldési szándék mellett: egy újrapróbálkozás
      // így ugyanazokat használja, és a darabok nem duplázódnak.
      const darabId = darabAzonositok(clientMessageId, darabok.length)[i];

      const valasz = await sendMessage({
        roomId,
        clientMessageId: darabId,
        text: labelPart(darabok[i], i, darabok.length),
        sourceLang,
        noTranslate,
        ...(atiratNyelv ? { transcript: true } : {}),
        // A percenkénti küldési keret alóli kivételhez (lásd
        // functions/src/lib/rateLimit.js) - CSAK akkor küldjük, ha
        // valóban több darabra bomlott az üzenet; egy rendes, egyetlen
        // darabból álló üzenetnél a viselkedés a korábbival azonos marad.
        ...(darabok.length > 1 ? { partIndex: i, partCount: darabok.length } : {}),
        ...(i > 0 && elsoDarabUzenetId ? { firstPartId: elsoDarabUzenetId } : {}),
        ...(i === 0 && imageAdat ? (tobbImageAdat.length > 0 ? { images: [imageAdat, ...tobbImageAdat] } : { image: imageAdat }) : {}),
        ...(i === 0 && fajlAdat ? { file: fajlAdat } : {}),
        ...(i === 0 && replyToId ? { replyToId } : {}),
        // Fórum (2026-10-09): a megnyitott témába (minden rész).
        ...(state.currentTopicId && state.currentTopicId !== ELOZMENY_ID ? { topicId: state.currentTopicId } : {}),
      });
      if (i === 0) elsoDarabUzenetId = valasz && valasz.messageId;

      // A már elküldött darabokat kivesszük a piszkozatból: ha egy későbbi
      // darab elbukik, csak a MÉG EL NEM KÜLDÖTT rész marad a mezőben.
      state.elkuldottDarabok = i + 1;
      if (!kep && !fajl) frissitKesz(i + 1);
    }
    state.elkuldottDarabok = 0;
    torolFuggo();

    // Csak SIKER után ürítünk - hiba esetén a szöveg ÉS a kép is megmarad,
    // hogy az újrapróbálkozáshoz ne kelljen mindent elölről.
    if (kep) releaseImage(kep);
    // A válasz-hivatkozás is csak SIKER után szűnik meg - ha a küldés
    // elbukott, az újrapróbálkozás ugyanarra az üzenetre válaszol.
    aktivKuldesSzoba = null;
    kuldesSzobajara(roomId, {
      draft: "", pendingSendId: null, ujraprobalhato: false, pendingImage: null, replyTo: null, chatErrorKey: null,
    });
    setChat({ sending: false, uploadProgress: null, pendingFile: null, ...(atiratNyelv ? { atiratNyelv: null } : {}) });

    // Ha közben új verzió jelent meg, most biztonságos frissíteni.
    maybeApplyUpdate();
  } catch (err) {
    log.error("[chat] küldés hiba:", err);

    // Ha több részben ment, és néhány darab MÁR ELMENT, akkor csak a
    // hátralévő rész maradjon a beviteli mezőben - különben az
    // újrapróbálkozás megismételné a már elküldött darabokat.
    aktivKuldesSzoba = null;
    let { kulcs: hibaKulcs, ujraprobalhato } = sendErrorKey(err, Boolean(kep));
    // v189: a lejárt bejelentkezésnél a szöveget ELŐBB biztosítjuk az eszközön (a titkár #18 / #20): a hibaüzenet csak akkor mondja, hogy "elmentve", ha a mentés
    // ténylegesen sikerült; ha nem, a szöveg a képernyőn marad, és az üzenet arra kér, hogy másold ki.
    if (hibaKulcs === "chat.sessionExpired") {
      const mentve = state.user ? piszkozatMentese(tarolo(), state.user.uid, roomId, state.currentRoomId === roomId ? state.currentTopicId : null, raw) : false;
      if (!mentve) hibaKulcs = "chat.sessionExpiredNoSave";
    }

    // VALÓS HIBÁBÓL TANULVA (2026-10-03, tagi jelzésre): a küldési
    // azonosító (pendingSendId) SZÁNDÉKOSAN megmarad egy sikertelen próbálkozás
    // után (lásd a handleSend() elején lévő megjegyzést) - egy egyszerű
    // hálózati hibánál ez helyes, mert az újrapróbálkozás ugyanazt az
    // üzenetet viszi el, nem duplikál.
    //
    // DE: ha a szerver "already-exists" hibát ad (a szöveg, a kép vagy a
    // forrásnyelv KÖZBEN megváltozott ugyanahhoz az azonosítóhoz képest -
    // pl. a felhasználó finomított a piszkozaton a sikertelen próbálkozás
    // UTÁN), ez az azonosító TRVALÓAN el van "ásva": minden további
    // próbálkozás ugyanezzel a hibával bukik, a "Próbáld újra" gomb
    // LÁTSZÓLAG semmit nem csinál. A tagok ezt a sikertelen üzenet
    // kimásolásával és KIJELENTKEZÉSSEL kerülték meg (az tisztítja csak az
    // azonosítót, lásd handleSignOut). Itt javítjuk: egy "already-exists"
    // hiba után MAGUNK nullázzuk az azonosítót, hogy a következő
    // próbálkozás már egy FRISS küldési szándékként induljon, kijelentkezés
    // nélkül is.
    const idUtkozes = String((err && err.code) || "") === "functions/already-exists";

    // MÁSODIK KÖR (2026-10-03, ismételt tagi jelzésre Androidról: a küldés
    // továbbra is csak ki- és visszajelentkezés után ment el). A
    // kijelentkezés HÁROM dolgot csinál, ami egy beragadt küldést feloldhat:
    //   1. nullázza a küldési azonosítót (state.pendingSendId),
    //   2. törli a HÁTTÉRTÁRBA mentett félbemaradt küldést (torolFuggo) -
    //      enélkül egy újraindított/háttérből visszatért alkalmazás
    //      (Androidon gyakori) a RÉGI azonosítót újra visszaállította,
    //      és a hiba újra előjött,
    //   3. friss bejelentkezési tokent szerez.
    // Mindhármat most a kijelentkezés NÉLKÜL is megtesszük - a pontos ok
    // élő eszköz nélkül nem azonosítható, ezért mindhárom lehetséges
    // beragadási pontot feloldjuk.
    //
    // Az azonosítót CSAK akkor dobjuk el, ha a szerver VÉGLEGESEN
    // elutasította a kérést (ilyenkor az üzenet biztosan NEM mentődött el,
    // tehát egy új azonosító nem okozhat duplikátumot). Hálózati jellegű
    // hibánál (internal/unavailable/deadline-exceeded/cancelled) az
    // azonosító marad - ott lehet, hogy a szerver már megkapta.
    const hibaKod = String((err && err.code) || "");
    const halozatiJellegu = ["functions/internal", "functions/unavailable",
      "functions/deadline-exceeded", "functions/cancelled", "auth/network-request-failed"].includes(hibaKod) || hibaKod.startsWith("storage/");
    const vegleges = hibaKod.startsWith("functions/") && !halozatiJellegu;
    if (vegleges) torolFuggo();
    if (hibaKod === "functions/unauthenticated") await frissitsdATokent();
    // A hibakódot a felirat mellé írjuk, ha az általános "nem sikerült"
    // jelenne meg - a képmentésnél ez vezetett el a valódi okhoz.
    const hibaSzoveg = hibaKulcs === "chat.sendFailed" && hibaKod
      ? `${t(state.uiLang, "chat.sendFailed")} (${hibaKod.replace("functions/", "")})`
      : hibaKulcs === "chat.sessionExpired" || hibaKulcs === "chat.sessionExpiredNoSave"
        ? `${t(state.uiLang, hibaKulcs)} (${(err && err.authCode) || "auth"})`
        : null;

    const kesz = state.elkuldottDarabok || 0;
    if (kesz > 0) {
      // A maradék a küldéskor RÖGZÍTETT szövegből számolódik, nem a mező
      // mostani tartalmából (az közben egy másik szobáé is lehet).
      const osszes = splitMessage(applyHashShortcut(raw).text, darabolasiKorlat(Boolean(state.currentTopicId)));
      const hatralevo = osszes.slice(kesz).join("\n\n");
      state.elkuldottDarabok = 0;
      // Új küldési szándék: a hátralévő rész önálló üzenet lesz.
      torolFuggo();
      kuldesSzobajara(roomId, {
        draft: hatralevo, pendingSendId: null, ujraprobalhato: false, pendingImage: null, replyTo: null,
        chatErrorKey: hibaKulcs,
      });
      setChat({ sending: false, uploadProgress: null });
      return;
    }

    kuldesSzobajara(roomId, {
      chatErrorKey: hibaKulcs, ujraprobalhato,
      // Lásd a fenti megjegyzést: végleges elutasításkor (köztük az
      // "already-exists") az azonosítót itt kell nullázni (akkor is, ha a
      // felhasználó közben MÁS szobába lépett át - a kuldesSzobajara ilyenkor
      // a roomId szerinti, háttérben tárolt állapotot frissíti).
      ...(idUtkozes || vegleges ? { pendingSendId: null } : {}),
    });
    if (hibaSzoveg && state.currentRoomId === roomId) setChat({ chatErrorText: hibaSzoveg });
    setChat({ sending: false, uploadProgress: null });
  }
}

/**
 * A küldési hibából a felhasználónak szóló felirat azonosítója.
 *
 * A Storage-hibák külön ágat kapnak: a kép feltöltése más okból bukhat el
 * (jogosultság, hálózat), mint maga az üzenetküldés, és a felhasználónak
 * tudnia kell, melyikről van szó.
 */
function sendErrorKey(err, volteKep) {
  const kulcs = hibaFelirat(err, volteKep);
  // Az "újrapróbálható" jelző a KÜLDÉS szobájáé - a hívó írja oda.
  return { kulcs, ujraprobalhato: kulcs === "chat.sendInterrupted" };
}

function hibaFelirat(err, volteKep) {
  const code = String((err && err.code) || "");
  if (code === "functions/resource-exhausted") return "chat.rateLimited";
  // "@2": az eredeti kép nem küldhető (túl nagy) - 2026-10-06.
  if (code === "app/original-too-large") return "image.ocrTooLarge";
  // A bejelentkezés lejárt/megszakadt (firebaseClient.js vedett()) - 2026-10-03.
  if (code === "app/session-expired") return "chat.sessionExpired";
  if (code.startsWith("storage/")) {
    return code === "storage/unauthorized" ? "image.uploadDenied" : "image.uploadFailed";
  }
  if (volteKep && String((err && err.message) || "").toLowerCase().includes("storage")) {
    return "image.uploadFailed";
  }

  // Hálózati eredetű kudarc: jellemzően akkor, ha a felhasználó közben más
  // alkalmazásra váltott, és a rendszer felfüggesztette a kérést. Ilyenkor
  // az üzenet megismételhető - a küldési azonosító megmarad, így a szerver
  // nem hoz létre kettőt belőle.
  if (code === "functions/internal" || code === "functions/unavailable" ||
      code === "functions/deadline-exceeded" || code === "functions/cancelled" ||
      code === "auth/network-request-failed") {
    return "chat.sendInterrupted";
  }
  return "chat.sendFailed";
}

// A függőben lévő kép változatának összehangolása a beírt szöveggel (2026-10-06):
// pontosan "@2" -> az eredeti, tömörítetlen fájl; bármi más -> a kicsinyített. Csak
// akkor dolgozik (és renderel), ha a "@2" határát átlépte a szöveg - leütésenként nem.
let kepSzinkronFut = false;
async function kepSzinkron() {
  const kep = state.pendingImage;
  if (!kep || kepSzinkronFut || state.sending) return;
  if (Array.isArray(kep.extras) && kep.extras.length > 0) return; // több képnél nincs "@2" (v211)
  if (eredetiKellEz(state.draft) === Boolean(kep.eredeti)) return;
  kepSzinkronFut = true;
  try {
    // Ciklus: a feldolgozás alatt tovább gépelhetett - az ÚJ állapothoz igazítunk.
    while (state.pendingImage === kep && !state.sending && eredetiKellEz(state.draft) !== Boolean(kep.eredeti)) {
      const valtott = await kepValtozat(kep, eredetiKellEz(state.draft));
      if (!valtott) break; // nincs eredeti-út ennél a formátumnál
      setChat({ pendingImage: kep, chatErrorKey: null });
    }
  } catch (err) {
    // Túl nagy az eredeti: azonnal szólunk (nem csak küldéskor); a küldés ugyanezzel a hibával megállna.
    log.error("[kép] a változat váltása nem sikerült:", err);
    setChat({ chatErrorKey: err && err.code === "app/original-too-large" ? "image.ocrTooLarge" : "image.notAnImage" });
  } finally {
    kepSzinkronFut = false;
  }
}

// A keresés lapjainak rövid ideig élő gyorsítótára (kereso.js lapGyorsitotar):
// a keresőszó módosítása így nem olvassa újra az átnézett üzeneteket.
const keresesLapGyorsitotarral = lapGyorsitotar(keresesiLap);

/**
 * Egy keresési találatra ugrás (2026-10-04). Másik szobában lévő találatnál
 * előbb átváltunk arra a szobára, megvárjuk az első lap betöltését, majd a
 * meglévő idézet-ugrás (onJumpToMessage) lapoz vissza a találatig - a keresés
 * miatt a szokásosnál mélyebbre (100 lap = 5000 üzenet).
 */
async function ugorjUzenethez(roomId, messageId) {
  if (state.currentRoomId !== roomId) {
    openRoom(roomId);
    for (let i = 0; i < 60 && !(state.currentRoomId === roomId && Array.isArray(state.messages)); i++) {
      await new Promise((r) => setTimeout(r, 100));
    }
  }
  await chatHandlers.onJumpToMessage(messageId, { maxLap: 100 });
}

/**
 * VALÓS HIBÁBÓL TANULVA (2026-10-03, tagi jelzésre): a szerkesztés/törlés
 * sikertelenségét korábban MINDIG ugyanaz az egy, elvont felirat jelezte
 * ("A törlés nem sikerült."), FÜGGETLENÜL az okától - hiába adott a szerver
 * (messageActions.js) ÉRTHETŐ, KONKRÉT magyar magyarázatot (pl. "Ezt az
 * üzenetet nem törölheted.", vagy "Egy feldarabolt, hosszú üzenet kezdő
 * része egyelőre nem törölhető ezen a felületen."). Ez utóbbi pont akkor
 * sújtja a tagokat, ha egy hosszú, a 20 000 karakternél hosszabb szöveget
 * (pl. egy egész promptot) illesztenek be - a küldés ilyenkor több
 * üzenetre tagolódik, és az ELSŐ darabja ezen a felületen (egyelőre)
 * szándékosan nem törölhető/szerkeszthető.
 *
 * Itt a szerver ÁLTALA MEGFOGALMAZOTT, biztonsággal mutatható szövegét
 * adjuk vissza - DE csak a messageActions.js ISMERT hibakódjainál; egy
 * váratlan (hálózati, "internal" stb.) hibánál a generikus feliratot
 * mutatjuk, mert egy technikai hibaüzeneg nem segítene a tagnak.
 */
function ismertUzenetMuveletHiba(err) {
  const code = String((err && err.code) || "");
  const ISMERT_KODOK = new Set([
    "functions/permission-denied",
    "functions/failed-precondition",
    "functions/not-found",
    "functions/already-exists",
    // A kényszerített újrafordítás kerete/költségplafonja (2026-10-07): a szerver szövege érthető.
    "functions/resource-exhausted",
  ]);
  const uzenet = (err && typeof err.message === "string" && err.message.trim()) || "";
  return ISMERT_KODOK.has(code) && uzenet ? uzenet : null;
}

/**
 * Megszakadt küldés automatikus folytatása.
 *
 * Akkor fut, amikor a felhasználó visszatér az alkalmazáshoz. Biztonságos,
 * mert a küldési azonosító a kudarc után is megmarad: ha az üzenet
 * valójában mégis elment, a szerver felismeri és nem hoz létre másodikat.
 */
/**
 * A darabok küldési azonosítói - egy küldési szándékhoz MINDIG ugyanazok.
 *
 * A szerver UUID v4 formátumot vár, ezért nem toldalékolhatunk. A
 * megőrzés az idempotencia miatt kell: ha a küldés félbeszakad és
 * visszatéréskor folytatódik, ugyanazokkal az azonosítókkal megy tovább,
 * így a már elment darabokból nem lesz második példány.
 */
const darabIdCache = new Map();
function darabAzonositok(alapId, darabszam) {
  const kulcs = `${alapId}:${darabszam}`;
  let lista = darabIdCache.get(kulcs);
  if (!lista) {
    lista = [alapId];
    for (let i = 1; i < darabszam; i++) lista.push(newClientMessageId());
    darabIdCache.set(kulcs, lista);
    // A gyorsítótár nem nőhet korlátlanul: csak a legutóbbi néhány
    // küldési szándék azonosítóit tartjuk meg.
    if (darabIdCache.size > 8) darabIdCache.delete(darabIdCache.keys().next().value);
  }
  return lista;
}

function retryInterruptedSend() {
  if (!state.ujraprobalhato || state.sending) return;
  if (!(state.draft || "").trim() && !state.pendingImage && !state.pendingFile) return;
  if (state.screen !== "active" || !state.currentRoomId) return;

  state.ujraprobalhato = false;
  log.debug("[chat] megszakadt küldés folytatása");
  handleSend();
}

/**
 * A feltöltés százalékának jelentése - RITKÍTVA.
 *
 * Minden állapotváltozás teljes újrarajzolást vált ki (az üzenetlistával
 * együtt). A feltöltési esemény másodpercenként sokszor érkezik, ezért
 * csak 10 százalékonként és a végén frissítünk: enélkül egy nagyobb kép
 * feltöltése közben a felület akadozna és a képek újra betöltődnének.
 */
function reportUploadProgress(szazalek) {
  // Közben szobát váltott: a másik szobában nem mutatunk idegen feltöltést.
  if (aktivKuldesSzoba && aktivKuldesSzoba !== state.currentRoomId) return;
  const elozo = state.uploadProgress;
  if (elozo !== null && elozo !== undefined && szazalek < 100 && szazalek - elozo < 10) return;
  setChat({ uploadProgress: szazalek });
}

/**
 * Érintőképernyős, felugró billentyűzetes eszköz-e? A válasz gomb
 * megnyomásakor ezen múlik, hogy fókuszáljunk-e a beviteli mezőbe.
 */
function isMobilKeplet() {
  return (window.navigator?.maxTouchPoints || 0) > 0;
}

// ----------------------------------------------------------------------------
// FÓRUM (2026-10-09) - olvasottság témánként (a szerveren, minden eszközön), új téma, figyelés.
// ----------------------------------------------------------------------------
function temaOlvasottnakJelolese(roomId, topicId, uzenetek) {
  if (topicId === ELOZMENY_ID) return;
  const sorszam = legnagyobbSorszam(uzenetek);
  const kulcs = `${roomId}/${topicId}`;
  const eddig = (state.forumRead || {})[kulcs] || 0;
  if (sorszam <= eddig) return;
  setChat({ forumRead: { ...(state.forumRead || {}), [kulcs]: sorszam } });
  // Ritkítva: olvasás közben legfeljebb 4 másodpercenként egy írás.
  clearTimeout(olvasottIdozito);
  olvasottIdozito = setTimeout(() => {
    forumAction({ action: "markRead", roomId, topicId, postNumber: sorszam }).catch((err) => log.error("[fórum] olvasottság:", err));
  }, 4000);
}

// A szerver hibaüzenete magyar: a japán / olasz stb. felületű tag számára a felület nyelvén írt alap szöveg áll elöl, a szerver részletes
// szövege zárójelben utána (2026-10-16, iPhone-os jelzés: "piros, olvashatatlan betűk"). Ugyanaz a szöveg nem ismétlődik.
// A hozzászólás javaslat-listájának (újra)olvasása és megjelenítése; a hiba a listában jelenik meg (2026-10-19).
async function frissitsdAJavaslatokat(messageId, lang, kinyit, uzenet = null) {
  const roomId = state.currentRoomId;
  if (!roomId) return;
  if (kinyit) setChat({ fixList: { messageId, lang, betolt: true, busy: false, hiba: null, lista: [], jegyzetek: {} } });
  try {
    const lista = await forditasJavaslatok(roomId, messageId, lang);
    if (state.fixList && state.fixList.messageId === messageId) setChat({ fixList: { ...state.fixList, betolt: false, busy: false, hiba: uzenet, lista } });
  } catch (err) {
    log.error("[fordításjavaslat] a lista nem tölthető be:", err);
    if (state.fixList && state.fixList.messageId === messageId) setChat({ fixList: { ...state.fixList, betolt: false, busy: false, hiba: t(state.uiLang, "message.fixFailed") } });
  }
}

function forumHiba(err, kulcs = "forum.manageFailed") {
  const alap = t(state.uiLang, kulcs);
  const reszlet = err && typeof err.message === "string" ? err.message.trim() : "";
  return reszlet && reszlet !== alap ? `${alap} (${reszlet})` : alap;
}

async function temaMuvelet(adat) {
  try {
    await topicAction({ roomId: state.currentRoomId, ...adat });
  } catch (err) {
    log.error("[fórum] témakezelés:", err);
    setChat({ chatErrorKey: "forum.manageFailed" });
  }
}

const forumKezelok = {
  onRetryList: () => listaUjraprobalasa(),
  onOpenTopic: (topicId) => openRoom(state.currentRoomId, topicId),
  onBackToTopics: () => openRoom(state.currentRoomId),
  onNewTopicStart: () => setChat({ ujTema: { title: "", text: "" }, ujTemaHiba: null }),
  onNewTopicChange: (mezo, ertek) => { if (state.ujTema) state.ujTema[mezo] = ertek; },
  onNewTopicCancel: () => setChat({ ujTema: null, ujTemaHiba: null }),
  onNewTopicSubmit: async () => {
    const u = state.ujTema;
    const roomId = state.currentRoomId;
    if (!u || !roomId || state.ujTemaBusy) return;
    const { text, noTranslate } = applyHashShortcut(String(u.text || "").trim());
    if (String(u.title || "").trim().length < 3 || !text.trim()) {
      setChat({ ujTemaHiba: t(state.uiLang, "forum.newTopicIncomplete") });
      return;
    }
    if (splitMessage(text, darabolasiKorlat(true)).length > 1) {
      setChat({ ujTemaHiba: t(state.uiLang, "forum.tooLong", { n: MAX_FORUM_TEXT_CODEPOINTS }) });
      return;
    }
    setChat({ ujTemaBusy: true, ujTemaHiba: null });
    try {
      const r = await sendMessage({ roomId, clientMessageId: newClientMessageId(), text, sourceLang: state.contentLang, noTranslate, newTopicTitle: u.title.trim() });
      setChat({ ujTemaBusy: false, ujTema: null });
      if (r && r.topicId && state.currentRoomId === roomId) openRoom(roomId, r.topicId);
    } catch (err) {
      log.error("[fórum] új téma:", err);
      setChat({ ujTemaBusy: false, ujTemaHiba: (err && err.message) || t(state.uiLang, "chat.sendFailed") });
    }
  },
  // Témakezelés (2026-10-09): átnevezés (a cím újrafordul), cím újrafordítása, kitűzés, lezárás.
  // Átnevezés (v122): beépített szerkesztő a felugró kérdés helyett (az néhol letiltott / nem látszik); a szerver döntése változatlan (nyitó / admin / témafelelős).
  onRenameTopic: () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) setChat({ atnevDraft: { title: temaCim(tema, state.contentLang), busy: false, error: null } });
  },
  onRenameChange: (ertek) => { if (state.atnevDraft) state.atnevDraft.title = ertek; },
  onRenameCancel: () => setChat({ atnevDraft: null }),
  onRenameSave: async () => {
    const v = state.atnevDraft;
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (!v || v.busy || !tema) return;
    const uj = String(v.title || "").trim();
    if (uj === "" || uj === tema.title) { setChat({ atnevDraft: null }); return; }
    setChat({ atnevDraft: { ...v, busy: true, error: null } });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "rename", topicId: tema.topicId, title: uj, titleLang: state.contentLang });
      setChat({ atnevDraft: null });
    } catch (err) {
      log.error("[fórum] átnevezés:", err);
      setChat({ atnevDraft: { ...v, busy: false, error: forumHiba(err, "forum.manageFailed") } });
    }
  },
  onRetranslateTitle: async () => {
    if (state.currentTopicId) await temaMuvelet({ action: "retranslateTitle", topicId: state.currentTopicId });
  },
  onTogglePin: async () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) await temaMuvelet({ action: "pin", topicId: tema.topicId, pinned: !tema.pinned });
  },
  onToggleClose: async () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) await temaMuvelet({ action: "close", topicId: tema.topicId, closed: tema.status !== "closed" });
  },
  // Szűrés státusz és címkék szerint (2026-10-16): csak kliensoldali nézet, a szerver nem vesz részt.
  onFilterWorkflow: (allapot) => setChat({ forumSzuro: { ...(state.forumSzuro || { tags: [] }), workflow: allapot } }),
  onFilterTag: (id) => setChat({ forumSzuro: szuroCimkeValtas(state.forumSzuro, id) }),
  onFilterClear: () => setChat({ forumSzuro: { workflow: "", tags: [] } }),
  // Munkafolyamat-státusz (a téma nyitója / admin / témafelelős): azonnal mentődik, mint a kitűzés.
  onSetWorkflow: async (allapot) => {
    if (state.currentTopicId) await temaMuvelet({ action: "setWorkflow", topicId: state.currentTopicId, workflow: allapot });
  },
  // Hozzászólás-címkék (2026-10-16): szűrő a témán belül; a jelölés vázlata a Mentésig a modellben él.
  onPostFilterTag: (id) => {
    const ki = state.postSzuro || [];
    setChat({ postSzuro: ki.includes(id) ? ki.filter((x) => x !== id) : [...ki, id] });
  },
  onPostFilterClear: () => setChat({ postSzuro: [] }),
  onToggleTopicMenu: () => setChat({ temaMenu: state.temaMenu !== true }),
  // Státusz-előzmény lapja (2026-10-18): mindenkinek megnyílik (olvasásra); a módosítás űrlapja csak a jogosultnak jelenik meg (a szerver is ellenőrzi).
  onOpenWorkflowPanel: () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) setChat({ wfPanel: { workflow: tema.workflow || "", note: tema.workflowNote || "", assignee: tema.workflowAssignee || "", due: tema.workflowDue || "", busy: false, error: null } });
  },
  onWorkflowPanelChange: (mezo, ertek) => { if (state.wfPanel) state.wfPanel[mezo] = ertek; },
  onWorkflowPanelClose: () => setChat({ wfPanel: null }),
  onWorkflowPanelSave: async () => {
    const v = state.wfPanel;
    if (!v || v.busy || !state.currentTopicId) return;
    setChat({ wfPanel: { ...v, busy: true, error: null } });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setWorkflow", topicId: state.currentTopicId, workflow: v.workflow, note: String(v.note || "").trim(), assignee: String(v.assignee || "").trim(), due: String(v.due || "") });
      // A panel nyitva marad: a frissített előzmény (a téma figyelőjén át) rögtön látszik; a vázlat a mentett értéket mutatja.
      setChat({ wfPanel: { ...state.wfPanel, busy: false, error: null } });
    } catch (err) {
      log.error("[fórum] státusz mentése:", err);
      setChat({ wfPanel: { ...state.wfPanel, busy: false, error: forumHiba(err) } });
    }
  },
  // Forrásmegjelölés (2026-10-18): a vázlat a Mentésig a modellben él; a gépelés nem rajzol újra.
  onEditSource: () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) setChat({ sourceDraft: { ...(tema.source || {}) }, sourceError: null });
  },
  onSourceChange: (mezo, ertek) => { if (state.sourceDraft) state.sourceDraft[mezo] = ertek; },
  onSourceCancel: () => setChat({ sourceDraft: null, sourceError: null }),
  onSourceSave: async () => {
    if (!state.currentTopicId || state.sourceBusy || !state.sourceDraft) return;
    setChat({ sourceBusy: true, sourceError: null });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setSource", topicId: state.currentTopicId, source: state.sourceDraft });
      setChat({ sourceBusy: false, sourceDraft: null });
    } catch (err) {
      log.error("[fórum] forrásmegjelölés mentése:", err);
      setChat({ sourceBusy: false, sourceError: forumHiba(err) });
    }
  },
  // Ellenőrzési pecsét (2026-10-18): a szerver a hozzászólásból olvassa ki az ellenőrzött szöveget; itt csak a nyelvet adjuk meg.
  // A gomb előbb a megjegyzés-mezőt nyitja (a vázlat a Pecsétig a modellben él; a gépelés nem rajzol újra); a megerősítés küldi el.
  onReviewStart: (messageId, lang, seen) => setChat({ postReviewing: { messageId, lang, seen, note: "", busy: false, error: null } }),
  onReviewNote: (ertek) => { if (state.postReviewing) state.postReviewing.note = ertek; },
  onReviewCancel: () => setChat({ postReviewing: null }),
  onReviewConfirm: async () => {
    const v = state.postReviewing;
    if (!v || v.busy || !state.currentTopicId) return;
    setChat({ postReviewing: { ...v, busy: true, error: null } });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setPostReview", topicId: state.currentTopicId, messageId: v.messageId, lang: v.lang, seen: v.seen, note: String(v.note || "").trim() });
      setChat({ postReviewing: null });
    } catch (err) {
      log.error("[fórum] ellenőrzési pecsét:", err);
      setChat({ postReviewing: { ...v, busy: false, error: forumHiba(err, "message.reviewFailed") } });
    }
  },
  onRemoveReview: async (messageId, lang, byUid) => {
    if (!state.currentTopicId) return;
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setPostReview", topicId: state.currentTopicId, messageId, lang, remove: true, ...(byUid ? { byUid } : {}) });
    } catch (err) {
      log.error("[fórum] ellenőrzés visszavonása:", err);
      setChat({ chatErrorKey: null, chatErrorText: forumHiba(err, "message.reviewFailed") });
    }
  },
  // Fordításjavaslat jóváhagyással (2026-10-19): a szerkesztő és a lista vázlata a modellben él; a döntést mindig a szerver hozza.
  onFixOpen: (messageId, lang, mostani) => setChat({ fixEditor: { messageId, lang, text: mostani, reason: "", busy: false, error: null } }),
  onFixChange: (mezo, ertek) => { if (state.fixEditor) state.fixEditor[mezo] = ertek; },
  onFixCancel: () => setChat({ fixEditor: null }),
  onFixSend: async () => {
    const v = state.fixEditor;
    if (!v || v.busy) return;
    setChat({ fixEditor: { ...v, busy: true, error: null } });
    try {
      await forditasJavaslat({ roomId: state.currentRoomId, messageId: v.messageId, action: "propose", lang: v.lang, text: String(v.text || ""), reason: String(v.reason || "") });
      setChat({ fixEditor: null });
      await frissitsdAJavaslatokat(v.messageId, v.lang, true);
    } catch (err) {
      log.error("[fordításjavaslat] küldés:", err);
      setChat({ fixEditor: { ...v, busy: false, error: forumHiba(err, "message.fixFailed") } });
    }
  },
  // Átirat (2026-10-19): a következő hozzászólás átirat-e (és milyen nyelvű); a javító szerkesztő vázlata a modellben él, a döntést a szerver hozza.
  onAtiratToggle: () => {
    state.pendingSendId = null; // más tartalom-fajta = új küldési szándék
    setChat({ atiratNyelv: state.atiratNyelv ? null : alapAtiratNyelv(CHAT_LANGUAGES, state.contentLang) });
  },
  onAtiratLang: (kod) => {
    state.pendingSendId = null;
    setChat({ atiratNyelv: kod });
  },
  onAtiratOpen: (messageId, mostani) => setChat({ atiratSzerk: { messageId, text: mostani, note: "", busy: false, error: null } }),
  onAtiratChange: (mezo, ertek) => { if (state.atiratSzerk) state.atiratSzerk[mezo] = ertek; },
  onAtiratCancel: () => setChat({ atiratSzerk: null }),
  // Átirat modern írásmódra (v205): egy kattintás; az eredmény új AI-hozzászólásként érkezik a szoba figyelésén át.
  onAtiratModernize: async (messageId) => {
    const mostani = state.modernAllapot;
    if (mostani && mostani.busy) return;
    setChat({ modernAllapot: { messageId, busy: true, error: null } });
    try {
      await atiratModernizalas({ roomId: state.currentRoomId, messageId });
      setChat({ modernAllapot: null });
    } catch (err) {
      log.error("[átirat] modernizálás:", err);
      setChat({ modernAllapot: { messageId, busy: false, error: forumHiba(err, "atirat.modernizeFailed") } });
    }
  },
  onAtiratSave: async () => {
    const v = state.atiratSzerk;
    if (!v || v.busy) return;
    setChat({ atiratSzerk: { ...v, busy: true, error: null } });
    try {
      await atiratJavitas({ roomId: state.currentRoomId, messageId: v.messageId, text: String(v.text || ""), note: String(v.note || "").trim() });
      setChat({ atiratSzerk: null });
    } catch (err) {
      log.error("[átirat] javítás:", err);
      setChat({ atiratSzerk: { ...v, busy: false, error: forumHiba(err, "atirat.failed") } });
    }
  },
  onFixToggle: async (messageId, lang) => {
    if (state.fixList && state.fixList.messageId === messageId && state.fixList.lang === lang) { setChat({ fixList: null }); return; }
    await frissitsdAJavaslatokat(messageId, lang, true);
  },
  onFixNote: (javaslatId, ertek) => { if (state.fixList) state.fixList.jegyzetek = { ...(state.fixList.jegyzetek || {}), [javaslatId]: ertek }; },
  onFixDecide: async (messageId, lang, javaslatId, dontes) => {
    const lista = state.fixList;
    if (!lista || lista.busy) return;
    setChat({ fixList: { ...lista, busy: true, hiba: null } });
    try {
      const jegyzet = String((lista.jegyzetek && lista.jegyzetek[javaslatId]) || "").trim();
      const r = await forditasJavaslat({ roomId: state.currentRoomId, messageId, action: "decide", suggestionId: javaslatId, decision: dontes, ...(jegyzet ? { note: jegyzet } : {}) });
      await frissitsdAJavaslatokat(messageId, lang, false, r && r.outcome === "expired" ? t(state.uiLang, "message.fixExpired") : null);
    } catch (err) {
      log.error("[fordításjavaslat] elbírálás:", err);
      setChat({ fixList: { ...state.fixList, busy: false, hiba: forumHiba(err, "message.fixFailed") } });
    }
  },
  onFixWithdraw: async (messageId, lang, javaslatId) => {
    const lista = state.fixList;
    if (!lista || lista.busy) return;
    setChat({ fixList: { ...lista, busy: true, hiba: null } });
    try {
      await forditasJavaslat({ roomId: state.currentRoomId, messageId, action: "withdraw", suggestionId: javaslatId });
      await frissitsdAJavaslatokat(messageId, lang, false);
    } catch (err) {
      log.error("[fordításjavaslat] visszavonás:", err);
      setChat({ fixList: { ...state.fixList, busy: false, hiba: forumHiba(err, "message.fixFailed") } });
    }
  },
  // Alszoba megnyitása a szülőszoba képernyőjéről (2026-10-18).
  onOpenSubRoom: (roomId) => { if (roomId && roomId !== state.currentRoomId) openRoom(roomId); },
  onOpenPostTags: (messageId) => {
    const uzenet = (state.messages || []).find((x) => x.messageId === messageId);
    if (uzenet) setChat({ postTagging: { messageId, tags: Array.isArray(uzenet.tags) ? [...uzenet.tags] : [], busy: false, error: null } });
  },
  onPostTagToggle: (id, be) => {
    const v = state.postTagging;
    if (!v) return;
    v.tags = be ? [...new Set([...v.tags, id])] : v.tags.filter((x) => x !== id);
  },
  onPostTagsCancel: () => setChat({ postTagging: null }),
  // Kapcsolatok (2026-10-18): a vázlat a Mentésig a modellben él; a választás nem rajzol újra.
  onOpenPostLinks: (messageId) => {
    const uzenet = (state.messages || []).find((x) => x.messageId === messageId);
    if (uzenet) setChat({ postLinking: { messageId, basedOn: uzenet.basedOn || "", supersedes: uzenet.supersedes || "", orig: { basedOn: uzenet.basedOn || "", supersedes: uzenet.supersedes || "" }, busy: false, error: null } });
  },
  onPostLinksChange: (mezo, ertek) => { if (state.postLinking) state.postLinking[mezo] = ertek; },
  onPostLinksCancel: () => setChat({ postLinking: null }),
  onPostLinksSave: async () => {
    const v = state.postLinking;
    if (!v || v.busy || !state.currentTopicId) return;
    const adat = {};
    for (const mezo of ["basedOn", "supersedes"]) if ((v[mezo] || "") !== (v.orig[mezo] || "")) adat[mezo] = v[mezo] || "";
    if (Object.keys(adat).length === 0) { setChat({ postLinking: null }); return; }
    setChat({ postLinking: { ...v, busy: true, error: null } });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setPostLinks", topicId: state.currentTopicId, messageId: v.messageId, ...adat });
      setChat({ postLinking: null });
    } catch (err) {
      log.error("[fórum] hozzászólás-kapcsolatok mentése:", err);
      setChat({ postLinking: { ...v, busy: false, error: forumHiba(err) } });
    }
  },
  onPostTagsSave: async () => {
    const v = state.postTagging;
    if (!v || v.busy || !state.currentTopicId) return;
    setChat({ postTagging: { ...v, busy: true, error: null } });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setPostTags", topicId: state.currentTopicId, messageId: v.messageId, tags: v.tags });
      setChat({ postTagging: null });
    } catch (err) {
      log.error("[fórum] hozzászólás-címkék mentése:", err);
      setChat({ postTagging: { ...v, busy: false, error: forumHiba(err) } });
    }
  },
  // Címkék a témán: a jelölések vázlatban élnek, a Mentés küldi el.
  onEditTags: () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (tema) setChat({ tagsDraft: [...(tema.tags || [])], tagsError: null });
  },
  onTagsToggle: (id, be) => {
    if (!state.tagsDraft) return;
    state.tagsDraft = be ? [...new Set([...state.tagsDraft, id])] : state.tagsDraft.filter((x) => x !== id);
  },
  onTagsCancel: () => setChat({ tagsDraft: null, tagsError: null }),
  onTagsSave: async () => {
    if (!state.currentTopicId || state.tagsBusy || !state.tagsDraft) return;
    setChat({ tagsBusy: true, tagsError: null });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setTags", topicId: state.currentTopicId, tags: state.tagsDraft });
      setChat({ tagsBusy: false, tagsDraft: null });
    } catch (err) {
      log.error("[fórum] címkék mentése:", err);
      setChat({ tagsBusy: false, tagsError: forumHiba(err) });
    }
  },
  // A szoba címkekatalógusa (admin): a vázlat a szerkesztő alatt él; a gépelés nem rajzol újra.
  onCatalogOpen: () => {
    const szoba = (state.rooms || []).find((r) => r && r.roomId === state.currentRoomId);
    setChat({ katalogusDraft: ((szoba && szoba.tagCatalog) || []).map((c) => ({ ...c, names: { ...(c.names || {}) } })), katalogusError: null, katalogusStatus: null });
  },
  onCatalogGroup: (i, csoport) => {
    if (state.katalogusDraft && state.katalogusDraft[i]) {
      setChat({ katalogusDraft: state.katalogusDraft.map((c, k) => (k === i ? { ...c, group: csoport } : c)), katalogusStatus: null });
    }
  },
  onCatalogName: (i, ertek) => { if (state.katalogusDraft && state.katalogusDraft[i]) state.katalogusDraft[i].name = ertek; },
  onCatalogLangName: (i, kod, ertek) => {
    const c = state.katalogusDraft && state.katalogusDraft[i];
    if (c) c.names = { ...(c.names || {}), [kod]: ertek };
  },
  onCatalogAdd: (csoport) => {
    if (state.katalogusDraft) setChat({ katalogusDraft: [...state.katalogusDraft, { group: csoport, name: "", names: {} }], katalogusStatus: null });
  },
  onCatalogRemove: (i) => {
    if (state.katalogusDraft) setChat({ katalogusDraft: state.katalogusDraft.filter((_, k) => k !== i), katalogusStatus: null });
  },
  onCatalogSuggest: async (i) => {
    const vazlat = state.katalogusDraft;
    const c = vazlat && vazlat[i];
    if (!c || !String(c.name || "").trim() || state.katalogusBusy) return;
    // Csak a HIÁNYZÓ nyelvek; a már kitöltött (kézzel javított) nevet a javaslat nem írja felül.
    const kodok = Object.keys(CHAT_LANGUAGES).filter((k) => !String((c.names || {})[k] || "").trim());
    if (kodok.length === 0) {
      // Nincs mit fordítani - ezt ki kell mondani, különben a gomb "nem csinál semmit"-nek látszik (iPhone-os jelzés).
      setChat({ katalogusError: null, katalogusStatus: t(state.uiLang, "forum.catalogAllFilled") });
      return;
    }
    setChat({ katalogusBusy: true, katalogusError: null, katalogusStatus: t(state.uiLang, "forum.catalogTranslating") });
    try {
      const javaslat = await suggestRoomNames(c.name.trim(), kodok, undefined);
      let kitoltve = 0;
      if (state.katalogusDraft === vazlat) {
        for (const [kod, ertek] of Object.entries(javaslat)) {
          if (!String((c.names || {})[kod] || "").trim()) { c.names = { ...(c.names || {}), [kod]: ertek }; kitoltve += 1; }
        }
      }
      setChat({ katalogusBusy: false, katalogusDraft: state.katalogusDraft, katalogusStatus: t(state.uiLang, "forum.catalogTranslated", { n: kitoltve }) });
    } catch (err) {
      log.error("[fórum] címkenév-javaslat:", err);
      setChat({ katalogusBusy: false, katalogusError: forumHiba(err, "forum.catalogSuggestFailed") });
    }
  },
  onCatalogCancel: () => setChat({ katalogusDraft: null, katalogusError: null, katalogusStatus: null }),
  onCatalogSave: async () => {
    if (!state.katalogusDraft || state.katalogusBusy) return;
    // Az üres nevű sorok (a "+ Hozzáadás" után kitöltetlenül maradtak) nem kerülnek mentésre.
    const lista = state.katalogusDraft
      .filter((c) => String(c.name || "").trim() !== "")
      .map((c) => ({ ...(c.id ? { id: c.id } : {}), group: c.group, name: c.name.trim(), names: cimekKuldesre(c.names) }));
    setChat({ katalogusBusy: true, katalogusError: null, katalogusStatus: null });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setCatalog", catalog: lista });
      setChat({ katalogusBusy: false, katalogusDraft: null, katalogusStatus: null });
    } catch (err) {
      log.error("[fórum] címkekatalógus mentése:", err);
      setChat({ katalogusBusy: false, katalogusError: forumHiba(err) });
    }
  },
  // Címek nyelvenként (admin, 2026-10-09): fix, javított címek a rendszer MINDEN nyelvére.
  onEditTitles: () => setChat({ titlesDraft: {}, titlesError: null, titlesStatus: null }),
  onTitlesChange: (kod, ertek) => { if (state.titlesDraft) state.titlesDraft[kod] = ertek; },
  onTitlesCancel: () => setChat({ titlesDraft: null, titlesError: null, titlesStatus: null }),
  onTitlesSave: async () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (!tema || state.titlesBusy) return;
    // A szerkesztett mezők + a már meglévő kézi címek (amihez nem nyúlt) = a TELJES lista; az üres mező törli.
    const teljes = { ...(tema.titleManual || {}), ...(state.titlesDraft || {}) };
    setChat({ titlesBusy: true, titlesError: null, titlesStatus: null });
    try {
      await topicAction({ roomId: state.currentRoomId, action: "setTitles", topicId: tema.topicId, titles: cimekKuldesre(teljes) });
      setChat({ titlesBusy: false, titlesDraft: {}, titlesStatus: t(state.uiLang, "forum.titlesSaved") });
    } catch (err) {
      log.error("[fórum] címek mentése:", err);
      setChat({ titlesBusy: false, titlesError: (err && err.message) || t(state.uiLang, "forum.manageFailed") });
    }
  },
  // Téma átalakítása önálló főszobává (admin, 2026-10-15): megerősítés után a szerver átköltözteti, majd az új szoba nyílik.
  onConvertToRoom: async () => {
    const roomId = state.currentRoomId;
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    const szoba = (state.rooms || []).find((r) => r && r.roomId === roomId);
    if (!tema || !szoba || state.atalakitasBusy) return;
    const kerdes = t(state.uiLang, "forum.convertConfirm", {
      title: temaCim(tema, state.contentLang), n: tema.postCount, members: (szoba.memberIds || []).length,
    });
    if (!window.confirm(kerdes)) return;
    setChat({ atalakitasBusy: true, chatErrorKey: null, chatErrorText: t(state.uiLang, "forum.convertBusy") });
    try {
      const r = await convertTopicToRoom({ roomId, topicId: tema.topicId });
      setChat({ atalakitasBusy: false, chatErrorText: null });
      // Az új szoba a szobalista élő figyelésével érkezik; ha még nincs ott, egy pillanat múlva nyitjuk.
      const nyisd = (probak) => {
        if ((state.rooms || []).some((x) => x && x.roomId === r.roomId)) openRoom(r.roomId, r.topicId);
        else if (probak > 0) setTimeout(() => nyisd(probak - 1), 500);
      };
      nyisd(20);
    } catch (err) {
      log.error("[fórum] téma átalakítása:", err);
      setChat({ atalakitasBusy: false, chatErrorText: t(state.uiLang, "forum.convertFailed", { error: (err && err.message) || "?" }) });
    }
  },
  onOpenMovedTopic: (tema) => {
    if (tema && tema.movedToRoomId && (state.rooms || []).some((x) => x && x.roomId === tema.movedToRoomId)) openRoom(tema.movedToRoomId, tema.movedToTopicId || undefined);
    else setChat({ chatErrorKey: "forum.movedNotMember" });
  },
  onToggleWatch: async () => {
    const tema = (state.topics || []).find((x) => x.topicId === state.currentTopicId);
    if (!tema || !state.user) return;
    const most = tema.watchers.includes(state.user.uid);
    try {
      await forumAction({ action: "setWatch", roomId: state.currentRoomId, topicId: tema.topicId, watching: !most });
    } catch (err) {
      log.error("[fórum] figyelés:", err);
    }
  },
  onToggleRoomMute: async () => {
    const szoba = (state.rooms || []).find((r) => r && r.roomId === state.currentRoomId);
    if (!szoba || !state.user) return;
    const nemitva = Array.isArray(szoba.mutedBy) && szoba.mutedBy.includes(state.user.uid);
    try {
      await forumAction({ action: "setRoomMute", roomId: szoba.roomId, muted: !nemitva });
    } catch (err) {
      log.error("[fórum] némítás:", err);
    }
  },
  onEmailFrequency: async (frequency) => {
    try {
      const r = await forumAction({ action: "setEmail", frequency });
      setChat({ emailFrequency: r.emailFrequency });
    } catch (err) {
      log.error("[fórum] e-mail beállítás:", err);
    }
  },
};

const chatHandlers = {
  onRetryList: () => listaUjraprobalasa(),
  ...forumKezelok,
  onImageSelected: async (file) => {
    setChat({ chatErrorKey: null, chatErrorText: null });
    // PDF-melléklet (2026-10-10): kis PDF (számla) - nincs tömörítés, csak ellenőrzés; kép mellett nem csatolható.
    if (pdfE(file)) {
      const eredmeny = await elokeszitPdf(file);
      if (!eredmeny.ok) {
        setChat({ chatErrorKey: eredmeny.hibaKulcs, chatErrorText: null });
        return;
      }
      if (state.pendingImage) releaseImage(state.pendingImage);
      state.pendingSendId = null; // új melléklet = új küldési szándék
      setChat({ pendingImage: null, pendingFile: eredmeny.kiegeszito, uploadProgress: null });
      return;
    }
    // Új kép: az esetleg csatolt PDF helyét átveszi (egy üzenethez egy melléklet).
    if (state.pendingFile) setChat({ pendingFile: null });
    try {
      const keszKep = await prepareImage(file);
      // TÖBB KÉP (v211): ha már van kiválasztott kép, az újabb HOZZÁADÓDIK (legfeljebb MAX_KEPEK-ig), nem cseréli le.
      const elsoKep = state.pendingImage;
      if (elsoKep) {
        const tovabbiak = Array.isArray(elsoKep.extras) ? elsoKep.extras : [];
        if (1 + tovabbiak.length >= MAX_KEPEK) {
          releaseImage(keszKep);
          setChat({ chatErrorKey: "image.maxCount" });
          return;
        }
        // Az eredeti ("@2") változat többképes bejegyzésnél nem használható: vissza a kicsinyítettre.
        if (elsoKep.eredeti) await kepValtozat(elsoKep, false);
        elsoKep.extras = [...tovabbiak, keszKep];
        state.pendingSendId = null; // új kép = új küldési szándék
        setChat({ pendingImage: elsoKep, uploadProgress: null });
        return;
      }
      // A korábbi előnézet elengedése, ha volt - enélkül memóriát
      // szivárogtatnánk minden képcserénél.
      if (state.pendingImage) releaseImage(state.pendingImage);
      state.pendingSendId = null; // új kép = új küldési szándék
      setChat({ pendingImage: keszKep, uploadProgress: null });
      kepSzinkron(); // ha a "@2" már be van gépelve, rögtön az eredeti változatra vált
      log.debug(
        `[kép] ${Math.round(keszKep.originalSize / 1024)} kB → ${Math.round(keszKep.compressedSize / 1024)} kB`
      );
    } catch (err) {
      log.error("[kép] előkészítés hiba:", err);
      const uzenet = String(err.message || "");
      setChat({
        chatErrorKey: uzenet.includes("túl nagy") ? "image.tooLarge" : "image.notAnImage",
        // A HEIC-hibánál a pontos, teendőt is tartalmazó üzenet többet ér,
        // mint az általános "ez nem kép" felirat.
        chatErrorText: uzenet.includes("HEIC") ? uzenet : null,
      });
    }
  },

  onRemoveFile: () => {
    state.pendingSendId = null;
    setChat({ pendingFile: null, uploadProgress: null });
  },

  // A `index`: melyik képet kell eltávolítani (0 = az első; v211: több kép). Index nélkül (régi hívás) az első kép megy.
  onRemoveImage: (index) => {
    const elso = state.pendingImage;
    const sorszam = typeof index === "number" ? index : 0;
    state.pendingSendId = null;
    if (!elso) { setChat({ pendingImage: null, uploadProgress: null }); return; }
    const tovabbiak = Array.isArray(elso.extras) ? elso.extras : [];
    if (sorszam > 0 && sorszam <= tovabbiak.length) {
      releaseImage(tovabbiak[sorszam - 1]);
      elso.extras = tovabbiak.filter((_, i) => i !== sorszam - 1);
      setChat({ pendingImage: elso, uploadProgress: null });
      return;
    }
    // Az első kép törlése: a következő kép lép a helyére (a többi hozzá tartozik tovább).
    elso.extras = [];
    releaseImage(elso);
    const [kovetkezo, ...maradek] = tovabbiak;
    if (kovetkezo) kovetkezo.extras = maradek;
    setChat({ pendingImage: kovetkezo || null, uploadProgress: null });
  },

  onEnableNotifications: async () => {
    const eredmeny = await enableNotifications(registerPushToken, state.user && state.user.uid);
    setChat({ offerNotifications: false });

    // FONTOS, VALÓS HIBÁBÓL TANULVA: a kudarc korábban CSAK a fejlesztői
    // naplóba került. A felhasználó megnyomta a "Bekapcsolom" gombot, a sáv
    // eltűnt, és abban a hitben maradt, hogy működik - közben soha nem
    // kapott egyetlen értesítést sem. A hibát ezért kimondjuk.
    if (!eredmeny.ok) {
      log.debug("[push] nem sikerült engedélyezni:", eredmeny.reason);
      setChat({
        chatErrorKey: eredmeny.reason === "denied" ? "notif.blocked" : "notif.failed",
      });
    }
  },
  onDismissNotifications: () => {
    markOfferDismissed();
    setChat({ offerNotifications: false });
  },
  onOpenProfile: () => {
    // A saját tagsági kártya (v166): ha van kiadott száma, a profil tetején látszik; a hiba nem akadályozza a profilt.
    state.membershipCard = null;
    getMyMembershipCard().then((k) => { state.membershipCard = k; if (state.overlay === "profile") render(); }).catch((err) => { log.error("[kártya] a saját kártya nem töltődött be:", err); });
    // A saját naplózott névváltozásaim (D-010, v185): csak akkor látszik, ha a napló be van kapcsolva; a hiba nem akadályozza a profilt.
    state.nevNaplo = null;
    getMyNameHistory().then((h) => { state.nevNaplo = h; if (state.overlay === "profile") render(); }).catch((err) => { log.error("[névnapló] a saját előzmény nem töltődött be:", err); });
    panelState = {
      ...panelState,
      statusKey: null,
      errorKey: null,
      profileName: state.profileName,
      profileNameLatn: state.profileNameLatn || "",
      profileNameJa: state.profileNameJa || "",
      profileNameZh: state.profileNameZh || "",
      profileNameKo: state.profileNameKo || "",
      profileNameCyr: state.profileNameCyr || "",
      profileNameEl: state.profileNameEl || "",
      profileLang: state.contentLang,
      suggesting: false,
      emailStatusKey: null,
      emailErrorKey: null,
      pushStatusKey: null,
      pushErrorKey: null,
      pushBusy: false,
    };
    setOverlay("profile");
    // Az e-mail összefoglaló beállítása a fórum-állapotban van: ha még nem töltöttük be (nem nyitott fórum-szobát), most.
    if (!state.forumAllapotBetoltve) forumAllapotBetoltese();
  },
  onReplyTo: (messageId) => {
    const msg = (state.messages || []).find((m) => m.messageId === messageId);
    if (!msg) return;

    // A jelzéshez a küldés pillanatában rögzített adatokból dolgozunk -
    // ugyanazokból, amiket a szerver is elment az idézetbe.
    const szoveg = (msg.text || "").trim();
    setChat({
      replyTo: {
        messageId,
        senderName: msg.senderName || "",
        senderNameLatn: msg.senderNameLatn || "",
        senderNameJa: msg.senderNameJa || "",
        senderNameZh: msg.senderNameZh || "",
        senderNameKo: msg.senderNameKo || "",
        senderNameCyr: msg.senderNameCyr || "",
        senderNameEl: msg.senderNameEl || "",
        senderDeleted: msg.senderDeleted === true,
        excerpt: szoveg || (msg.image && (msg.image.path || msg.image.url) ? t(state.uiLang, "reply.image") : ""),
      },
    });
    // A beviteli mezőbe ugrunk, hogy rögtön írni lehessen - de csak
    // asztali gépen. Mobilon a fókusz felhozná a billentyűzetet, ami
    // eltakarná azt az üzenetet, amire a felhasználó épp válaszolni akar.
    const input = document.getElementById("message-input");
    if (input && !isMobilKeplet()) input.focus();
  },
  onCancelReply: () => setChat({ replyTo: null }),

  // --- Üzenet szerkesztése és törlése (2026-10-02) ---
  //
  // Az IDŐKERETET és a jogosultságot a szerver kényszeríti ki
  // (functions/src/messageActions.js) - itt csak annyit ellenőrzünk, hogy
  // egyáltalán saját, nem törölt üzenetről van-e szó, hogy a szerkesztő
  // mező ne jelenjen meg olyan üzenetnél, aminél úgyis elutasítaná a
  // szerver. A pontos (24 órás szerkesztési / 15 perces törlési) határidőt szándékosan NEM számoljuk
  // újra itt - a kliens órája eltérhet a szerverétől, és egy hamis "még
  // van időd" vagy "lejárt" üzenet rosszabb, mint a szerver válasza.
  onStartEdit: (messageId) => {
    const msg = (state.messages || []).find((m) => m.messageId === messageId);
    if (!msg || msg.senderId !== state.user?.uid || msg.deleted === true) return;
    setChat({
      editingMessageId: messageId,
      editingText: msg.text || "",
      editingBusy: false,
      editingErrorKey: null,
      editingErrorText: null,
    });
  },
  onEditTextChange: (value) => {
    state.editingText = value;
  },
  // Cetli (2026-10-07): a fejléc ✉ gombja újranyitja a felugró ablakot; az üzenet "Cetli" gombja az író ablakot.
  onOpenNotes: () => cetliOlvasoFrissitese(null),
  // Közlemény (2026-10-25): a fejléc 📌 gombja újranyitja a felugró ablakot.
  onOpenAnnouncements: () => kozlemenyOlvasoFrissitese(null),
  // Kezdőlap (2026-10-25, a titkár #86): állandó bejárat minden szobából.
  onOpenHome: () => kezdolapMegnyitasa(),
  // Az ajánlott tájékoztatóra ugrás (v157): az eredeti hozzászólásra, a törzsszöveg másolása nélkül.
  // A hirdetmény fejléce összecsukható / kinyitható (v158): összecsukva egysoros sáv marad ("hol vagyok" jelzés + menü-gomb).
  onBejaratToggle: (zarva) => { setChat({ bejaratZarva: zarva === true }); },
  // Egy "×"-szel TELJESEN bezárható a hirdetmény fejléce (v171, Tamás: "egyszerűbben bezárható"); a következő belépésig nem jelenik meg újra.
  onBejaratClose: () => { setChat({ bejaratBezarva: true }); },
  onJumpPinned: (messageId) => {
    // Az ugrás után a hirdetmény fejléce összecsukódik (v164), hogy a hozzászólás a teljes magasságban olvasható legyen.
    if (state.bejaratZarva !== true) setChat({ bejaratZarva: true });
    if (state.currentRoomId && messageId) ugorjHivatkozottUzenethez(state.currentRoomId, state.currentTopicId || null, messageId);
  },
  onOpenNoteComposer: (messageId) => {
    const msg = (state.messages || []).find((m) => m.messageId === messageId);
    if (!msg || !msg.senderId || msg.senderId === state.user.uid) return;
    // Ugyanazt a kérésazonosítót használjuk, amíg a szöveg nem változik: egy megszakadt, de valójában
    // sikeres küldés újrapróbálása így nem készít második cetlit.
    let utolso = null;
    nyissCetliIrot({
      uiLang: state.uiLang,
      cimzettNev: feladoNev(msg, state.contentLang, state.uiLang),
      onKuld: async (text) => {
        if (!utolso || utolso.text !== text) utolso = { text, id: newClientMessageId() };
        await sendNote({ toUid: msg.senderId, text, requestId: utolso.id });
      },
      hibaSzoveg: ismertCetliHiba,
    });
  },
  // Eredeti / fordítás átváltása (2026-10-07): csak megjelenítés, csak ennek a tagnak a nézetén.
  onToggleOriginal: (messageId) => {
    const kovetkezo = new Set(state.showOriginalIds);
    if (kovetkezo.has(messageId)) kovetkezo.delete(messageId);
    else kovetkezo.add(messageId);
    setChat({ showOriginalIds: kovetkezo });
  },
  // Egymás mellett (2026-10-19): az eredeti és a fordítás két oszlopban; a tag beállítása, az eszközén megmarad.
  onTogglePair: () => {
    const uj = state.egymasMellett !== true;
    try { localStorage.setItem(EGYMAS_MELLETT_KULCS, uj ? "1" : "0"); } catch (e) { /* tiltott tárhely: a beállítás csak erre a munkamenetre él */ }
    setChat({ egymasMellett: uj });
  },
  // Kényszerített újrafordítás (2026-10-07, tagi kérésre): a szoba bármely tagja kérheti, ha a
  // fordítás nem sikerült. Az eredmény a Firestore-figyelőn át érkezik (az üzenet állapota
  // "pending"-re vált, majd a fordítás megjelenik) - itt csak a kérést küldjük, és a gombot
  // tartjuk le addig, hogy a dupla kattintás ne indítson két kérést.
  // Karakterszavazó (2026-10-30): betöltés, szavazás / visszavonás, lezárás. Az állapot üzenetenként él (state.szavazok).
  onPollLoad: async (messageId, ujra) => {
    const roomId = state.currentRoomId;
    const regi = (state.szavazok || {})[messageId];
    if (!messageId || !roomId || (regi && regi.fazis === "toltes") || (regi && regi.fazis === "kesz" && ujra !== true)) return;
    setChat({ szavazok: { ...state.szavazok, [messageId]: { fazis: "toltes" } } });
    try {
      const r = await pollVote({ action: "get", roomId, messageId });
      setChat({ szavazok: { ...state.szavazok, [messageId]: { fazis: "kesz", ...r } } });
    } catch (err) {
      log.error("[szavazó] a betöltés nem sikerült:", err);
      setChat({ szavazok: { ...state.szavazok, [messageId]: { fazis: "hiba" } } });
    }
  },
  onPollVote: async (messageId, n, answer) => {
    const roomId = state.currentRoomId;
    const s = (state.szavazok || {})[messageId];
    if (!messageId || !roomId || !s || s.fazis !== "kesz" || s.mentes === "mentes") return;
    setChat({ szavazok: { ...state.szavazok, [messageId]: { ...s, mentes: "mentes" } } });
    try {
      const r = await pollVote({ action: "vote", roomId, messageId, n, answer });
      const aktualis = state.szavazok[messageId] || s;
      setChat({ szavazok: { ...state.szavazok, [messageId]: { ...aktualis, mine: r.mine, mentes: "ok" } } });
    } catch (err) {
      log.error("[szavazó] a mentés nem sikerült:", err);
      const aktualis = state.szavazok[messageId] || s;
      setChat({ szavazok: { ...state.szavazok, [messageId]: { ...aktualis, mentes: "hiba" } } });
    }
  },
  onPollClose: async (messageId, closed) => {
    const roomId = state.currentRoomId;
    const s = (state.szavazok || {})[messageId];
    if (!messageId || !roomId || !s || s.fazis !== "kesz" || s.mentes === "mentes") return;
    setChat({ szavazok: { ...state.szavazok, [messageId]: { ...s, mentes: "mentes" } } });
    try {
      await pollVote({ action: "close", roomId, messageId, closed });
      const r = await pollVote({ action: "get", roomId, messageId });
      setChat({ szavazok: { ...state.szavazok, [messageId]: { fazis: "kesz", ...r } } });
    } catch (err) {
      log.error("[szavazó] a lezárás nem sikerült:", err);
      const aktualis = state.szavazok[messageId] || s;
      setChat({ szavazok: { ...state.szavazok, [messageId]: { ...aktualis, mentes: "hiba" } } });
    }
  },
  onRetryTranslation: async (messageId) => {
    const roomId = state.currentRoomId;
    if (!messageId || !roomId || state.retryBusyIds.has(messageId)) return;
    // Ha a néző nyelvén a fordítást ember javította (elfogadott javaslat), az újrafordítás felülírná: előbb megerősítést kérünk (a régi szöveg az előzményben marad).
    const uzenetAdat = (state.messages || []).find((x) => x.messageId === messageId);
    const nezoNyelv = state.contentLang || state.uiLang;
    let overrideHuman = false;
    if (uzenetAdat && uzenetAdat.translationHuman && uzenetAdat.translationHuman[nezoNyelv] === true) {
      if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "message.retranslateHumanWarn"))) return;
      overrideHuman = true;
    }
    const foglalt = new Set(state.retryBusyIds);
    foglalt.add(messageId);
    setChat({ retryBusyIds: foglalt });
    let elindult = false;
    try {
      await retryTranslation({ roomId, messageId, requestId: newClientMessageId(), overrideHuman });
      elindult = true;
    } catch (err) {
      log.error("[üzenet] újrafordítás kérése hiba:", err);
      const reszletes = ismertUzenetMuveletHiba(err);
      setChat({
        chatErrorKey: reszletes ? null : "message.retryFailed",
        chatErrorText: reszletes,
      });
    } finally {
      if (elindult) {
        // A kérés csak sorba állította a fordítást: a gomb "folyamatban" marad, amíg az üzenet állapota le nem zárul
        // (retryVarakozas.js) - a figyelő oldja fel, vagy a végső időkorlát.
        retryKerelmek.set(messageId, { kezdet: Date.now(), lattFolyamatban: false });
        setTimeout(() => retryFeloldas(state.messages), RETRY_MAX_VARAKOZAS_MS + 500);
      } else {
        const kesz = new Set(state.retryBusyIds);
        kesz.delete(messageId);
        setChat({ retryBusyIds: kesz });
      }
    }
  },
  onCancelEdit: () => setChat({ editingMessageId: null, editingText: "", editingErrorKey: null, editingErrorText: null }),
  onSaveEdit: async () => {
    const messageId = state.editingMessageId;
    const roomId = state.currentRoomId;
    if (!messageId || !roomId || state.editingBusy) return;

    const text = (state.editingText || "").trim();
    if (!text) {
      const msg = (state.messages || []).find((m) => m.messageId === messageId);
      // Csak kép esetén engedett az üres szöveg (a felirat eltávolítása) -
      // ugyanaz a szabály, mint küldéskor.
      if (!msg || !msg.image) {
        setChat({ editingErrorKey: "message.editEmpty" });
        return;
      }
    }

    setChat({ editingBusy: true, editingErrorKey: null });
    try {
      await editMessage({ roomId, messageId, text, requestId: newClientMessageId() });
      setChat({ editingMessageId: null, editingText: "", editingBusy: false, editingErrorKey: null });
    } catch (err) {
      log.error("[üzenet] szerkesztés hiba:", err);
      const reszletes = ismertUzenetMuveletHiba(err);
      setChat({
        editingBusy: false,
        editingErrorKey: reszletes ? null : "message.editFailed",
        editingErrorText: reszletes,
      });
    }
  },
  // A törölt jelzés eltávolítása / visszaállítása (v151, csak admin).
  onHideDeletedMarker: async (messageId, rejtse) => {
    const roomId = state.currentRoomId;
    if (!roomId || state.editingBusy) return;
    if (rejtse && !window.confirm(t(state.uiLang, "message.markerRemoveConfirm"))) return;
    setChat({ editingBusy: true });
    try {
      await hideDeletedMarker({ roomId, messageId, hidden: rejtse === true, requestId: newClientMessageId() });
      setChat({ editingBusy: false });
    } catch (err) {
      log.error("[üzenet] a törölt jelzés módosítása nem sikerült:", err);
      const reszletes = ismertUzenetMuveletHiba(err);
      setChat({ editingBusy: false, chatErrorKey: reszletes ? null : "message.markerFailed", chatErrorText: reszletes });
    }
  },
  onDeleteMessage: async (messageId) => {
    const roomId = state.currentRoomId;
    if (!roomId || state.editingBusy) return;
    // Feldarabolt, hosszú üzenet kezdő része (v156): a megerősítés elmondja, hogy a hozzá tartozó további részek is törlődnek.
    const cel = (state.messages || []).find((m) => m.messageId === messageId);
    const felosztott = Boolean(cel) && Number.isFinite(cel.splitPartCount) && cel.splitPartCount > 1;
    if (!window.confirm(t(state.uiLang, felosztott ? "message.deleteSplitConfirm" : "message.deleteConfirm"))) return;

    setChat({ editingBusy: true });
    try {
      const valasz = await deleteMessage({ roomId, messageId, requestId: newClientMessageId() });
      setChat({ editingBusy: false });
      // A régebbi, nem összekapcsolt részek önálló hozzászólásként maradtak: az admin tudja, hányat kell még külön törölnie.
      if (valasz && valasz.splitMissing > 0 && typeof window.alert === "function") {
        window.alert(t(state.uiLang, "message.deleteSplitMissing", { n: valasz.splitMissing }));
      }
    } catch (err) {
      log.error("[üzenet] törlés hiba:", err);
      const reszletes = ismertUzenetMuveletHiba(err);
      setChat({
        editingBusy: false,
        chatErrorKey: reszletes ? null : "message.deleteFailed",
        chatErrorText: reszletes,
      });
    }
  },
  messageLink: (messageId) => hivatkozasKeszit(window.location, { roomId: state.currentRoomId, topicId: state.currentTopicId, messageId }),
  onJumpToMessage: async (messageId, opciok = {}) => {
    const keres = () => document.querySelector(`.msg-row[data-message-id="${CSS.escape(messageId)}"]`);
    let sor = keres();
    // Az eredeti már kigördült az élő ablakból: visszafelé lapozunk, amíg meg
    // nem lesz (alapból legfeljebb 10 lap = 500 üzenet, hogy ne töltsön
    // végtelenül; a KERESÉS találataihoz többet engedünk - 2026-10-04).
    const maxLap = Number(opciok.maxLap) > 0 ? Number(opciok.maxLap) : 10;
    for (let i = 0; !sor && i < maxLap && state.hasOlder; i++) {
      const volt = await regebbiBetoltese();
      if (!volt) break;
      sor = keres();
    }
    if (!sor) return;
    sor.scrollIntoView({ block: "center", behavior: "smooth" });
    // Rövid kiemelés: enélkül hosszú listában nem látszik, hova ugrottunk.
    sor.classList.add("msg-highlight");
    setTimeout(() => sor.classList.remove("msg-highlight"), 1600);
  },
  onDraftChange: (value) => {
    // Nem renderelünk újra minden leütésnél - csak az állapotot frissítjük.
    state.draft = value;
    state.chatErrorText = null;
    // Megváltozott tartalom = ÚJ küldési szándék. Enélkül egy sikertelen
    // küldés után átírt üzenet a régi azonosítóval menne ki, amire a
    // szerver (helyesen) "már létezik" hibát adna, és a küldés véglegesen
    // elakadna.
    state.pendingSendId = null;
    piszkozatMentesenKesleltetve();
    // A félbemaradt küldés feljegyzése (pendingSend.js) is érvényét veszti -
    // de csak ha EHHEZ a szobához tartozik (egy másik szoba kétes küldése
    // attól még kétes, hogy itt valaki gépel).
    torolFuggoSzobaban(state.user && state.user.uid, state.currentRoomId);
    // "@2": az előnézet RÖGTÖN az éppen feltöltendő változatot (eredeti / tömörített)
    // mutassa - ne csak küldéskor derüljön ki (2026-10-06, tagi jelzésre: a
    // csatolt 700 kB-os fájl előnézete 296 kB-ot mutatott, ezért úgy tűnt, tömörítve megy).
    kepSzinkron();
  },
  onSend: handleSend,
  onLoadOlder: () => { regebbiBetoltese(); },
  onOpenRooms: () => setOverlay("rooms"),
  onOpenHelp: () => setOverlay("help"),
  // A csatolás módja (2026-10-18): a meglévő parancsot írja a mezőbe ("@2" szövegfelismerés, "@1" képjavítás), "normal" törli, ha a mező épp parancs.
  // Parancsnál a mező szövege csak maga a parancs lehet (szerver: aiParancs) - a begépelt felirat helyét a parancs veszi át.
  onPickImageMode: (mod) => {
    const parancs = mod === "ocr" ? "@2" : mod === "enhance" ? "@1" : "";
    const jelenlegi = (state.draft || "").trim();
    const ujSzoveg = parancs || (jelenlegi === "@1" || jelenlegi === "@2" ? "" : state.draft || "");
    state.draft = ujSzoveg;
    state.pendingSendId = null; // megváltozott tartalom = új küldési szándék (mint a gépelésnél)
    state.chatErrorText = null;
    kepSzinkron(); // "@2": rögtön az eredeti, tömörítetlen változatra vált (és vissza)
    setChat({ draft: ujSzoveg });
  },
  // Közös szójegyzék (2026-10-08)
  onOpenGlossary: () => {
    szojegyzekAllapot = { ...SZOJEGYZEK_KEZDO };
    setOverlay("glossary");
    szojegyzekBetoltes();
  },
  // Keresés az üzenetekben (2026-10-04) - lásd keresesView.js / kereso.js.
  onOpenSearch: () => {
    nyissKeresot({
      uiLang: state.uiLang,
      tartalomNyelv: state.contentLang,
      szobak: state.rooms || [],
      aktualisSzobaId: state.currentRoomId,
      lapLekeres: keresesLapGyorsitotarral,
      onJump: ugorjUzenethez,
      // A találat témájának neve, ha a szoba témái be vannak töltve (az aktuális szobáé); másutt nem mutatunk találgatást.
      temaNev: (roomId, uzenet) => {
        if (roomId !== state.currentRoomId || !uzenet || !uzenet.topicId) return "";
        const tm = (state.topics || []).find((x) => x.topicId === uzenet.topicId);
        return tm ? temaCim(tm, state.contentLang) : "";
      },
    });
  },
  onOpenAdmin: () => {
    panelState = {
      ...panelState,
      reauthRetry: null,
      reauthMode: null,
      reauthLabel: null,
      statusKey: null,
      errorKey: null,
      selectedRoomId: state.currentRoomId,
      editingRoomId: null,
      nevPotlas: null,
      adminMenu: null,
      adminTopicsRoomId: null,
      adminTopics: null,
      adminTopicEdit: null,
    };
    setOverlay("admin");
    loadAdminUsers();
    loadAdminRooms();
  },
  onSignOut: handleSignOut,
};

// --- Szoba-átfogó munkalista (2026-10-18): a tag szobáinak státuszos témái; egyszeri betöltés a megnyitáskor (nem élő figyelés), szobánként egy lekérdezés.
async function nyissMunkalistat() {
  state.munkalista = { betolt: true, hiba: null, temak: null, szuro: alapSzuro() };
  setOverlay("munkalista");
  const szobak = (state.rooms || []).filter((r) => r && !r.archived);
  const temak = {};
  let hiba = null;
  // Legfeljebb 5 szoba egyszerre: ne terheljük egyszerre a hálózatot.
  for (let i = 0; i < szobak.length; i += 5) {
    await Promise.all(szobak.slice(i, i + 5).map(async (r) => {
      try {
        temak[r.roomId] = await statuszosTemak(r.roomId);
      } catch (err) {
        log.error("[munkalista] a szoba témái nem tölthetők be:", r.roomId, err);
        hiba = t(state.uiLang, "worklist.failed");
      }
    }));
    if (state.overlay !== "munkalista") return; // közben bezárták
  }
  state.munkalista = { ...state.munkalista, betolt: false, hiba, temak };
  if (state.overlay === "munkalista") render();
}

// --- "Elbírálandó javaslatok" (2026-10-19): azok a hozzászólások, amelyeken nyitott fordításjavaslat vár; egyszeri betöltés, szobánként egy lekérdezés
// a hozzászólásokra, és csak azokban a szobákban egy a témákra, ahol van találat.
async function nyissElbiralandokat() {
  state.elbiralandok = { betolt: true, hiba: null, adat: null };
  setOverlay("elbiralandok");
  const szobak = (state.rooms || []).filter((r) => r && !r.archived);
  const adat = {};
  let hiba = null;
  for (let i = 0; i < szobak.length; i += 5) {
    await Promise.all(szobak.slice(i, i + 5).map(async (r) => {
      try {
        const uzenetek = await javaslatosUzenetek(r.roomId);
        if (uzenetek.length === 0) return;
        adat[r.roomId] = { uzenetek, temak: await szobaTemai(r.roomId), tele: uzenetek.length >= 50 };
      } catch (err) {
        log.error("[javaslatok] a szoba nem tölthető be:", r.roomId, err);
        hiba = t(state.uiLang, "suggest.failed");
      }
    }));
    if (state.overlay !== "elbiralandok") return; // közben bezárták
  }
  state.elbiralandok = { betolt: false, hiba, adat };
  if (state.overlay === "elbiralandok") render();
}

// --- Átfedő panelek renderelése
function renderOverlay() {
  const app = document.getElementById("app");
  if (state.overlay === "rooms") {
    renderRoomSwitcher(
      app,
      {
        uiLang: state.uiLang,
        contentLang: state.contentLang || state.uiLang,
        rooms: state.rooms,
        currentRoomId: state.currentRoomId,
        unreadRoomIds: state.unreadRoomIds || [],
      },
      {
        onSelectRoom: (roomId) => {
          setOverlay(null);
          if (roomId !== state.currentRoomId) openRoom(roomId);
        },
        onOpenWorkList: nyissMunkalistat,
        onOpenSuggestions: nyissElbiralandokat,
        onClose: () => setOverlay(null),
      }
    );
  } else if (state.overlay === "elbiralandok") {
    renderElbiralandok(
      app,
      {
        uiLang: state.uiLang, contentLang: state.contentLang || state.uiLang, rooms: state.rooms, myUid: state.user && state.user.uid,
        staff: state.access?.role === "admin" || state.access?.role === "topic_lead", elbiralandok: state.elbiralandok,
      },
      {
        onClose: () => { state.elbiralandok = null; setOverlay(null); },
        onOpenMessage: (roomId, topicId, messageId) => {
          state.elbiralandok = null;
          setOverlay(null);
          openRoom(roomId, topicId || null);
          ugorjHivatkozottUzenethez(roomId, topicId || null, messageId);
        },
      }
    );
  } else if (state.overlay === "munkalista") {
    renderMunkalista(
      app,
      { uiLang: state.uiLang, contentLang: state.contentLang || state.uiLang, rooms: state.rooms, munkalista: state.munkalista },
      {
        onClose: () => { state.munkalista = null; setOverlay(null); },
        onOpenTopic: (roomId, topicId) => {
          state.munkalista = null;
          setOverlay(null);
          openRoom(roomId, topicId);
        },
        onFilter: (mezo, ertek) => {
          state.munkalista = { ...state.munkalista, szuro: { ...(state.munkalista && state.munkalista.szuro), [mezo]: ertek } };
          render();
        },
      }
    );
  } else if (state.overlay === "admin") {
    renderAdminPanel(
      app,
      {
        uiLang: state.uiLang,
        rooms: panelState.allRooms,
        users: panelState.users,
        currentUid: state.user?.uid || null,
        callerIsRoot: panelState.callerIsRoot,
        // A saját szerepkör (admin / topic_lead) - ez szűkíti a panel
        // menüjét és a szobakezelő gombjait Témafelelősnél (2026-09-30).
        callerRole: state.access?.role,
        selectedRoomId: effectiveSelectedRoomId(),
        editingRoomId: panelState.editingRoomId,
        editName: panelState.editName,
        editLocalizedNames: panelState.editLocalizedNames,
        newRoomName: panelState.newRoomName,
        newRoomParentId: panelState.newRoomParentId,
        newRoomReadOnly: panelState.newRoomReadOnly,
        editParentRoomId: panelState.editParentRoomId,
        newUserEmail: panelState.newUserEmail,
        newUserName: panelState.newUserName,
        newUserRooms: panelState.newUserRooms || [],
        userRoomsEdit: panelState.userRoomsEdit || null,
        userSort: panelState.userSort || "name",
        potlas: panelState.potlas || null,
        email: panelState.email || null,
        myUid: state.user?.uid,
        localizedNewRoomNames: panelState.localizedNewRoomNames,
        contentLangs: state.contentLangs,
        // Az admin nyelve: a szobanevek ezen jelennek meg a szobakezelésben (2026-10-10).
        contentLang: state.contentLang || state.uiLang,
        usage: panelState.usage,
        menu: panelState.adminMenu,
        nevPotlas: panelState.nevPotlas || null,
        eloSzobak: state.rooms || [],
        topicsRoomId: panelState.adminTopicsRoomId,
        topics: panelState.adminTopics,
        topicEdit: panelState.adminTopicEdit,
        topicsMore: panelState.adminTopicsMore === true,
        kozlemeny: panelState.kozlemeny,
        homeRoomIds: panelState.homeRoomIds,
        homeStatus: panelState.homeStatus,
        homeLanding: panelState.homeLanding,
        homeLandingTopics: panelState.homeLandingTopics,
        homeLandingIssueAt: panelState.homeLandingIssueAt,
        homePinned: panelState.homePinned,
        homePinnedLabels: panelState.homePinnedLabels || {},
        members: panelState.members === undefined ? null : panelState.members,
        jelentkezesek: panelState.jelentkezesek || { lista: null, hiba: false, status: "", role: "", reszlet: null, busy: false },
        membersEnforce: panelState.membersEnforce === true,
        membersNameLog: panelState.membersNameLog === true,
        nameLogTag: panelState.nameLogTag || null,
        membersHiba: panelState.membersHiba === true,
        membersMuveletHiba: panelState.membersMuveletHiba === true,
        homeLandingMessages: panelState.homeLandingMessages,
        homeLandingMessagesHiba: panelState.homeLandingMessagesHiba === true,
        kozlemenyek: panelState.kozlemenyek,
        busy: panelState.busy,
        statusKey: panelState.statusKey,
        statusParams: panelState.statusParams,
        errorKey: panelState.errorKey,
        errorText: panelState.errorText,
        reauth: Boolean(panelState.reauthRetry),
        reauthMode: panelState.reauthMode,
        reauthLabel: panelState.reauthLabel,
      },
      adminHandlers
    );
  } else if (state.overlay === "help") {
    renderHelpSheet(app, { uiLang: state.uiLang }, {
      onClose: () => setOverlay(null),
      // A teljes súgó a főablakon belüli, teljes képernyős rétegben nyílik "Vissza a programhoz" gombbal; a program állapota érintetlen marad.
      onOpenFull: () => { setOverlay(null); nyissSugot({ uiLang: state.uiLang }); },
    });
  } else if (state.overlay === "glossary") {
    const nevek = Object.fromEntries(Object.entries(state.contentLangs || {}).map(([k, v]) => [k, typeof v === "object" && v !== null ? v.name || k : v]));
    renderGlossaryPanel(app, { uiLang: state.uiLang, contentLang: state.contentLang, ...szojegyzekAllapot, nyelvNevek: nevek }, glossaryHandlers);
  } else if (state.overlay === "profile") {
    renderProfilePanel(
      app,
      {
        uiLang: state.uiLang,
        membershipCard: state.membershipCard && state.membershipCard.issued === true ? state.membershipCard : null,
        // v182: ez az eszköz és a belépés (csak saját eszközön): tartós tároló, és mikor veszett el utoljára a belépés
        nevNaplo: state.nevNaplo || null,
        eszkozInfo: hatalyosMod() === "sajat" ? { tartos: tartosTarOlvas(window), elveszett: elvesztesOlvas(window) } : null,
        name: panelState.profileName,
        nameLatn: panelState.profileNameLatn,
        nameJa: panelState.profileNameJa,
        nameZh: panelState.profileNameZh,
        nameKo: panelState.profileNameKo,
        nameCyr: panelState.profileNameCyr,
        nameEl: panelState.profileNameEl,
        suggesting: panelState.suggesting,
        nameLangKerdes: panelState.nameLangKerdes || false,
        contentLang: panelState.profileLang,
        contentLangs: state.contentLangs,
        uiLangs: Object.fromEntries(
          SUPPORTED_UI_LANGS.map((code) => [code, UI_LANG_NATIVE_NAMES[code]])
        ),
        busy: panelState.busy,
        statusKey: panelState.statusKey,
        errorKey: panelState.errorKey,
        // E-mail összefoglaló (2026-10-16): null = még töltődik; saját állapot- és hibajelzéssel (azonnal ment, nem a "Mentés" gombbal).
        emailFrequency: state.forumAllapotBetoltve ? state.emailFrequency || "off" : null,
        emailStatusKey: panelState.emailStatusKey,
        emailErrorKey: panelState.emailErrorKey,
        // Push-értesítés ezen az eszközön (2026-10-16): a böngésző és a tárolt "ki" jelző alapján, renderkor kiolvasva.
        push: pushAllapot(state.user && state.user.uid),
        pushBusy: panelState.pushBusy === true,
        pushStatusKey: panelState.pushStatusKey,
        pushErrorKey: panelState.pushErrorKey,
      },
      profileHandlers
    );
  }
}

/**
 * A tagság-kezelőben ténylegesen kijelölt szoba. A tárolt azonosító elavulhat
 * (a szobát épp törölték, vagy sosem volt kiválasztva); ilyenkor a lista első
 * szobája az érvényes, mert a legördülő menü is azt mutatja. Enélkül a
 * jelölőnégyzetek egy másik szoba tagságát mutatnák, mint amit a mentés írna.
 */
function effectiveSelectedRoomId() {
  const rooms = panelState.allRooms || [];
  if (rooms.some((r) => r.roomId === panelState.selectedRoomId)) return panelState.selectedRoomId;
  return rooms.length > 0 ? rooms[0].roomId : null;
}

// Az ÖSSZES szoba, amit az admin panel kezelhet - nem csak amiknek maga az
// admin a tagja (2026-09-29). `state.rooms` (a saját tagság szerinti, valós
// idejű lista) ettől külön, változatlanul él, és csak a tényleges
// csevegéshez (szobaváltó, üzenetek) használt - a jogosultság ott
// VÁLTOZATLANUL tagsághoz kötött marad, ez a lista csak az admin-panelt
// szolgálja ki.
async function loadAdminRooms() {
  try {
    const res = await adminAction("listRooms", { limit: 100 });
    panelState.allRooms = res.rooms || [];
  } catch (err) {
    log.error("[admin] szobalista hiba:", err);
    panelState.allRooms = [];
    panelState.errorKey = "admin.loadFailed";
  }
  panelState.busy = false;
  render();
}

// A felhasználólista lapjainak felső korlátja. 200 fős üzemnél (2026-10-01)
// egyetlen lap elvileg elég, de a lapozás a biztosíték: ha a létszám tovább
// nő, a lista attól még TELJES marad. A kör azért véges, hogy egy hibás
// szerverválasz (mindig ugyanazt a kurzort adja vissza) ne pörögjön örökké.
const ADMIN_USER_LAP_MERET = 200;
const ADMIN_USER_MAX_LAP = 25;

async function loadAdminUsers() {
  try {
    // VÉGIGLAPOZUNK (2026-10-01, a 200 fős bővítés része).
    //
    // A TALÁLT HIBA: korábban itt egyetlen, 100-as lap kérése állt, és a
    // szerver által visszaadott `nextCursor` figyelmen kívül maradt. 100 fő
    // fölött az admin panel CSENDBEN a tagok első 100 főjét mutatta - a
    // többi egyszerűen nem létezett a felületen (nem lehetett szerepkört
    // állítani, eltávolítani, és a "Szobatagok" nézetben bejelölni sem).
    // A szobatagság mentését ez nem rontotta el (az a szoba saját,
    // szerveroldali memberIds listájából dolgozik, nem a látható névsorból),
    // tehát adatvesztés nem történt - de a kezelhetetlenség valós volt.
    const osszes = [];
    let cursor = null;
    let callerIsRoot = false;
    for (let lap = 0; lap < ADMIN_USER_MAX_LAP; lap++) {
      const res = await adminAction("listUsers", {
        limit: ADMIN_USER_LAP_MERET,
        ...(cursor ? { cursor } : {}),
      });
      osszes.push(...(res.users || []));
      callerIsRoot = res.callerIsRoot === true;
      if (!res.nextCursor || res.nextCursor === cursor) break;
      cursor = res.nextCursor;
    }
    panelState.users = osszes;
    panelState.callerIsRoot = callerIsRoot;
  } catch (err) {
    log.error("[admin] felhasználólista hiba:", err);
    panelState.users = [];
    panelState.errorKey = "admin.loadFailed";
  }
  panelState.busy = false;
  render();
}

/**
 * A fordítási költség összesítője az adminpanelhez (csak olvasás). Hiba
 * esetén a panel többi része ettől függetlenül használható marad.
 */
async function loadUsageSummary() {
  panelState.usage = null;
  try {
    const res = await adminAction("usageSummary", { days: 30 });
    panelState.usage = res && Array.isArray(res.days) ? res : false;
  } catch (err) {
    log.error("[admin] költségösszesítő hiba:", err);
    panelState.usage = false;
  }
  if (state.overlay === "admin") render();
}

/** A témaműveletek szerver-hibakódjai (functions/src/topicAdmin.js, topics.js: details.code) -> a tag nyelvén megjelenő felirat. */
const TEMA_HIBA_KULCSOK = {
  "target-not-allowed": "admin.topicErr.targetNotAllowed",
  "target-has-topic": "admin.topicErr.targetHasTopic",
  "topic-locked": "admin.topicErr.topicLocked",
  "topic-busy": "admin.topicErr.topicBusy",
  "topic-not-movable": "admin.topicErr.topicNotMovable",
  "not-found": "admin.topicErr.notFound",
};

/** A kiválasztott szoba témáinak betöltése az admin panelhez; a közben átváltott szobát nem írja felül. */
async function betoltAdminTemak(roomId, tovabbi = false) {
  try {
    const lap = await adminTemak(roomId, tovabbi ? panelState.adminTopicsCursor : null);
    if (panelState.adminTopicsRoomId === roomId) {
      panelState.adminTopics = tovabbi && Array.isArray(panelState.adminTopics) ? [...panelState.adminTopics, ...lap.temak] : lap.temak;
      panelState.adminTopicsCursor = lap.cursor;
      panelState.adminTopicsMore = lap.tobb;
    }
  } catch (err) {
    log.error("[admin] témalista hiba:", err);
    if (panelState.adminTopicsRoomId === roomId) { panelState.adminTopics = []; panelState.errorKey = "admin.topicFailed"; }
  }
  render();
}

/** Egy témaművelet futtatása az admin panelen: foglalt jelzés, siker / hiba üzenet, a lista újratöltése. */
async function adminTemaMuvelet(muvelet) {
  const roomId = panelState.adminTopicsRoomId;
  if (!roomId || panelState.busy) return;
  panelState.busy = true;
  panelState.statusKey = null;
  panelState.errorKey = null;
  panelState.errorText = null;
  render();
  try {
    await muvelet(roomId);
    panelState.statusKey = "admin.topicDone";
    panelState.adminTopicEdit = null;
  } catch (err) {
    if (!(err && err.megszakitva)) {
      log.error("[admin] témaművelet hiba:", err);
      // A szerver gépi kódja szerint a tag nyelvén magyarázunk; ismeretlen kódnál az általános szöveg + a szerver (magyar) üzenete.
      const ismert = TEMA_HIBA_KULCSOK[err && err.details && err.details.code];
      panelState.errorKey = ismert || "admin.topicFailed";
      panelState.errorText = ismert ? null : err && typeof err.message === "string" ? err.message : null;
    }
  }
  panelState.busy = false;
  render();
  await betoltAdminTemak(roomId);
}

// Friss belépés (v135, functions/src/lib/frissBelepes.js): a védett admin-műveletek régi belépésnél "reauth-required" hibát adnak.
// Ilyenkor a művelet NEM vész el: a panel megjegyzi, hogyan kell újrapróbálni, a gomb a Google-belépést megismétli, és utána
// ugyanazt az (érintetlenül maradt) adatot küldi újra.
function frissBelepesHiba(err) {
  return Boolean(err && err.details && err.details.reason === "reauth-required");
}
function frissBelepesKerese(ujra, leiras) {
  panelState.reauthRetry = ujra;
  panelState.reauthMode = "login";
  panelState.reauthLabel = leiras && leiras.action ? { action: leiras.action, name: String(leiras.label || "") } : null;
  // Lapújratöltésen át is folytatható (reauthFolytatas.js): ahol a Google-belépés a lapot viszi el, a memóriabeli függvény elveszne.
  reauthMentes(leiras);
  panelState.errorKey = "admin.reauthNeeded";
  panelState.busy = false;
  render();
}

// A friss belépés miatt megszakadt admin-művelet folytatása a Google-belépés UTÁN, ha a lap közben újratöltődött (reauthFolytatas.js).
async function folytatMegszakitottAdminMuvelet() {
  const mentett = reauthKivesz();
  if (!mentett) return;
  chatHandlers.onOpenAdmin(); // (a lap megnyitása a főkezelők között van, nem az adminHandlers-ben)
  // A belépés megtörtént, de a műveletet NEM futtatjuk le magától (titkár #65): újra megmutatjuk, mi készült elő, és külön jóváhagyást kérünk.
  panelState.reauthRetry = () => vegrehajtMentett(mentett);
  panelState.reauthMode = "megerosit";
  panelState.reauthLabel = { action: mentett.action, name: mentett.label || "" };
  panelState.errorKey = null;
  panelState.statusKey = null;
  render();
}
async function vegrehajtMentett(mentett) {
  const kulcsok = ALLAPOT_KULCSOK[mentett.action];
  panelState.busy = true;
  panelState.reauthMode = null;
  render();
  try {
    await adminAction(mentett.action, mentett.payload, newClientMessageId());
    panelState.statusKey = kulcsok.ok;
    panelState.errorKey = null;
  } catch (err) {
    if (frissBelepesHiba(err)) return frissBelepesKerese(() => vegrehajtMentett(mentett), mentett); // még mindig nem elég friss: újra kérjük
    log.error("[admin] a megszakadt művelet folytatása nem sikerült:", err);
    panelState.errorKey = kulcsok.hiba;
  }
  panelState.busy = false;
  render();
  loadAdminUsers();
  loadAdminRooms();
}

// --- Közlemények az admin panelben (2026-10-25)
const ANN_URES = () => ({ text: "", audience: "all", uids: [], roomId: "", days: 30, valasz: null, hiba: null });

async function betoltKozlemenyeket() {
  panelState.kozlemenyek = null;
  render();
  try {
    const res = await announcementAdmin({ action: "list" });
    panelState.kozlemenyek = Array.isArray(res.announcements) ? res.announcements : [];
  } catch (err) {
    log.error("[admin] a közlemények listája nem töltődött be:", err);
    panelState.kozlemenyek = [];
    panelState.errorKey = "admin.annFailed";
  }
  render();
}

// Önkéntes jelentkezések (v192): a szervezői lista és a megnyitott részletek állapota.
function jelentkezesekAllapota() {
  return panelState.jelentkezesek || { lista: null, hiba: false, status: "", role: "", reszlet: null, busy: false };
}
async function betoltJelentkezeseket() {
  const j = jelentkezesekAllapota();
  panelState.jelentkezesek = { ...j, hiba: false, ...(j.reszlet ? {} : { lista: null }) };
  render();
  try {
    const r = await applicationAdmin({ action: "list", ...(j.status ? { status: j.status } : {}), ...(j.role ? { role: j.role } : {}) });
    panelState.jelentkezesek = { ...jelentkezesekAllapota(), lista: Array.isArray(r.applications) ? r.applications : [], hiba: false };
  } catch (err) {
    log.error("[admin] a jelentkezések nem töltődtek be:", err);
    panelState.jelentkezesek = { ...jelentkezesekAllapota(), lista: jelentkezesekAllapota().lista || [], hiba: true };
  }
  render();
}
async function handlers_onApplicationOpenUjra(uid) {
  const r = await applicationAdmin({ action: "get", uid });
  panelState.jelentkezesek = { ...jelentkezesekAllapota(), reszlet: r, busy: false, hiba: false };
  render();
}

async function betoltTagokat() {
  panelState.members = null;
  panelState.membersHiba = false;
  render();
  try {
    const r = await memberAdmin({ action: "list" });
    panelState.members = Array.isArray(r.members) ? r.members : [];
    panelState.membersEnforce = r.enforce === true;
    panelState.membersNameLog = r.nameLog === true;
  } catch (err) {
    log.error("[admin] a tagnyilvántartás nem töltődött be:", err);
    panelState.membersHiba = true;
  }
  render();
}

async function tagMuvelet(adat) {
  if (panelState.busy) return;
  panelState.busy = true;
  panelState.membersHiba = false;
  panelState.membersMuveletHiba = false;
  render();
  try {
    await memberAdmin(adat);
  } catch (err) {
    log.error("[admin] a tagnyilvántartási művelet nem sikerült:", err);
    panelState.membersMuveletHiba = true;
  }
  panelState.busy = false;
  await betoltTagokat();
}

async function betoltLandingUzeneteket() {
  const l = panelState.homeLanding;
  panelState.homeLandingMessagesHiba = false;
  if (!l || !l.roomId || !l.topicId) { panelState.homeLandingMessages = []; render(); return; }
  try {
    const lista = await landingUzenetek(l.roomId, l.topicId, state.contentLang);
    if (panelState.homeLanding && panelState.homeLanding.topicId === l.topicId) { panelState.homeLandingMessages = lista; render(); }
  } catch (err) {
    log.error("[admin] a belépési cél hozzászólásai nem töltődtek be:", err);
    // A hiba KÜLÖN állapot (nem "0 hozzászólás"): a titkár #99 kérése, hogy a "töltődik", a "sikertelen" és a valóban üres megkülönböztethető legyen.
    panelState.homeLandingMessages = null;
    panelState.homeLandingMessagesHiba = true;
    render();
  }
}

const adminHandlers = {
  // Kezdőlap (2026-10-25): a tagok kezdőlapján megjelenő szobák (config/home), sorrendben.
  onHomeAdd: (roomId) => {
    const lista = panelState.homeRoomIds || [];
    if (!lista.includes(roomId) && lista.length < 8) panelState.homeRoomIds = [...lista, roomId];
    panelState.homeStatus = null;
    render();
  },
  onHomeRemove: (roomId) => { panelState.homeRoomIds = (panelState.homeRoomIds || []).filter((x) => x !== roomId); panelState.homeStatus = null; render(); },
  onHomeMove: (roomId, irany) => {
    const l = [...(panelState.homeRoomIds || [])];
    const i = l.indexOf(roomId);
    const j = i + irany;
    if (i < 0 || j < 0 || j >= l.length) return;
    [l[i], l[j]] = [l[j], l[i]];
    panelState.homeRoomIds = l;
    panelState.homeStatus = null;
    render();
  },
  // Belépési cél (v153): "home" = a kezdőlap; "topic" = egy meglévő szoba / téma
  onHomeLandingMode: (mod) => {
    panelState.homeLanding = mod === "topic" ? (panelState.homeLanding || { roomId: "", topicId: null }) : null;
    panelState.homeStatus = null;
    render();
  },
  onHomeLandingRoom: async (roomId) => {
    panelState.homeLanding = { roomId: roomId || "", topicId: null };
    panelState.homeLandingTopics = null;
    panelState.homeStatus = null;
    render();
    if (!roomId) return;
    try {
      const lap = await adminTemak(roomId);
      if (panelState.homeLanding && panelState.homeLanding.roomId === roomId) { panelState.homeLandingTopics = lap.temak; render(); }
    } catch (err) {
      log.error("[admin] a belépési cél témái nem töltődtek be:", err);
      panelState.homeLandingTopics = [];
      render();
    }
  },
  onHomeLandingTopic: async (topicId) => {
    if (panelState.homeLanding) panelState.homeLanding = { ...panelState.homeLanding, topicId: topicId || null };
    panelState.homePinned = [];
    panelState.homeLandingMessages = null;
    panelState.homeStatus = null;
    render();
    await betoltLandingUzeneteket();
  },
  // Ajánlott tájékoztatók (v157): legfeljebb 3 meglévő hozzászólás a belépési cél témájából
  onHomePinnedReload: async () => {
    panelState.homeLandingMessages = null;
    render();
    await betoltLandingUzeneteket();
  },
  // Tagnyilvántartás (v166, Admin › Tagsági kártya): lista, szám kiadása, állapot állítása. Fizetés nincs.
  onMemberRefresh: () => betoltTagokat(),
  onMemberIssue: async (uid) => { await tagMuvelet({ action: "issue", uid }); },
  onMemberStatus: async (uid, status) => { await tagMuvelet({ action: "setStatus", uid, status }); },
  onMemberEnforce: async (enforce) => { await tagMuvelet({ action: "setEnforce", enforce: enforce === true }); },
  // Önkéntes jelentkezések (v192, csak admin): lista, szűrés, részletek (az olvasás auditnaplóba kerül), belső megjegyzés, kérdés / döntés.
  onApplicationRefresh: () => betoltJelentkezeseket(),
  onApplicationFilter: (status, role) => { panelState.jelentkezesek = { ...jelentkezesekAllapota(), status, role, lista: null, reszlet: null }; betoltJelentkezeseket(); },
  onApplicationOpen: async (uid) => {
    try {
      const r = await applicationAdmin({ action: "get", uid });
      panelState.jelentkezesek = { ...jelentkezesekAllapota(), reszlet: r, hiba: false, fordEredeti: false, fordBusy: false, fordHiba: false, egyeztetes: "" };
    } catch (err) {
      log.error("[admin] a jelentkezés nem töltődött be:", err);
      panelState.jelentkezesek = { ...jelentkezesekAllapota(), hiba: true };
    }
    render();
  },
  onApplicationClose: () => { panelState.jelentkezesek = { ...jelentkezesekAllapota(), reszlet: null, fordEredeti: false, fordBusy: false, fordHiba: false }; betoltJelentkezeseket(); },
  // A válaszok fordítása az admin felületi nyelvére (v204): kérés / újrafordítás (force), és váltás az eredeti és a fordítás között.
  onApplicationTranslate: async (uid, force) => {
    const j = jelentkezesekAllapota();
    if (j.fordBusy) return;
    panelState.jelentkezesek = { ...j, fordBusy: true, fordHiba: false };
    render();
    try {
      const r = await applicationAdmin({ action: "translate", uid, lang: state.uiLang, ...(force ? { force: true } : {}) });
      const most = jelentkezesekAllapota();
      if (most.reszlet && most.reszlet.uid === uid) {
        panelState.jelentkezesek = { ...most, fordBusy: false, fordHiba: false, fordEredeti: false, reszlet: { ...most.reszlet, translations: r.translations || {} } };
      } else {
        panelState.jelentkezesek = { ...most, fordBusy: false };
      }
    } catch (err) {
      log.error("[admin] a jelentkezés fordítása nem sikerült:", err);
      panelState.jelentkezesek = { ...jelentkezesekAllapota(), fordBusy: false, fordHiba: true };
    }
    render();
  },
  // Elfogadás után (v206): a résztvevő felvétele űrlap megnyitása a jelentkező e-mail-címével és nevével előtöltve (a felvételt az admin nyugtázza).
  onApplicationAddParticipant: (email, name, roles) => {
    panelState.newUserEmail = String(email || "");
    panelState.newUserName = String(name || "");
    // v207: a jelentkezett szerepekhez illő szobák előre kijelölve (név alapján; az admin átírhatja).
    const kijelolt = new Set();
    // Először az Audit szoba (megismerkedés); a munkaszobákba az „Egyeztetés” gomb hívja be (v207).
    for (const r of panelState.allRooms || []) if (onkentesSzobaSzerep(r.name) === "audit") kijelolt.add(r.roomId);
    panelState.newUserRooms = [...kijelolt];
    adminHandlers.onOpenMenu("newUser");
  },
  onApplicationTranslateToggle:() => { const j = jelentkezesekAllapota(); panelState.jelentkezesek = { ...j, fordEredeti: !j.fordEredeti }; render(); },
  onApplicationNote: async (uid, text) => {
    try {
      await applicationAdmin({ action: "addNote", uid, text });
      await handlers_onApplicationOpenUjra(uid);
    } catch (err) {
      log.error("[admin] a megjegyzés nem mentődött:", err);
      panelState.jelentkezesek = { ...jelentkezesekAllapota(), hiba: true };
      render();
    }
  },
  onApplicationStatus: async (uid, status, message) => {
    const j = jelentkezesekAllapota();
    if (j.busy) return;
    panelState.jelentkezesek = { ...j, busy: true, hiba: false };
    render();
    try {
      await applicationAdmin({ action: "setStatus", uid, status, ...(message ? { message } : {}) });
      await handlers_onApplicationOpenUjra(uid);
    } catch (err) {
      log.error("[admin] a döntés nem mentődött:", err);
      panelState.jelentkezesek = { ...jelentkezesekAllapota(), busy: false, hiba: true };
      render();
    }
  },
  // v207: Egyeztetés - a jelöltet (az Audit szoba után) a jelentkezett szerepeknek megfelelő munkaszobába (Tesztelők / Pénzügyi támogatók) hívja a csoportos megbeszéléshez.
  onApplicationConsult: async (uid, roles) => {
    const j = jelentkezesekAllapota();
    if (j.busy) return;
    panelState.jelentkezesek = { ...j, busy: true, egyeztetes: "" };
    render();
    let eredmeny = "err";
    try {
      if (!(panelState.allRooms || []).length) await loadAdminRooms();
      const szobak = [...new Set((panelState.allRooms || []).filter((r) => r.archived !== true && (roles || []).includes(onkentesSzobaSzerep(r.name))).map((r) => r.roomId))];
      if (!szobak.length) eredmeny = "noroom";
      else {
        await adminAction("addToRooms", { targetUid: uid, rooms: szobak }, newClientMessageId());
        await loadAdminRooms();
        eredmeny = "ok";
      }
    } catch (err) {
      log.error("[admin] az egyeztetésre hívás nem sikerült:", err);
    }
    panelState.jelentkezesek = { ...jelentkezesekAllapota(), busy: false, egyeztetes: eredmeny };
    render();
  },
  onMemberNameLogSwitch: async (enabled) => { await tagMuvelet({ action: "setNameLog", enabled: enabled === true }); },
  // Egy tag naplózott névváltozásai (csak admin; az olvasás auditnaplóba kerül): a lista a tag sora alatt jelenik meg.
  onMemberNameLog: async (uid) => {
    if (panelState.nameLogTag && panelState.nameLogTag.uid === uid) { panelState.nameLogTag = null; render(); return; }
    try {
      const r = await memberAdmin({ action: "nameLog", uid });
      panelState.nameLogTag = { uid, entries: Array.isArray(r.entries) ? r.entries : [] };
    } catch (err) {
      log.error("[admin] a névnapló nem töltődött be:", err);
      panelState.membersMuveletHiba = true;
    }
    render();
  },
  onHomePinnedLabel: (messageId, ertek) => {
    panelState.homePinnedLabels = { ...(panelState.homePinnedLabels || {}), [messageId]: String(ertek || "").slice(0, 60) };
    panelState.homeStatus = null; // nincs újrarajzolás: a gépelés közben a mező fókusza megmarad
  },
  onHomePinnedToggle: (messageId, bekapcsolva) => {
    const lista = panelState.homePinned || [];
    panelState.homePinned = bekapcsolva ? (lista.includes(messageId) || lista.length >= 3 ? lista : [...lista, messageId]) : lista.filter((x) => x !== messageId);
    panelState.homeStatus = null;
    render();
  },
  onHomeSave: async () => {
    if (panelState.busy) return;
    panelState.busy = true;
    panelState.homeStatus = null;
    render();
    try {
      const cel = panelState.homeLanding && panelState.homeLanding.roomId ? panelState.homeLanding : null;
      const cimkek = panelState.homePinnedLabels || {};
      const ajanlott = cel && cel.topicId ? (panelState.homePinned || []).slice(0, 3).map((id) => ({ messageId: id, customLabel: String(cimkek[id] || "").trim() })) : [];
      await saveHomeConfig({ roomIds: panelState.homeRoomIds || [], landing: cel, pinned: ajanlott });
      panelState.homeStatus = "saved";
    } catch (err) {
      log.error("[admin] a kezdőlap mentése nem sikerült:", err);
      panelState.homeStatus = "failed";
    }
    panelState.busy = false;
    render();
  },
  // Közlemények: az űrlap mezői (a gépelés nem rajzol újra, csak a választó mezők), küldés, lista, visszavonás.
  onAnnChange: (mezo, ertek) => {
    panelState.kozlemeny = panelState.kozlemeny || ANN_URES();
    panelState.kozlemeny[mezo] = ertek;
    if (mezo === "audience" || mezo === "roomId") render();
  },
  onAnnToggleUser: (uid, bekapcsolva) => {
    panelState.kozlemeny = panelState.kozlemeny || ANN_URES();
    const halmaz = new Set(panelState.kozlemeny.uids || []);
    if (bekapcsolva) halmaz.add(uid); else halmaz.delete(uid);
    panelState.kozlemeny.uids = [...halmaz];
  },
  onAnnRefresh: () => betoltKozlemenyeket(),
  onAnnSend: async () => {
    const f = panelState.kozlemeny = panelState.kozlemeny || ANN_URES();
    if (panelState.busy) return;
    f.hiba = null; f.valasz = null;
    const adat = { action: "send", text: String(f.text || "").trim(), audience: f.audience, days: Number(f.days) || 30, requestId: crypto.randomUUID() };
    if (f.audience === "users") adat.uids = f.uids || [];
    if (f.audience === "room") adat.roomId = f.roomId;
    if (!adat.text || (f.audience === "users" && adat.uids.length === 0) || (f.audience === "room" && !adat.roomId)) {
      f.hiba = t(state.uiLang, "admin.annFailed"); render(); return;
    }
    panelState.busy = true;
    render();
    try {
      const res = await announcementAdmin(adat);
      panelState.kozlemeny = { ...ANN_URES(), audience: f.audience, valasz: t(state.uiLang, "admin.annSent", { n: res.recipientCount }) };
      panelState.busy = false;
      await betoltKozlemenyeket();
      return;
    } catch (err) {
      log.error("[admin] a közlemény küldése nem sikerült:", err);
      const kod = String((err && err.code) || "");
      const ismert = ["functions/invalid-argument", "functions/not-found", "functions/failed-precondition", "functions/resource-exhausted", "functions/permission-denied"];
      f.hiba = ismert.includes(kod) && err.message ? err.message : t(state.uiLang, "admin.annFailed");
    }
    panelState.busy = false;
    render();
  },
  onAnnWithdraw: async (annId) => {
    if (panelState.busy) return;
    if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "admin.annWithdrawConfirm"))) return;
    panelState.busy = true;
    render();
    try {
      await announcementAdmin({ action: "withdraw", annId });
    } catch (err) {
      log.error("[admin] a közlemény visszavonása nem sikerült:", err);
      panelState.errorKey = "admin.annFailed";
    }
    panelState.busy = false;
    await betoltKozlemenyeket();
  },
  // Almenü megnyitása / visszalépés a főmenübe. Az üzenetsáv törlődik, hogy
  // az egyik almenü állapotüzenete ne látsszon a másikban. A költségadat
  // csak akkor töltődik, amikor tényleg megnyitják (nem minden panelnyitáskor).
  onOpenMenu: (key) => {
    panelState.adminMenu = key;
    panelState.statusKey = null;
    panelState.errorKey = null;
    panelState.userRoomsEdit = null; // a nyitva hagyott tagság-szerkesztő ne maradjon másik menüből visszatérve
    if (key === "usage") loadUsageSummary();
    if (key === "card") betoltTagokat();
    if (key === "applications") { panelState.jelentkezesek = { lista: null, hiba: false, status: "", role: "", reszlet: null, busy: false }; betoltJelentkezeseket(); }
    if (key === "announcements") { betoltKozlemenyeket(); if (!panelState.users) loadAdminUsers(); }
    if (key === "home") { panelState.homeRoomIds = null; panelState.homeStatus = null; getHomeConfig().then((c) => { panelState.homeRoomIds = c.roomIds; panelState.homeLanding = c.landing; panelState.homeLandingIssueAt = c.landingIssueAt; panelState.homePinned = (c.pinned || []).map((p) => p.messageId); panelState.homePinnedLabels = Object.fromEntries((c.pinned || []).filter((p) => p.customLabel).map((p) => [p.messageId, p.customLabel])); panelState.homeLandingMessages = null; panelState.homeLandingTopics = null; render(); betoltLandingUzeneteket(); if (c.landing && c.landing.roomId) adminTemak(c.landing.roomId).then((l) => { panelState.homeLandingTopics = l.temak; render(); }).catch(() => {}); }); }
    render();
  },
  onBackToMenu: () => {
    panelState.adminMenu = null;
    panelState.statusKey = null;
    panelState.errorKey = null;
    panelState.editingRoomId = null;
    render();
  },
  // Újrahitelesítés és a megszakadt védett művelet folytatása (lásd frissBelepesKerese).
  onReauth: async () => {
    const ujra = panelState.reauthRetry;
    if (!ujra || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    reauthIndit(); // innentől a mentett művelet lapújratöltés után is folytatható (a Google-belépés a lapot is elviheti)
    try {
      await ujraHitelesites();
    } catch (err) {
      log.error("[admin] újrahitelesítés hiba:", err);
      const megszakitva = err && (err.code === "auth/popup-closed-by-user" || err.code === "auth/cancelled-popup-request");
      panelState.busy = false;
      panelState.errorKey = megszakitva ? "admin.reauthNeeded" : "admin.reauthFailed";
      render();
      return;
    }
    panelState.busy = false;
    panelState.reauthRetry = null;
    reauthTorol(); // a memóriából folytatjuk; a mentés csak lapújratöltés esetére kell (az újabb hiba újra elmenti)
    await ujra();
  },
  // A lapújratöltés utáni megerősítés: igen = végrehajtás, mégse = elvetés (a bejegyzés már kivéve, nem marad meg).
  onReauthContinue: async () => {
    const ujra = panelState.reauthRetry;
    if (!ujra || panelState.busy) return;
    panelState.reauthRetry = null;
    panelState.reauthMode = null;
    reauthTorol();
    await ujra();
  },
  onReauthCancel: () => {
    panelState.reauthRetry = null;
    panelState.reauthMode = null;
    panelState.reauthLabel = null;
    reauthTorol();
    render();
  },
  onNewUserEmailChange: (value) => {
    panelState.newUserEmail = value;
  },
  onNewUserNameChange: (value) => {
    panelState.newUserName = value;
  },
  onNewUserRoomToggle: (roomId, on) => {
    const lista = new Set(panelState.newUserRooms || []);
    if (on) lista.add(roomId); else lista.delete(roomId);
    panelState.newUserRooms = [...lista];
  },

  // v212: a Résztvevők lista rendezése (név / felvétel ideje, mindkettő növekvő).
  onUserSort: (kulcs) => {
    panelState.userSort = kulcs === "added" ? "added" : "name";
    render();
  },

  // v208: egy résztvevő szobatagságának beállítása (Admin › Résztvevők › „Tagság beállítása”).
  // Ugyanaz a gomb nyitja és zárja a szerkesztőt; a kijelölés a szobák tényleges tagságából indul.
  onUserRoomsOpen: async (user) => {
    if (panelState.busy) return;
    if (panelState.userRoomsEdit && panelState.userRoomsEdit.uid === user.uid) {
      panelState.userRoomsEdit = null;
      render();
      return;
    }
    panelState.errorKey = null;
    panelState.statusKey = null;
    const kijeloles = () => (panelState.allRooms || []).filter((r) => Array.isArray(r.memberIds) && r.memberIds.includes(user.uid)).map((r) => r.roomId);
    panelState.userRoomsEdit = { uid: user.uid, original: kijeloles(), selected: kijeloles() };
    render();
    if (!(panelState.allRooms || []).length) {
      // A szobalista még nem töltődött be: betöltés után a kijelölés a friss tagságból indul.
      await loadAdminRooms();
      if (panelState.userRoomsEdit && panelState.userRoomsEdit.uid === user.uid) {
        panelState.userRoomsEdit = { uid: user.uid, original: kijeloles(), selected: kijeloles() };
        render();
      }
    }
  },
  onUserRoomsToggle: (roomId, on) => {
    const szerk = panelState.userRoomsEdit;
    if (!szerk) return;
    const lista = new Set(szerk.selected || []);
    if (on) lista.add(roomId); else lista.delete(roomId);
    szerk.selected = [...lista];
    // Nincs teljes újrarajzolás (a szobalista görgetése megmarad): csak a számláló frissül.
    const szamlalo = document.querySelector("[data-user-rooms-count]");
    if (szamlalo) szamlalo.textContent = t(state.uiLang, "admin.userRoomsCount", { n: lista.size });
  },
  onUserRoomsSave: async (user) => {
    const szerk = panelState.userRoomsEdit;
    if (panelState.busy || !szerk || szerk.uid !== user.uid) return;
    const eredeti = new Set(szerk.original || []);
    const kijelolt = new Set(szerk.selected || []);
    const add = [...kijelolt].filter((id) => !eredeti.has(id));
    const remove = [...eredeti].filter((id) => !kijelolt.has(id));
    if (add.length === 0 && remove.length === 0) {
      panelState.userRoomsEdit = null;
      render();
      return;
    }
    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();
    try {
      await adminAction("setUserRooms", { targetUid: user.uid, ...(add.length ? { add } : {}), ...(remove.length ? { remove } : {}) }, newClientMessageId());
      panelState.statusKey = "admin.userRoomsSaved";
      panelState.userRoomsEdit = null;
      await loadAdminRooms();
      return; // a loadAdminRooms kiveszi a foglalt állapotot és újrarajzol
    } catch (err) {
      log.error("[admin] a szobatagság mentése nem sikerült:", err);
      panelState.errorKey = "admin.userRoomsFailed";
    }
    panelState.busy = false;
    render();
  },

  onAddUser: async () => {
    const email = (panelState.newUserEmail || "").trim();
    if (panelState.busy) return;

    if (!email) {
      panelState.errorKey = "admin.emailRequired";
      render();
      return;
    }

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      const szobak = Array.isArray(panelState.newUserRooms) ? panelState.newUserRooms : [];
      await adminAction(
        "addUser",
        { email, name: (panelState.newUserName || "").trim(), ...(szobak.length ? { rooms: szobak } : {}) },
        newClientMessageId()
      );
      panelState.newUserEmail = "";
      panelState.newUserName = "";
      panelState.newUserRooms = [];
      panelState.statusKey = "admin.userAdded";
      await loadAdminUsers();
      return; // a loadAdminUsers már rendereli
    } catch (err) {
      if (frissBelepesHiba(err)) return frissBelepesKerese(() => adminHandlers.onAddUser(), { action: "addUser", label: email, payload: { email, name: (panelState.newUserName || "").trim() } });
      log.error("[admin] felhasználó felvétele hiba:", err);
      panelState.errorKey =
        err && err.code === "functions/already-exists"
          ? "admin.userExists"
          : err && err.code === "functions/invalid-argument"
          ? "admin.invalidEmail"
          : "admin.addUserFailed";
    }
    panelState.busy = false;
    render();
  },

  // Adminisztrátor kinevezése / visszavétele (csak a két fix admin; a szerver
  // is ellenőrzi). Nincs megerősítő ablak: a művelet azonnal visszafordítható.
  onSetRole: async (user, role) => {
    if (panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();
    try {
      await adminAction("setUserRole", { targetUid: user.uid, role }, newClientMessageId());
      panelState.statusKey = "admin.roleChanged";
      await loadAdminUsers();
      return;
    } catch (err) {
      if (frissBelepesHiba(err)) return frissBelepesKerese(() => adminHandlers.onSetRole(user, role), { action: "setUserRole", label: `${user.name || user.displayName || user.email || user.uid} → ${role}`, payload: { targetUid: user.uid, role } });
      log.error("[admin] szerepkör módosítása hiba:", err);
      panelState.errorKey = "admin.roleFailed";
    }
    panelState.busy = false;
    render();
  },

  onRemoveUser: async (user, ujra = false) => {
    if (panelState.busy) return;

    const nev = user.name || user.displayName || user.email || user.uid;
    const kerdes = t(state.uiLang, "admin.removeConfirm", { name: nev });
    if (!ujra && !window.confirm(kerdes)) return; // újrahitelesítés utáni újrapróbánál a megerősítés már megtörtént

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      await adminAction("removeUser", { targetUid: user.uid }, newClientMessageId());
      panelState.statusKey = "admin.userRemoved";
      await loadAdminUsers();
      return;
    } catch (err) {
      if (frissBelepesHiba(err)) return frissBelepesKerese(() => adminHandlers.onRemoveUser(user, true), { action: "removeUser", label: nev, payload: { targetUid: user.uid } });
      log.error("[admin] felhasználó eltávolítása hiba:", err);
      panelState.errorKey =
        err && err.code === "functions/permission-denied"
          ? "admin.cannotRemoveAdmin"
          : err && err.code === "functions/failed-precondition"
          ? "admin.cannotRemoveSelf"
          : "admin.removeFailed";
    }
    panelState.busy = false;
    render();
  },

  onNewRoomNameChange: (value) => {
    panelState.newRoomName = value;
  },
  // Javaslat (AI) a szoba nyelvenkénti neveihez (2026-10-04). A forrásnyelv
  // csak SEGÍTSÉG a fordítónak (és kihagyja a célok közül): az admin a saját
  // tartalomnyelvén írja az alap nevet.
  // v122: a forrásnyelv csak akkor adott, ha a név egy nyelvi mezőből jön; az alap név nyelve ISMERETLEN (nem az admin csevegési nyelve).
  onSuggestRoomNames: (name, targetLangs, sourceLang) => suggestRoomNames(name, targetLangs, sourceLang || undefined, { room: true }),
  // Az útmutató-szoba leírásának gépi javaslata a hiányzó nyelvekre (v121): ugyanaz a végpont, hosszú szöveggel; a forrásnyelv a kitöltött mező nyelve.
  onSuggestGuideText: (text, targetLangs, sourceLang) => suggestRoomNames(text, targetLangs, sourceLang, { longText: true }),
  // A javaslat megérkezésekor még ugyanazt a szobát szerkeszti-e (lásd javaslat.js).
  isEditingRoom: (roomId) => panelState.editingRoomId === roomId,
  onLocalizedNameChange: (code, value) => {
    panelState.localizedNewRoomNames = {
      ...panelState.localizedNewRoomNames,
      [code]: value,
    };
  },
  onNewRoomParentChange: (parentRoomId) => {
    panelState.newRoomParentId = parentRoomId;
  },
  // Csak olvasható szoba (2026-10-08)
  onNewRoomReadOnlyChange: (ertek) => {
    panelState.newRoomReadOnly = ertek === true;
  },
  // Fordító modell szobánként (2026-10-10): flash (alap) / lite.
  onSetRoomTranslationModel: async (room, model) => {
    if (!room || !room.roomId || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    try {
      await adminAction("setRoomTranslationModel", { roomId: room.roomId, model }, newClientMessageId());
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] fordító modell mentése hiba:", err);
      panelState.errorKey = "admin.modelSaveFailed";
    }
    panelState.busy = false;
    render();
  },
  onToggleRoomReadOnly: async (room) => {
    if (!room || !room.roomId || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    try {
      await adminAction("setRoomReadOnly", { roomId: room.roomId, readOnly: room.readOnly !== true }, newClientMessageId());
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] csak olvasható állapot hiba:", err);
      panelState.errorKey = "admin.readOnlyFailed";
    }
    panelState.busy = false;
    render();
  },
  // Offline olvasás szobánként (v143, csak admin): a tag saját eszközén mentett, kapcsolat nélkül olvasható tartalom engedélyezése.
  onSetRoomOfflineRead: async (room, bekapcsol) => {
    if (!room || !room.roomId || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    try {
      await adminAction("setRoomOfflineRead", { roomId: room.roomId, offlineRead: bekapcsol === true }, newClientMessageId());
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] offline olvasás beállítása hiba:", err);
      panelState.errorKey = "admin.readOnlyFailed";
    }
    panelState.busy = false;
    render();
  },
  // v216: e-mail a kijelölt tagoknak (Admin › Résztvevők). A gépelt tárgy / szöveg nem rajzol újra (nincs elvesző fókusz).
  onEmailToggle: () => {
    const e = panelState.email || {};
    panelState.email = { ...e, open: !e.open, errorKey: null, result: null };
    render();
  },
  onEmailSelect: (uid, be) => {
    const e = panelState.email || {};
    const lista = new Set(e.selected || []);
    if (be) lista.add(uid); else lista.delete(uid);
    panelState.email = { ...e, selected: [...lista], result: null, errorKey: null };
    render();
  },
  onEmailSelectAll: (uidok) => { panelState.email = { ...(panelState.email || {}), selected: [...uidok], result: null, errorKey: null }; render(); },
  onEmailSelectNone: () => { panelState.email = { ...(panelState.email || {}), selected: [], result: null, errorKey: null }; render(); },
  onEmailDraft: (mezo, ertek) => {
    if (mezo !== "subject" && mezo !== "body") return;
    panelState.email = { ...(panelState.email || {}), [mezo]: ertek };
  },
  onEmailSend: async () => {
    const e = panelState.email || {};
    const kijelolt = Array.isArray(e.selected) ? e.selected : [];
    const targy = String(e.subject || "").trim();
    const szoveg = String(e.body || "").trim();
    if (panelState.busy) return;
    if (kijelolt.length === 0 || !targy || !szoveg) { panelState.email = { ...e, errorKey: "admin.emailNeedFields", result: null }; render(); return; }
    if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "admin.emailConfirm", { n: kijelolt.length }))) return;
    panelState.busy = true;
    panelState.email = { ...e, errorKey: null, result: null };
    render();
    try {
      const eredmeny = await adminAction("sendMemberEmail", { uids: kijelolt, subject: targy, body: szoveg }, newClientMessageId());
      // Siker: a szöveg törlődik (véletlen újraküldés ellen), a kijelölés is.
      panelState.email = { open: true, selected: [], subject: "", body: "", errorKey: null, result: { queued: eredmeny.queued || 0, skipped: eredmeny.skipped || 0 } };
    } catch (err) {
      log.error("[admin] e-mail küldés hiba:", err);
      panelState.email = { ...(panelState.email || {}), errorKey: "admin.emailFailed", result: null };
    }
    panelState.busy = false;
    render();
  },
  // v217: a tagok mostani nevének átvezetése a régi üzenetekre / idézetekre / témákra (idő-keretes, `next`-tel folytatódik).
  onSyncMemberNames: async () => {
    if (panelState.busy) return;
    if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "admin.nameSyncConfirm"))) return;
    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();
    try {
      let utan = null;
      let osszes = 0;
      do {
        const eredmeny = await adminAction("syncMemberNames", utan ? { after: utan } : {}, newClientMessageId());
        osszes += eredmeny.updated || 0;
        utan = eredmeny.next || null;
      } while (utan);
      panelState.statusKey = "admin.nameSyncDone";
      panelState.statusParams = { n: osszes };
    } catch (err) {
      log.error("[admin] név-átvezetés hiba:", err);
      panelState.errorKey = "admin.nameSyncFailed";
    }
    panelState.busy = false;
    render();
  },
  // v215: a szoba régi üzeneteinek pótló fordítása (hívásonként legfeljebb 40 üzenet; a `next` jelzővel folytatható).
  onBackfillTranslations: async (room, opciok) => {
    if (!room || !room.roomId || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    const payload = { roomId: room.roomId, transcripts: opciok && opciok.transcripts === true };
    if (opciok && opciok.after != null) payload.after = opciok.after;
    try {
      const eredmeny = await adminAction("backfillTranslations", payload, newClientMessageId());
      panelState.potlas = { ...(panelState.potlas || {}), [room.roomId]: { started: eredmeny.started || 0, next: eredmeny.next == null ? null : eredmeny.next } };
    } catch (err) {
      log.error("[admin] pótló fordítás hiba:", err);
      panelState.potlas = { ...(panelState.potlas || {}), [room.roomId]: { failed: true, started: 0, next: null } };
    }
    panelState.busy = false;
    render();
  },
  // --- Témák kezelése (2026-10-19, csak admin) ---
  onTopicsMore: async () => {
    const roomId = panelState.adminTopicsRoomId;
    if (!roomId || panelState.busy) return;
    await betoltAdminTemak(roomId, true);
  },
  onTopicsRoom: async (roomId) => {
    panelState.adminTopicsRoomId = roomId;
    panelState.adminTopicsCursor = null;
    panelState.adminTopicsMore = false;
    panelState.adminTopics = roomId ? null : [];
    panelState.adminTopicEdit = null;
    panelState.statusKey = null;
    panelState.errorKey = null;
    render();
    if (roomId) await betoltAdminTemak(roomId);
  },
  onTopicEditStart: (tema, mode) => {
    panelState.adminTopicEdit = { topicId: tema.topicId, mode, value: tema.title || "", target: "" };
    panelState.statusKey = null;
    panelState.errorKey = null;
    render();
  },
  onTopicEditChange: (mezo, ertek) => { if (panelState.adminTopicEdit) panelState.adminTopicEdit[mezo] = ertek; },
  onTopicEditCancel: () => { panelState.adminTopicEdit = null; render(); },
  onTopicRename: (tema) => adminTemaMuvelet(async (roomId) => {
    const cim = String(panelState.adminTopicEdit?.value || "").trim();
    if (cim.length < 3) throw Object.assign(new Error("rövid cím"), { felhasznaloi: true });
    await topicAction({ action: "rename", roomId, topicId: tema.topicId, title: cim });
  }),
  onTopicClose: (tema, lezart) => adminTemaMuvelet((roomId) => topicAction({ action: "close", roomId, topicId: tema.topicId, closed: lezart === true })),
  onTopicLock: (tema, zarolt) => adminTemaMuvelet((roomId) => topicAction({ action: "lock", roomId, topicId: tema.topicId, locked: zarolt === true })),
  onTopicDelete: (tema) => {
    const cim = tema.title || tema.topicId;
    if (tema.kind === "history") {
      // Az ELŐZMÉNY törlése (v149): a szoba korábbi chatje (a témákba rendezett hozzászólások nem érintettek) - külön, erősebb megerősítés.
      const db = Number.isInteger(tema.historyMessageCount) ? tema.historyMessageCount : "?";
      if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "admin.historyDeleteConfirm", { n: db }))) return;
      return adminTemaMuvelet((roomId) => deleteTopic({ roomId, topicId: tema.topicId }));
    }
    // A megerősítés megmutatja a hozzászólások számát, és figyelmeztet, ha a szobában van másik, azonos nevű téma (a tartalmuk eltérhet - a titkár #46 kérése).
    const azonosNevu = (panelState.adminTopics || []).some((x) => x.topicId !== tema.topicId && x.kind === "discussion" && String(x.title || "").trim().toLowerCase() === String(tema.title || "").trim().toLowerCase() && String(tema.title || "").trim() !== "");
    const kerdes = t(state.uiLang, "admin.topicDeleteConfirm", { title: cim, n: Number.isInteger(tema.postCount) ? tema.postCount : "?" }) + (azonosNevu ? "\n\n" + t(state.uiLang, "admin.topicDeleteDupWarn") : "");
    if (typeof window.confirm === "function" && !window.confirm(kerdes)) return;
    return adminTemaMuvelet((roomId) => deleteTopic({ roomId, topicId: tema.topicId }));
  },
  onTopicMove: (tema) => {
    const szerk = panelState.adminTopicEdit;
    const celId = szerk && szerk.target;
    if (!celId) { panelState.errorKey = "admin.topicPickTarget"; render(); return; }
    const cel = (panelState.allRooms || []).find((r) => r.roomId === celId);
    const celNev = cel ? getRoomDisplayName(cel, state.contentLang || state.uiLang, state.uiLang) : celId;
    if (typeof window.confirm === "function" && !window.confirm(t(state.uiLang, "admin.topicMoveConfirm", { title: tema.title || tema.topicId, room: celNev }))) return;
    return adminTemaMuvelet(async (roomId) => {
      try {
        await moveTopic({ roomId, topicId: tema.topicId, targetRoomId: celId });
      } catch (err) {
        // Megtekintési kör: a cél szobának olyan tagja van, aki a mostani szobának nem - kifejezett megerősítés kell.
        const reszletek = err && err.details;
        if (reszletek && reszletek.code === "wider-audience") {
          if (typeof window.confirm === "function" && window.confirm(t(state.uiLang, "admin.topicMoveWider", { n: reszletek.count }))) {
            await moveTopic({ roomId, topicId: tema.topicId, targetRoomId: celId, confirmWider: true });
            return;
          }
          throw Object.assign(new Error("megszakítva"), { megszakitva: true });
        }
        throw err;
      }
    });
  },
  onSetRoomGuide: async (room, guide, guideText) => {
    if (!room || !room.roomId || panelState.busy) return;
    panelState.busy = true;
    panelState.errorKey = null;
    render();
    try {
      await adminAction("setRoomGuide", { roomId: room.roomId, guide: guide === true, guideText }, newClientMessageId());
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] útmutató-szoba hiba:", err);
      panelState.errorKey = "admin.guideFailed";
    }
    panelState.busy = false;
    render();
  },
  onCreateRoom: async () => {
    const name = (panelState.newRoomName || "").trim();
    if (!name || panelState.busy) return;

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      await adminAction(
        "createRoom",
        {
          name,
          memberIds: [],
          localizedNames: panelState.localizedNewRoomNames,
          parentRoomId: panelState.newRoomParentId || null,
          readOnly: panelState.newRoomReadOnly === true,
        },
        newClientMessageId()
      );
      panelState.newRoomName = "";
      panelState.localizedNewRoomNames = {};
      panelState.newRoomParentId = null;
      panelState.newRoomReadOnly = false;
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] szoba létrehozása hiba:", err);
      panelState.errorKey =
        err && err.code === "functions/failed-precondition" ? "admin.roomParentInvalid" : "admin.createFailed";
    }
    panelState.busy = false;
    render();
  },
  // --- Szoba átnevezése
  onStartRename: (room) => {
    if (panelState.busy) return;
    panelState.editingRoomId = room.roomId;
    panelState.editName = room.name || "";
    panelState.editLocalizedNames = { ...(room.localizedNames || {}) };
    panelState.editParentRoomId = room.parentRoomId || null;
    panelState.statusKey = null;
    panelState.errorKey = null;
    render();
  },
  onEditParentChange: (parentRoomId) => {
    panelState.editParentRoomId = parentRoomId;
  },
  onEditNameChange: (value) => {
    panelState.editName = value;
  },
  // Az összes nyelvi név törlése az űrlapon (mentésig csak a piszkozatot érinti); az űrlap újrarajzolódik.
  onClearLocalizedNames: () => {
    if (panelState.busy) return;
    panelState.editLocalizedNames = {};
    render();
  },
  onEditLocalizedNameChange: (code, value) => {
    panelState.editLocalizedNames = { ...panelState.editLocalizedNames, [code]: value };
  },
  onCancelRename: () => {
    if (panelState.busy) return;
    panelState.editingRoomId = null;
    render();
  },
  onSaveRename: async () => {
    if (panelState.busy || !panelState.editingRoomId) return;
    const name = (panelState.editName || "").trim();
    if (!name) {
      panelState.errorKey = "admin.renameNameRequired";
      render();
      return;
    }

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      // Az üres lokalizált nevek nem kerülnek a kérésbe (a szerver is eldobja őket).
      const localizedNames = {};
      for (const [code, value] of Object.entries(panelState.editLocalizedNames || {})) {
        if (typeof value === "string" && value.trim()) localizedNames[code] = value.trim();
      }
      const eredmeny = await adminAction(
        "renameRoom",
        {
          roomId: panelState.editingRoomId,
          name,
          localizedNames,
          parentRoomId: panelState.editParentRoomId || null,
        },
        newClientMessageId()
      );
      panelState.editingRoomId = null;
      // Ha a szerver elavult (változatlanul visszaküldött) nyelvi neveket dobott el, ezt jelezzük (2026-10-10).
      panelState.statusKey = eredmeny && eredmeny.droppedLocalized > 0 ? "admin.roomRenamedStale" : "admin.roomRenamed";
      // A szobalista élő figyelő: az új név (és a szülő) magától megjelenik.
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] szoba átnevezése hiba:", err);
      panelState.errorKey =
        err && err.code === "functions/failed-precondition" ? "admin.roomParentInvalid" : "admin.renameFailed";
    }
    panelState.busy = false;
    render();
  },

  // --- Szoba TÖRLÉSE (visszafordíthatatlan)
  onDeleteRoom: async (room, ujra = false) => {
    if (panelState.busy) return;

    const nev = getRoomDisplayName(room, state.contentLang || state.uiLang, state.uiLang);
    if (!ujra && !window.confirm(t(state.uiLang, "admin.deleteRoomConfirm", { name: nev }))) return; // újrapróbánál a megerősítés már megtörtént

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    panelState.editingRoomId = null;
    render();

    try {
      await adminAction("deleteRoom", { roomId: room.roomId }, newClientMessageId());
      if (panelState.selectedRoomId === room.roomId) panelState.selectedRoomId = null;
      panelState.statusKey = "admin.roomDeleted";
      // A szobalista élő figyelő: a szoba magától eltűnik, és ha épp az volt
      // megnyitva, a csevegő átvált egy másikra.
      await loadAdminRooms();
      return;
    } catch (err) {
      if (frissBelepesHiba(err)) return frissBelepesKerese(() => adminHandlers.onDeleteRoom(room, true), { action: "deleteRoom", label: nev, payload: { roomId: room.roomId } });
      log.error("[admin] szoba törlése hiba:", err);
      panelState.errorKey =
        err && err.code === "functions/failed-precondition" ? "admin.deleteRoomHasChildren" : "admin.deleteRoomFailed";
    }
    panelState.busy = false;
    render();
  },

  onSelectRoom: (roomId) => {
    panelState.selectedRoomId = roomId;
    panelState.statusKey = null;
    panelState.errorKey = null;
    render();
  },
  onToggleMember: async (uid, shouldBeMember) => {
    const room = (panelState.allRooms || []).find((r) => r.roomId === effectiveSelectedRoomId());
    if (!room || panelState.busy) return;

    const current = new Set(room.memberIds || []);
    if (shouldBeMember) current.add(uid);
    else current.delete(uid);

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      await adminAction(
        "setRoomMembers",
        { roomId: room.roomId, memberIds: [...current] },
        newClientMessageId()
      );
      panelState.statusKey = "admin.membersSaved";
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] tagság hiba:", err);
      panelState.errorKey = "admin.membersFailed";
    }
    panelState.busy = false;
    render();
  },
  // A szoba fel / le a testvérei között (2026-10-20, v125): a megjelenített sorrendből az egymás melletti pár cseréjével új sorrend; a szerver számozza (setRoomOrder).
  onMoveRoom: async (room, irany) => {
    if (!room || panelState.busy) return;
    const rendezett = alapSorrend(panelState.allRooms || [], state.rooms || []);
    const { testverek, index } = testverCsoport(rendezett, room);
    const cel = index + irany;
    if (index < 0 || cel < 0 || cel >= testverek.length) return;
    const idk = testverek.map((r) => r.roomId);
    [idk[index], idk[cel]] = [idk[cel], idk[index]];
    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();
    try {
      await adminAction("setRoomOrder", { parentRoomId: room.parentRoomId || null, orderedIds: idk }, newClientMessageId());
      panelState.statusKey = "admin.roomOrderSaved";
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] szoba-sorrend hiba:", err);
      panelState.errorKey = "admin.roomOrderFailed";
    }
    panelState.busy = false;
    render();
  },
  // Hiányzó nyelvi nevek tömeges pótlása (2026-10-20, v123): javaslat egyenként, a szerver keretét tartva; mentés csak az admin jóváhagyásával.
  onNevPotlasStart: async () => {
    if (panelState.busy || (panelState.nevPotlas && panelState.nevPotlas.fazis === "fut")) return;
    const kodok = Object.keys(CHAT_LANGUAGES);
    const feladatok = feladatLista(hianyzoNevek(panelState.allRooms, state.rooms, kodok));
    if (feladatok.length === 0) { panelState.nevPotlas = null; render(); return; }
    const allapot = { fazis: "fut", haladas: { n: 0, m: feladatok.length }, megszakit: false };
    panelState.nevPotlas = allapot;
    render();
    const eredmeny = await javaslatokKeszitese(
      feladatok,
      // az alap név nyelve ismeretlen (a fordító felismeri): a név lehet japán, magyar stb.
      (f) => suggestRoomNames(f.nev, f.kodok, undefined, { room: f.fajta === "szoba" }),
      { megszakitott: () => allapot.megszakit, haladas: (n, m) => { allapot.haladas = { n, m }; if (panelState.nevPotlas === allapot) render(); } }
    );
    if (panelState.nevPotlas !== allapot) return; // közben elvetette / panelt váltott
    panelState.nevPotlas = { fazis: "kesz", javaslatok: eredmeny.javaslatok, hibak: eredmeny.hibak, keretHiba: eredmeny.keretHiba, tulHosszu: eredmeny.tulHosszu || 0, megszakadt: eredmeny.megszakadt };
    render();
  },
  onNevPotlasCancel: () => { if (panelState.nevPotlas) panelState.nevPotlas.megszakit = true; },
  onNevPotlasDiscard: () => { panelState.nevPotlas = null; render(); },
  onNevPotlasSave: async () => {
    const np = panelState.nevPotlas;
    if (!np || np.fazis !== "kesz" || panelState.busy) return;
    const terv = mentesiTervek(np.javaslatok || [], panelState.allRooms, state.rooms, Object.keys(CHAT_LANGUAGES));
    if (terv.ossz === 0) { panelState.nevPotlas = null; render(); return; }
    panelState.nevPotlas = { ...np, fazis: "ment", hiba: false };
    panelState.busy = true;
    render();
    let mentett = 0; let hiba = false;
    for (const r of terv.szobak) {
      try {
        // az alap név és a szülő VÁLTOZATLAN: a szerver nem dobja el a nyelvi neveket, csak a hiányzókat egészítjük ki.
        await adminAction("renameRoom", { roomId: r.roomId, name: r.name, localizedNames: r.localizedNames, parentRoomId: r.parentRoomId }, newClientMessageId());
        mentett += r.db;
      } catch (err) { log.error("[admin] nevek pótlása (szoba):", err); hiba = true; }
    }
    for (const k of terv.katalogusok) {
      try {
        await topicAction({ roomId: k.roomId, action: "setCatalog", catalog: k.catalog.map((c) => ({ id: c.id, group: c.group, name: c.name, names: c.names })) });
        mentett += k.db;
      } catch (err) { log.error("[admin] nevek pótlása (címkék):", err); hiba = true; }
    }
    panelState.nevPotlas = { fazis: "vege", mentett, hiba };
    await loadAdminRooms(); // (a hibát maga kezeli, és újrarajzol)
  },
  // Mindenki felvétele / eltávolítása egy kattintással (2026-10-20, v122). A két kulcs admin mindig tag marad: a szerver a kérésbe
  // visszateszi őket (lib/rootMembers.js), ezért "senki" = üres lista. A létszámkorlát (200) fölött a szerver elutasít: előre jelezzük.
  onSetAllMembers: async (mindenki) => {
    const room = (panelState.allRooms || []).find((r) => r.roomId === effectiveSelectedRoomId());
    if (!room || panelState.busy || !panelState.users) return;
    const aktivak = panelState.users.filter((u) => u.active).map((u) => u.uid);
    if (mindenki && aktivak.length > 200) { panelState.errorKey = "admin.membersFailed"; panelState.statusKey = null; render(); return; }
    const nev = getRoomDisplayName(room, state.contentLang || state.uiLang, state.uiLang);
    if (!mindenki && !window.confirm(t(state.uiLang, "admin.membersNoneConfirm", { room: nev }))) return;
    if (mindenki && !window.confirm(t(state.uiLang, "admin.membersAllConfirm", { room: nev, n: aktivak.length }))) return;
    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();
    try {
      await adminAction("setRoomMembers", { roomId: room.roomId, memberIds: mindenki ? aktivak : [] }, newClientMessageId());
      panelState.statusKey = "admin.membersSaved";
      await loadAdminRooms();
      return;
    } catch (err) {
      log.error("[admin] tagság (mindenki / senki) hiba:", err);
      panelState.errorKey = "admin.membersFailed";
    }
    panelState.busy = false;
    render();
  },
  onClose: () => setOverlay(null),
};

const profileHandlers = {
  // Push-értesítés ki/be KAPCSOLÓ (2026-10-16, tagi kérés): csak ezt az eszközt érinti; azonnal érvényes (nem a "Mentés" gombbal).
  // Bekapcsolás: ha a böngésző még nem kérdezett, felugrik az engedélykérés (felhasználói gesztus: a kapcsoló megérintése);
  // letiltott engedélynél csak a böngésző beállításaiban lehet visszakapcsolni (ezt jelezzük). Kikapcsolás: az eszköz tokenje törlődik.
  onPushToggle: async (bekapcsol) => {
    if (panelState.pushBusy) return;
    panelState.pushBusy = true;
    panelState.pushStatusKey = null;
    panelState.pushErrorKey = null;
    render();
    const uid = state.user && state.user.uid;
    try {
      if (bekapcsol) {
        const e = await enableNotifications(registerPushToken, uid);
        if (e.ok) {
          panelState.pushStatusKey = "profile.pushOn";
          setChat({ offerNotifications: false }); // a felajánló sáv ezután felesleges
        } else {
          panelState.pushErrorKey = e.reason === "denied" ? "notif.blocked" : "notif.failed";
        }
      } else {
        const e = await disableNotifications(registerPushToken, uid);
        if (e.ok) panelState.pushStatusKey = "profile.pushOff";
        else panelState.pushErrorKey = "notif.failed";
      }
    } catch (err) {
      log.error("[profil] push kapcsoló:", err);
      panelState.pushErrorKey = "notif.failed";
    }
    panelState.pushBusy = false;
    render();
  },
  // E-mail összefoglaló (2026-10-16, tagi kérés: a profilban legyen): a választás AZONNAL mentődik (a "Mentés" gomb a nevet és a
  // nyelvet menti). Ugyanazt az állapotot (state.emailFrequency) használja, mint a fórum témalistájának választója.
  onEmailFrequency: async (frequency) => {
    panelState.emailStatusKey = null;
    panelState.emailErrorKey = null;
    try {
      const r = await forumAction({ action: "setEmail", frequency });
      setChat({ emailFrequency: r.emailFrequency });
      panelState.emailStatusKey = "profile.emailSaved";
    } catch (err) {
      log.error("[profil] e-mail beállítás:", err);
      panelState.emailErrorKey = "profile.emailFailed"; // az újrarajzolás a SZERVEREN lévő (régi) értékre állítja vissza a választót
    }
    render();
  },
  onNameChange: (value) => {
    panelState.profileName = value;
  },
  onNameLatnChange: (value) => {
    panelState.profileNameLatn = value;
  },
  onNameJaChange: (value) => {
    panelState.profileNameJa = value;
  },
  onNameZhChange: (value) => {
    panelState.profileNameZh = value;
  },
  onNameKoChange: (value) => {
    panelState.profileNameKo = value;
  },
  onNameCyrChange: (value) => {
    panelState.profileNameCyr = value;
  },
  onNameElChange: (value) => {
    panelState.profileNameEl = value;
  },
  onSuggestNames: async (nameLang) => {
    const name = (panelState.profileName || "").trim();
    if (panelState.busy || panelState.suggesting) return;
    // Üres név: a gomb ugyanúgy jelzi, mit hiányol, mint a szobanév-szerkesztő
    // javaslat-gombja (suggest.needBase) - korábban némán nem történt semmi
    // (2026-10-06, a "mindig legyen javaslat-gomb" kérés átvizsgálásakor).
    if (!name) {
      panelState.statusKey = null;
      panelState.errorKey = "suggest.needBase";
      render();
      return;
    }

    // MIND A HAT írásmód (2026-10-04, tagi kérésre): az ÜRES mezőket kérjük -
    // amit a tag már kitöltött, ahhoz nem nyúlunk.
    const MEZOK = [
      ["nameLatn", "profileNameLatn"], ["nameJa", "profileNameJa"], ["nameZh", "profileNameZh"],
      ["nameKo", "profileNameKo"], ["nameCyr", "profileNameCyr"], ["nameEl", "profileNameEl"],
    ];
    const uresek = MEZOK.filter(([, allapotKulcs]) => !(panelState[allapotKulcs] || "").trim());
    if (uresek.length === 0) {
      panelState.errorKey = null;
      panelState.statusKey = "suggest.nothingToDo";
      render();
      return;
    }

    panelState.suggesting = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      const javaslat = await suggestNameVariants(name, nameLang, uresek.map(([mezo]) => mezo));

      // A szerver visszaszólhat, hogy a név többértelmű (csupa han
      // írásjegy): ilyenkor nem tippelünk, hanem megkérdezzük a tagot,
      // melyik nyelv szerinti átírást kéri.
      if (javaslat && javaslat.needsLanguage) {
        panelState.nameLangKerdes = true;
        panelState.suggesting = false;
        render();
        return;
      }
      panelState.nameLangKerdes = false;
      // A javaslatot csak BEÍRJUK a mezőbe - a mentés a tag dolga, hogy
      // előbb átnézhesse. Egy névnek több olvasata is lehet. Ami közben
      // kitöltődött (a tag gépelt a várakozás alatt), azt nem írjuk felül.
      let beirt = 0;
      const javaslatok = (javaslat && javaslat.suggestions) || {};
      for (const [mezo, allapotKulcs] of uresek) {
        if (javaslatok[mezo] && !(panelState[allapotKulcs] || "").trim()) {
          panelState[allapotKulcs] = javaslatok[mezo];
          beirt++;
        }
      }
      if (beirt > 0) panelState.statusKey = "profile.suggestReview";
      else panelState.errorKey = "profile.suggestFailed";
    } catch (err) {
      log.error("[profil] névjavaslat hiba:", err);
      panelState.errorKey = "profile.suggestFailed";
    }
    panelState.suggesting = false;
    render();
  },
  onUiLangChange: (code) => {
    // A felület nyelvét azonnal állítjuk - a felhasználó azonnal látja
    // a változást, és így azt is, hogy jó helyen jár-e.
    setUiLang(code);
    render();
  },
  onContentLangChange: (code) => {
    panelState.profileLang = code;
    render();
  },
  onSave: async () => {
    const name = (panelState.profileName || "").trim();
    if (!name) {
      panelState.errorKey = "profile.nameRequired";
      render();
      return;
    }

    panelState.busy = true;
    panelState.errorKey = null;
    panelState.statusKey = null;
    render();

    try {
      const nameLatn = (panelState.profileNameLatn || "").trim();
      const nameJa = (panelState.profileNameJa || "").trim();
      const nameZh = (panelState.profileNameZh || "").trim();
      const nameKo = (panelState.profileNameKo || "").trim();
      const nameCyr = (panelState.profileNameCyr || "").trim();
      const nameEl = (panelState.profileNameEl || "").trim();
      await saveProfile({
        name,
        nameLatn,
        nameJa,
        nameZh,
        nameKo,
        nameCyr,
        nameEl,
        preferredLang: panelState.profileLang,
        lastRoomId: state.currentRoomId,
      });
      setChat({
        profileName: name,
        profileNameLatn: nameLatn,
        profileNameJa: nameJa,
        profileNameZh: nameZh,
        profileNameKo: nameKo,
        profileNameCyr: nameCyr,
        profileNameEl: nameEl,
        contentLang: panelState.profileLang,
      });
      panelState.statusKey = "profile.saved";
    } catch (err) {
      log.error("[profil] mentés hiba:", err);
      panelState.errorKey = "profile.saveFailed";
    }
    panelState.busy = false;
    render();
  },
  onClose: () => setOverlay(null),
};

// ----------------------------------------------------------------------
// Jogosultság-ellenőrzés (access/{uid})
// ----------------------------------------------------------------------
async function checkAccess(user) {
  if (!user) return;

  // Önkéntes jelentkezés (v191): a jelentkezési oldalon a tagsági hozzáférés nem feltétel (a nem tag is jelentkezhet) - nincs jogosultság-ellenőrzés,
  // a jelentkező csak a saját jelentkezését éri el (szerveroldali függvények); a tag a "Vissza az alkalmazásba" gombbal léphet tovább.
  if (jelentkezesUtvonal) {
    setScreen("apply");
    jelentkezesBetoltese();
    return;
  }

  // Ha a felhasználó még a nyelvválasztó képernyőn van (első látogatás,
  // de már volt érvényes bejelentkezése), NE rántsuk el alóla a
  // képernyőt - előbb hadd válasszon nyelvet. A jogosultságot majd a
  // "Tovább" gomb után, a belépő képernyőről ellenőrizzük.
  if (state.screen === "lang") return;

  // Az offline pillanatkép-tár a jogosultság-ellenőrzés ELŐTT kapcsol be (csak saját eszköz módban; lásd offlineKezelo.js): kapcsolat nélküli
  // hidegindításnál a mentett jogosultság és profil szolgál, és a szobafigyelők már kiszolgálhatnak offline adatot. Időkorláttal: egy
  // beragadt tár ne akaszthassa meg a belépést.
  await Promise.race([offlineAktival(user.uid), new Promise((kesz) => setTimeout(kesz, 1500))]).catch(() => {});

  setScreen("access-checking");
  // Az ellenőrzés "lassú" jelzése és végső időkorlátja (2026-10-18): 8 mp után jelzés + újrapróba gomb, 40 mp után a megszokott
  // hibaág (access-pending + hibaüzenet + "újraellenőrzés"). Egy újabb ellenőrzés elavulttá teszi a korábbit (sorszám).
  const sorszam = ++hozzaferesEllenorzesSorszam;
  state.accessLassu = false;
  const lassuIdozito = setTimeout(() => {
    if (sorszam === hozzaferesEllenorzesSorszam && state.screen === "access-checking") {
      state.authDiag = hibaKod(KODOK.ACCESS_SLOW);
      setChat({ accessLassu: true });
    }
  }, ACCESS_LASSU_MS);
  try {
    const access = await Promise.race([
      getMyAccess(user.uid),
      new Promise((_, elutasit) => setTimeout(() => elutasit(new Error("access-timeout")), ACCESS_IDOKORLAT_MS)),
    ]);
    clearTimeout(lassuIdozito);
    if (sorszam !== hozzaferesEllenorzesSorszam) return; // közben újraindult: az újabb ellenőrzés dönt
    state.accessLassu = false;
    setAccess(access);

    if (hozzaferesAktiv(access)) {
      // Saját eszközön a böngészőt kérjük, hogy tartósan őrizze a tárolót (a belépés ne törlődjön); az eredmény a profilon látszik. Közös eszközön nem.
      if (hatalyosMod() === "sajat") tarolotKer(window).then(() => render()).catch(() => {});
      state.authDiag = null;
      state.accessProbak = 0;
      setScreen("active");
      startChat();
      elsoBejelentkezesiSugo(user.uid);
      folytatMegszakitottAdminMuvelet(); // lásd fent: a Google-belépés a lapot is elvihette
    } else {
      setScreen("access-pending");
    }
  } catch (err) {
    clearTimeout(lassuIdozito);
    if (sorszam !== hozzaferesEllenorzesSorszam) return;
    state.accessLassu = false;
    log.error("[access] jogosultság-ellenőrzés hiba:", err);
    const idotullepes = err && err.message === "access-timeout";
    state.authDiag = idotullepes ? hibaKod(KODOK.ACCESS_TIMEOUT) : hibaKod(KODOK.ACCESS_ERROR, err && err.code);
    setError("access.errorChecking");
    setScreen("access-pending");
  }
}
/**
 * Az "Első lépések" lap EGYSZER, az első belépéskor magától megnyílik (2026-10-19, a titkár A/8 kérése: "az első alkalommal érkezők habozás nélkül
 * értsék meg, hová menjenek és mit nyomjanak meg"). Eszközönként és felhasználónként egyszer; a jelzést CSAK akkor írjuk, ha a lap tényleg megnyílt, és ha
 * a böngésző tárhelye tiltott, nem nyitjuk meg (különben minden belépéskor előjönne). Közben megnyitott más lapot nem takarunk el.
 */
function elsoBejelentkezesiSugo(uid) {
  let kulcs;
  try {
    kulcs = `lineage0_elso_sugo_${uid}`;
    if (window.localStorage.getItem(kulcs)) return;
  } catch (e) {
    return;
  }
  setTimeout(() => {
    if (state.screen !== "active" || state.overlay || !state.user || state.user.uid !== uid) return;
    try { window.localStorage.setItem(kulcs, "1"); } catch (e) { return; }
    setOverlay("help");
  }, 1800);
}

const ACCESS_LASSU_MS = 8000;
const ACCESS_IDOKORLAT_MS = 40000;
let hozzaferesEllenorzesSorszam = 0;

// ----------------------------------------------------------------------
// Firebase Auth állapotfigyelés + redirect-eredmény feldolgozása
// ----------------------------------------------------------------------
consumeRedirectResult()
  .then((result) => {
    // Diagnosztikai napló: ha valaki redirectből tér vissza, de ez
    // null-t ad hibaüzenet NÉLKÜL, az jellemzően azt jelenti, hogy a
    // böngésző (pl. inkognitó mód, harmadik féltől származó tárolás
    // korlátozása) elvesztette a bejelentkezési állapotot útközben -
    // ez NEM Firebase-hiba, a konzolban ez segít megkülönböztetni a
    // "tényleg nincs bejelentkezve" esettől.
    log.debug("[auth] consumeRedirectResult() eredmény:", result ? `user=${result.user?.email}` : "null (nincs feldolgozható redirect-eredmény)");
  })
  .catch((err) => {
    log.error("[auth] consumeRedirectResult() hiba:", err.code || err.message, err);
    state.authDiag = hibaKod(KODOK.LOGIN_REDIRECT_ERROR, err && err.code);
    setError("login.errorFailed");
  });

watchAuthState(async (user) => {
  log.debug("[auth] onAuthStateChanged:", user ? user.email : "nincs bejelentkezve");
  // v182 ("emlékezz erre az eszközre"): a megjegyzett e-mail a Google login_hint-hez, és a munkamenet-elvesztés mérése (belepesEmlekezet.js).
  if (hitelesitesValtozott(user, hatalyosMod(), Date.now(), window) === "elveszett") log.debug("[auth] a munkamenet elveszett (volt belépés, a tag nem lépett ki)");
  setUser(user);

  if (!user) {
    // --- Némán elbukott az átirányításos bejelentkezés?
    //
    // FONTOS, VALÓS HIBÁBÓL TANULVA: Safariban (és minden iPhone-os
    // böngészőben) a szigorú tárolás-szétválasztás miatt a felhasználó
    // végigmegy a Google-bejelentkezésen, visszatér - és NEM TÖRTÉNIK
    // SEMMI. Nincs hibaüzenet, mert a Firebase szemszögéből a böngésző
    // egyszerűen nem adott vissza semmit; a felhasználó a belépő
    // képernyőn ragad, és hiába próbálja újra, mindig ugyanoda jut.
    //
    // Ezt az állapotot ismerjük fel itt: nemrég indult átirányítás
    // (sessionStorage-jel), mégsincs bejelentkezett felhasználó.
    // Ilyenkor az eszközre megjegyezzük, hogy a felugró ablakos út kell,
    // és a következő próbálkozás már azon megy.
    const nemaKudarc = redirectSilentlyFailed(false);
    if (nemaKudarc) {
      log.error("[auth] az átirányításos bejelentkezés némán elbukott - átállás felugró ablakra");
      rememberPopupNeeded();
      clearRedirectMarker();
    }
    // Kijelentkezve a KEZDŐ FOLYAMAT (2026-10-13): kezdőképernyő (nyelv + logó) -> üdvözlő szöveg -> Google-belépés.
    // A néma kudarc (visszatérés bejelentkezés nélkül) a belépő képernyőre visz, hibaüzenettel; ha a felhasználó már a
    // folyamat valamelyik lépésén áll (lang / welcome / login), ott marad; minden más helyről (betöltés, kijelentkezés)
    // a kezdőképernyőre kerül.
    // A jelentkezési oldalról (#/jelentkezes) érkezőt nem a kezdő folyamat (nyelv / üdvözlés), hanem a jelentkezési bemutató fogadja (v191).
    if (nemaKudarc) setScreen("login");
    else if (jelentkezesUtvonal) setScreen("apply");
    else if (state.screen !== "lang" && state.screen !== "welcome" && state.screen !== "login") setScreen("lang");
    // A hibaüzenet CSAK a képernyőváltás UTÁN állítható be: a setScreen
    // szándékosan törli a korábbi hibát, tehát előtte beállítva azonnal
    // elveszne, és a felhasználó megint csak egy néma belépő képernyőt
    // látna - pontosan azt, amit el akarunk kerülni.
    if (nemaKudarc) { state.authDiag = hibaKod(KODOK.LOGIN_REDIRECT_SILENT); setError("login.errorRedirectFailed"); }
    return;
  }

  clearTimeout(loginFeloldoIdozito); // megvan a felhasználó: a beragadás-őr már nem kell
  // Sikeres bejelentkezés: a jel már nem kell, és ha eddig felugró
  // ablakot használtunk, most sem árt megtartani - a beállítást csak
  // akkor töröljük, ha az ÁTIRÁNYÍTÁS bizonyult működőnek.
  clearRedirectMarker();

  if (!user.email) {
    state.authDiag = hibaKod(KODOK.LOGIN_NO_EMAIL);
    setError("login.errorNoEmail");
    await signOut();
    setUser(null);
    setScreen("login");
    return;
  }

  if (!user.emailVerified) {
    state.authDiag = hibaKod(KODOK.LOGIN_NOT_VERIFIED);
    setError("login.errorNotVerified");
    await signOut();
    setUser(null);
    setScreen("login");
    return;
  }

  await checkAccess(user);
});

// Ha a böngésző jelzi, hogy az alkalmazás telepíthetővé vált (vagy éppen
// települt), rendereljünk újra, hogy a telepítési sáv megjelenjen/eltűnjön.
onInstallAvailabilityChange(() => render());
// Offline sáv (offlineSav.js): kapcsolat nélkül, bekapcsolt offline-kezelővel jelzi, hogy mentett tartalom látszik, és mikor volt az utolsó szerver-egyeztetés.
const offlineSav = offlineSavInditasa({ kezelo: offline, nyelv: () => state.uiLang });
subscribe(() => offlineSav.frissit());
// A közös eszközre váltás tárolótörlésének eredménye (ok / blokkolt / hiba) a belépő képernyőn látszik: az esemény újrarajzolást kér.
window.addEventListener(ESZKOZ_TORLES_ESEMENY, () => render());

// Kapcsolat visszatértekor a mentett (offline) jogosultságot ELŐBB ellenőrizzük (docs/OFFLINE_TERV_2026-10-22.md, 8. fejezet): ha a tag időközben
// megszűnt (inaktív lett), a mentett offline tartalma törlődik, és a program nem jeleníti meg tovább. A figyelők maguk újrakapcsolódnak.
let hozzaferesUjraEllenorzesFolyamatban = false;
async function hozzaferesUjraEllenorzese() {
  if (hozzaferesUjraEllenorzesFolyamatban || !state.user || state.screen !== "active" || !offline.allapot().engedett) return;
  hozzaferesUjraEllenorzesFolyamatban = true;
  try {
    const access = await getMyAccess(state.user.uid);
    if (!hozzaferesAktiv(access)) {
      setAccess(access);
      await offlineLeallit().catch(() => {});
      setScreen("access-pending");
    }
  } catch (err) {
    /* még nincs valódi kapcsolat: a következő "online" esemény újra próbálja */
  } finally {
    hozzaferesUjraEllenorzesFolyamatban = false;
  }
}
window.addEventListener("online", () => { hozzaferesUjraEllenorzese(); });

// Lusta nyelvbetöltés (v126): a mentett felületi nyelv szövegeit megvárjuk az első rendernél (legfeljebb 1,5 mp-ig: lassú hálózaton inkább az angol
// tartalék látszik, mint az üres képernyő); utána minden újonnan megérkező nyelv (pl. a csevegési nyelv feliratai) újrarajzolást kér.
onNyelvBetoltve(() => render());
// Első render a nyelv megérkezése után (de legfeljebb 1,5 mp-et várva), még mielőtt bármilyen Firebase-válasz megérkezne -
// így a nyelvválasztó vagy a belépő képernyő rögtön látszik, a mentett nyelven.
Promise.race([ensureUiLang(state.uiLang), new Promise((kesz) => setTimeout(kesz, 1500))]).then(() => render());

// Nem éles (dev/teszt) változaton jól látható jelzés; éles változaton nincs.
renderEnvBanner();

// ----------------------------------------------------------------------
// Service worker regisztráció (offline app-héj, PWA telepíthetőség).
// Fontos: ez csak a statikus fájlokat cache-eli, lásd service-worker.js
// megjegyzését a hitelesítési útvonalak kihagyásáról.
// ----------------------------------------------------------------------
// A tesztváltozaton (dev) indításkor - CSAK ha a program verziója változott
// a legutóbbi óta - előbb kiürítjük a gyorsítótárat, és csak utána
// regisztrálunk service workert, hogy a friss worker már üres tárral
// induljon. Ha a verzió nem változott, a törlés kimarad (nincs rá szükség).
// Élesen a törlés egyáltalán nem fut, a regisztráció ugyanúgy megtörténik,
// mint eddig.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    clearCachesOnVersionChange().then(() => {
      // Dev: a böngésző se használja a service-worker.js saját, korábbi
      // példányát a HTTP-gyorsítótárból (updateViaCache: "none").
      const options = IS_PROD ? undefined : { updateViaCache: "none" };
      return navigator.serviceWorker.register("./service-worker.js", options);
    }).catch((err) => {
      log.error("Service worker regisztráció sikertelen:", err);
    });
  });
}

// --- Új verzió megérkezett, de a felhasználó épp dolgozik
let updateVar = false;

/** Újratöltés, ha épp semmi nem veszne el vele. */
function maybeApplyUpdate() {
  if (!updateVar) return;
  if (state.sending || state.pendingImage) return;
  if ((state.draft || "").trim().length > 0) return;
  // A MÁS szobákban félretett piszkozat, kép vagy félbemaradt küldés is csak
  // a memóriában él - egy újratöltés elvinné. (AUDIT: a szobánkénti
  // piszkozat bevezetésekor ez az ellenőrzés kimaradt.)
  if (szobaAllapotok.size > 0) return;
  applyUpdate();
}

// Automatikus frissítésfigyelés: új verzió telepítése után a felhasználó
// nem ragad be a régi kódban akkor sem, ha napokig nyitva tartja a lapot.
// Lásd updater.js a részletes magyarázatért.
//
// A frissítés NEM szakíthatja félbe a munkát: ha épp gépel, kép van
// előkészítve vagy küldés/feltöltés fut, az újratöltés megvárja a
// nyugodt pillanatot. Enélkül egy kiadás a be nem küldött piszkozatot és
// a félig feltöltött képet is elvinné.
startUpdateWatcher(() => {
  updateVar = true;
  maybeApplyUpdate();
});

// --- A push-értesítés ÁTVÉTELE (2026-10-13): a szerver csak az első változásról szól, utána csend a következő belépésig;
// belépéskor / előtérbe kerüléskor a jelvény törlődik, és (ha volt értesítés) a szerver is megtudja, hogy a tag látja
// az újdonságokat. Az újdonságokat az élő figyelők magától lekérdezik és frissítik.
let utolsoErzekelt = 0;
function pushAtveteleHaKell(kenyszeritett = false) {
  if (!state.user) return Promise.resolve(false);
  const most = Date.now();
  if (kenyszeritett && most - utolsoErzekelt < 30000) return Promise.resolve(false); // előtérben érkező üzenetek: legfeljebb 30 mp-enként
  if (kenyszeritett) utolsoErzekelt = most;
  return pushAtvetel({ atvetelFn: () => forumAction({ action: "ackPush" }), kenyszeritett, most }).catch(() => false);
}

// --- Az olvasatlan jelvény törlése, amint a felhasználó visszatér és
// ténylegesen látja a beszélgetést.
document.addEventListener("visibilitychange", () => {
  if (!document.hidden && state.screen === "active" && state.currentRoomId) {
    clearUnread();
  }
  if (!document.hidden) maybeApplyUpdate();
  if (!document.hidden) retryInterruptedSend();
  if (!document.hidden) szobaOlvasottsagFrissitese(); // v186: a másik eszközön olvasott szoba itt is olvasott
  if (!document.hidden) pushAtveteleHaKell(); // az alkalmazás ikonjának jelzése törlődik; ha volt értesítés, átvétel
  // A láthatóság változása eldönti, hogy a worker kérjen-e értesítést:
  // háttérbe tett lapnál igen, előtérben lévőnél (a nézett szobára) nem.
  reportCurrentRoomToSW();
  // Háttérben érkezett üzenet: most már látja - olvasott (olvasatlan.js).
  if (!document.hidden) latottSzobaFrissitese();
});
window.addEventListener("focus", () => {
  if (state.screen === "active" && state.currentRoomId) {
    clearUnread();
    latottSzobaFrissitese();
  }
  reportCurrentRoomToSW();
  retryInterruptedSend();
});
window.addEventListener("blur", reportCurrentRoomToSW);

// --- A service worker üzenetei (push érkezett, vagy értesítésre kattintottak)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    const data = event.data || {};

    if (data.type === "OPEN_ROOM" && data.roomId) {
      // Az értesítésre kattintva a megfelelő szobát nyitjuk meg.
      if (data.roomId !== state.currentRoomId) {
        const letezik = state.rooms.some((r) => r.roomId === data.roomId);
        if (letezik) openRoom(data.roomId);
      }
      clearUnread();
      return;
    }

    // Push érkezett, miközben az alkalmazás nyitva van.
    //
    // FONTOS, VALÓS HIBÁBÓL TANULVA: ezt az üzenetet a worker eddig is
    // elküldte, de SENKI nem dolgozta fel - így egy MÁSIK szobába érkező
    // üzenetről a nyitott felületen semmilyen jelzés nem jelent meg (az
    // üzenetfigyelő csak az épp megnyitott szobát követi).
    //
    // Csak a más szobába érkező üzenetet számoljuk itt: a jelenleg nyitott
    // szobáét az üzenetfigyelő (handleIncomingMessage) kezeli, különben
    // kétszer számolnánk ugyanazt.
    // Előtérben érkező üzenet (a tag az alkalmazásban van): az értesítés átvéve - különben a szerver a háttérbe tett alkalmazásnál
    // is hallgatna ("csak az első változásról szól", a következő belépésig).
    if (data.type === "NEW_MESSAGE" && !document.hidden) pushAtveteleHaKell(true);
    if (data.type === "NEW_MESSAGE" && data.roomId && data.roomId !== state.currentRoomId) {
      incrementUnread();
    }
  });
}

